<template>
	<b-overlay :show="stillLoadingBlocks" rounded opacity="0.6" :spinner-small="false" z-index="99999" spinner-variant="primary" :no-center="true" :fixed="true">
		<template v-slot:overlay>
			<div class="b-overlay__wrapper">
				<div class="d-flex align-items-center">
					<div clsas="b-overlay__spinner"><b-spinner variant="primary"></b-spinner></div>
					<div class="flex-grow-1 b-overlay__message">Loading street blocks, please wait...</div>
				</div>
			</div>
		</template>
		<Spinner v-if="checkingConflicts" />
		<b-container id="laneclosure-add-container" class="laneclosure-add-container" v-if="laneClosureRequest != null && loaded">
			<div class="new-content-page-title" v-if="$store.state.isMobile">
				New Violation
			</div>
			<b-form v-show="submitted">
				<h1 class="pt-2">Violation Submitted</h1>
				<b-row>
					<b-col class="pb-3">
						<h2>Thank you for your violation submission.</h2>
						<b-button variant="secondary" type="button" class="btn-sm mr-2" @click="onViewLaneClosureRequest">View Lane Closure Request</b-button>
						<b-button variant="secondary" type="button" class="btn-sm" @click="onBackToContraventions">List All Violations</b-button>
					</b-col>
				</b-row>
			</b-form>

			<b-form @submit="onSubmit" @reset="onReset" v-show="!submitted">
				<form-wizard title="" icon="" id="add-lcr-wizard" ref="lcrWizard" subtitle="" @on-change="onWizardStep" :start-index="getStartIndex" @on-complete="onSubmit" color="#233360" background-color="orange" @on-validate="onWizardValidation" @on-error="handleWizardErrorMessage">
					<tab-content title="Violation" :before-change="validateContraventionStepAsync">
						<b-row v-if="!$store.state.isMobile">
							<b-col>
								<h1>New Violation</h1>
							</b-col>
						</b-row>
						<b-row v-show="canReportContravention">
							<b-col sm="12" class="mb-3">
								<div class="lcr-summary__label">Enforcement Officer</div>
								<div v-if="contravention.officer" class="contact">
									<div class="contact__name">{{contravention.officer.firstName}} {{contravention.officer.lastName}}</div>
									<div class="contact__organization">{{contravention.officer.organizationName}}</div>
									<div class="contact__phone">{{contravention.officer.phone}}</div>
								</div>
								<autocomplete data-position="above" :search="onOfficerSearch" @submit="onOfficerSelect" placeholder="Start typing to select Enforcement Officer" aria-label="Start typing to select Enforcement Officer" ref="searchOfficer" auto-select>
									<template v-slot:result=" {result, props } ">
										<li v-bind="props" class="autocomplete-result primary-contact-result">
											<div class="contact-name">{{result.firstName}} {{result.lastName}} {{result.isActive ? '' : '(inactive)'}}</div>
											<div class="contact-organization">{{result.organizationName}}</div>
											<div class="contact-phone">{{result.phone}}</div>
										</li>
									</template>
								</autocomplete>
							</b-col>
							<b-col sm="12" class="mb-3">
								<div class="lcr-summary__label">Violation Type</div>
								<div class="lcr-summary__value">
									<b-form-select v-model="contravention.typeId.value" :options="Contravention.getContraventionTypeIdOptions" @input="contravention.typeId.resetStatus()" :state="contravention.typeId.status" value-field="id" text-field="name"></b-form-select>
								</div>
							</b-col>
							<b-col sm="12" class="mb-3">
								<div class="lcr-summary__label">Violation / Infraction Details</div>
								<wysiwyg v-model="contravention.comments.value"></wysiwyg>
							</b-col>
							<b-col sm="12">
								<div class="lcr-summary__label">Attachments</div>
								<p>Upload any related photos and documents related to the violation and/or infractions.</p>
								<div class="attachment__uploader">
									<file-pond credits="false" name="attachment" ref="pondContravention" label-idle="<span class='filepond--label-action'>Select files</span>" v-bind:allow-multiple="true" accepted-file-types="image/jpeg, image/png, application/pdf, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel,application/msexcel,application/x-msexcel,application/x-ms-excel,application/x-excel,application/x-dos_ms_excel,application/xls,application/x-xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-powerpoint" v-on:init="handleFilePondContraventionInit" v-on:addfile="handleFilePondContraventionAddFile" v-on:processfile="handleFilePondContraventionProcessFile">
									</file-pond>
								</div>
							</b-col>
							<b-col sm="12">
								<attachments-list lg="3"  :sourceId="null" a:sourceTable="'contravention_attachment'"  v-model="contravention" :downloadToken="downloadToken" :downloadTokenExpires="downloadTokenExpires" ref="refContraventionAttachments"></attachments-list>
							</b-col>
						</b-row>
					</tab-content>
					<tab-content title="Submitter" :before-change="validateSubmitterStepAsync">
						<b-row>
							<b-col lg="6">
								<h1>New Violation</h1>
								<b-form-group label="Is this closure an emergency?" :state="laneClosureRequest.isEmergency.status" :invalid-feedback="laneClosureRequest.isEmergency.invalidMessage">
									<b-form-radio-group id="rg-is-emergency" v-model="laneClosureRequest.isEmergency.value" :options="LaneClosureRequest.getYesNoOptions" @change="laneClosureRequest.isEmergency.resetStatus()" :state="laneClosureRequest.isEmergency.status" value-field="id" text-field="name" inline></b-form-radio-group>
									<p>In emergency situations that threaten public safety or are a public hazard, the Construction Agency responsible for the work performed is authorized to eliminate the public hazard immediately. <strong>You must describe the nature of the emergency in the comments section.</strong><br/><br><strong>ABUSE OF EMERGENCY APPROVAL WILL RESULT IN IMMEDIATE STOP WORK ORDERS AND/OR FINES.</strong></p>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row>
							<b-col lg="6">
								<b-form-group label="Primary Reason for Closure" :state="laneClosureRequest.natureOfWorkId.status" :invalid-feedback="laneClosureRequest.natureOfWorkId.invalidMessage" description="Please choose the most appropriate answer.">
									<b-form-select v-model="laneClosureRequest.natureOfWorkId.value" :options="LaneClosureRequest.getNatureOfWorkOptions" @input="laneClosureRequest.natureOfWorkId.resetStatus()" :state="laneClosureRequest.natureOfWorkId.status" value-field="id" text-field="name" @change="laneClosureRequest.natureOfWorkId.setDirty();updateTrafficEffect();"></b-form-select>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row>
							<b-col lg="6">
								<b-form-group id="ig-affected-streets" label="Primary Street Affected" label-for="input-lcr-affected-streets-1" description="" :state="laneClosureRequest.affectedStreet.status" :invalid-feedback="laneClosureRequest.affectedStreet.invalidMessage">
									<p>Select the primary street affected by the lane closures/restriction</p>
									<multiselect
									class="custom-multiselect"
									ref="affectedStreetFilterAdd"
									v-model="affectedStreetText"
									track-by="id"
									open-direction="bottom"
									label="label"
									:options="affectedStreetOptions"
									:show-labels="false"
									:multiple="false"
									:close-on-select="true"
									:hide-selected="false"
									:preserve-search="false"
									:clear-on-select="false"
									:internal-search="false"
									placeholder="Select or start typing"
									:loading="isAffectedStreetsLoading"
									@search-change="onAffectedStreetSearch"
									@input="onAffectedStreetInput"
									>
									<template slot="selection" slot-scope="{ values, search, isOpen }">
										<span
										class="multiselect__single"
										v-if="values.length && !isOpen"
										v-html="getOptionSelected(values.length)"
										></span>

									</template>
									<template slot="option" slot-scope="props">
										<div class="option__desc">
											<span class="option__title">{{ props.option.label }}</span><br>
										</div>
									</template>
									<template slot="noOptions">
									</template>
									<template slot="afterList">
										<li class="multiselect__after-list">Start typing to find streets.</li>
									</template>

									<template slot="noResult">
										No results. Please try changing the search query.
									</template>
								</multiselect>
							</b-form-group>

							<b-form-group id="ig-direction-1" label="Direction(s) of Travel" label-for="input-lcr-direction-of-travel-1" description="" :state="laneClosureRequest.directionId.status" :invalid-feedback="laneClosureRequest.directionId.invalidMessage">
								<b-form-select v-model="laneClosureRequest.directionId.value" id="input-lcr-direction-of-travel-1" :options="LaneClosureRequest.getDirectionIdOptions" @input="laneClosureRequest.directionId.resetStatus()" :state="laneClosureRequest.directionId.status" value-field="id" text-field="name" @change="laneClosureRequest.directionId.setDirty();loadBlocks();"></b-form-select>
							</b-form-group>

							<b-form-group id="ig-first-cross" label="First Cross Street (starting in the direction of travel)" label-for="input-first-cross-1" description="1st intersecting street with the Primary Street Affected to indicate the beginning of the block." :state="laneClosureRequest.firstCrossStreet.status" :invalid-feedback="laneClosureRequest.firstCrossStreet.invalidMessage">
								<b-form-select id="input-first-cross-1" v-model="laneClosureRequest.firstCrossStreet.value" @input="laneClosureRequest.firstCrossStreet.resetStatus()" :state="laneClosureRequest.firstCrossStreet.status" :options="firstCrossStreetOptions" @change="laneClosureRequest.firstCrossStreet.setDirty(); loadBlocks()"></b-form-select>
							</b-form-group>
							<b-form-group id="ig-last-cross" label="Last Cross Street  (ending in the direction of travel)" label-for="input-last-cross-1" description="Last intersecting street with the Primary Street Affected to indicate the ending of all affected block(s)." :state="laneClosureRequest.lastCrossStreet.status" :invalid-feedback="laneClosureRequest.lastCrossStreet.invalidMessage">
								<b-form-select id="input-last-cross-1" v-model="laneClosureRequest.lastCrossStreet.value" @input="laneClosureRequest.lastCrossStreet.resetStatus()" :state="laneClosureRequest.lastCrossStreet.status" :options="firstCrossStreetOptions" @change="laneClosureRequest.lastCrossStreet.setDirty(); loadBlocks()"></b-form-select>
							</b-form-group>
							<b-row v-if="laneClosureRequest">
								<b-col md>
									<b-form-group :label="confirmBlocksLabel" :state="validateConfirmedBlocks.status" :invalid-feedback="validateConfirmedBlocks.invalidMessage">
									<b-row>
										<b-col style="max-width:100px;">
									<div class="show-on-map-wrapper loading-blocks-wrapper">
										<b-spinner v-if="loadingBlocks" small label="Loading Map" class="ml-2" style="position: absolute; z-index: 1; top: 20px; left: 8px; color: #293C7C;"></b-spinner>
										<a class="show-on-map text-left" @click="showOnMap">
											<span v-if="hideMap" class="on-container">
												<img class="on-badge responsive-img" src="@/assets/map-badge-hide.svg" alt="on-badge" />
												<img class="on-map responsive-img" src="@/assets/hide-map.svg" alt="on-map" />
											</span>
											<span v-else class="on-container">
												<img class="on-badge responsive-img" src="@/assets/map-badge.svg" alt="on-badge" />
												<img class="on-map responsive-img" src="@/assets/show-on-map.svg" alt="on-map" />
											</span>
										</a>
									</div>
									</b-col>
									<b-col sm="auto" lg="auto" class="pt-3">
										<b-form-checkbox :checked="validateConfirmedBlocks.value == 1" v-model="validateConfirmedBlocks.value" key="`confirmedBlocksCheckbox`+renderCounter" :unchecked-value="0" :value="1" name="confirmedBlocksCheckbox"><span>I confirm that the affected street blocks on the map are accurate.</span></b-form-checkbox>
									</b-col>
									</b-row>
									</b-form-group>
								</b-col>
							</b-row>
						</b-col>
					</b-row>
					<b-row class="row--with-top-border pt-3">
						<b-col>
							<h2>Authorized Construction Agency</h2>
						</b-col>
					</b-row>
					<b-row class="row--with-top-border pt-3">
						<b-col lg="6">
							<p>A Construction Agency can request designation as an Authorized Construction Agency from the Traffic Management Branch. As an Authorized Construction Agency, they can perform many of the tasks previously required to be completed by the Traffic Services Branch, including installing Turn restriction signage, No Parking signage and Designated Construction Zones (Reduction of speed on high speed roadways).</p>
							<p>
							If you are hiring a private company to perform any services for you please mention the name of the company in the comments section.
							</p>
							<p>Please be aware that Traffic Management will require traffic plans for full or directional closures of Regional streets, DCZ's or other situations as requested by Traffic Management for review before approval.
							</p>
							<b-form-group label="I wish to act as an Authorized Construction Agency (ACA)" :state="laneClosureRequest.actAsAca.status" :invalid-feedback="laneClosureRequest.actAsAca.invalidMessage" id="fg-act-as-aca" class="fg-act-as-aca">
								<b-form-radio-group id="rg-act-as-aca" v-model="laneClosureRequest.actAsAca.value" :options="LaneClosureRequest.getYesNoOptions" @change="laneClosureRequest.actAsAca.resetStatus(); laneClosureRequest.actAsAca.setDirty();" :state="laneClosureRequest.actAsAca.status" value-field="id" text-field="name">
								</b-form-radio-group>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row v-if="laneClosureRequest" v-show="laneClosureRequest.actAsAca.value == '1'">
						<b-col md  lg="6">
							<b-row>
								<b-col>
									<b-form-group label="How do you want to act as an ACA?" :state="acaChoices.status" :invalid-feedback="acaChoices.invalidMessage">
										<b-form-checkbox @change="acaChoices.resetStatus();" :checked="laneClosureRequest.acaParkingRemoval.value == 1" v-model="laneClosureRequest.acaParkingRemoval.value" key="acaParkingRemoval" :unchecked-value="0" :value="1" name="acaParkingRemoval"><span><strong>Parking Removal</strong> - I have my own no stopping signs or I will hire a private company to remove the parking. Please note if you require City of Winnipeg Traffic Services to remove the parking do NOT choose this option.</span></b-form-checkbox>
										<b-form-checkbox @change="acaChoices.resetStatus();" :checked="laneClosureRequest.acaTurnRestrictions.value == 1" v-model="laneClosureRequest.acaTurnRestrictions.value" key="acaTurnRestrictions" :unchecked-value="0" :value="1" name="acaTurnRestrictions"><span><strong>Turn Restrictions</strong> - I have my own turn restriction signs or I will hire a private company to install them for me.</span></b-form-checkbox>
										<b-form-checkbox @change="acaChoices.resetStatus();" :checked="laneClosureRequest.acaFullDirectional.value == 1" v-model="laneClosureRequest.acaFullDirectional.value" key="acaFullDirectional" :unchecked-value="0" :value="1" name="acaFullDirectional"><span><strong>Full or Directional Closure of a Regional Street</strong> - I intend to close one or both directions of travel on a Regional street and I will provide my own signage or I will hire a private company to do this for me.</span></b-form-checkbox>
										<b-form-checkbox @change="acaChoices.resetStatus();" :checked="laneClosureRequest.acaDcz.value == 1" v-model="laneClosureRequest.acaDcz.value" key="acaDcz" :unchecked-value="0" :value="1" name="acaDcz"><span><strong>Designated Construction Zone (DCZ)</strong> - I wish to install a DCZ with a speed reduction and I have my own signs or I will hire a private company to do this for me.</span></b-form-checkbox>
									</b-form-group>
								</b-col>
							</b-row>
						</b-col>
					</b-row>




					<b-row class="row--with-top-border pt-3">
						<b-col>
							<h2>Requested Dates</h2>
						</b-col>
					</b-row>
					<b-row class="row--with-top-border pt-3">
						<b-col lg="6">
							<b-form-group label="Will this closure take less than 2 hours?" :state="laneClosureRequest.isUnderTwoHours.status" :invalid-feedback="laneClosureRequest.isUnderTwoHours.invalidMessage" id="fg-less-than-two-hour" class="fg-less-than-two-hour">
								<b-form-radio-group id="rg-less-than-two-hour" v-model="laneClosureRequest.isUnderTwoHours.value" :options="LaneClosureRequest.getYesNoOptions" @change="laneClosureRequest.isUnderTwoHours.resetStatus(); laneClosureRequest.isUnderTwoHours.setDirty();" :state="laneClosureRequest.isUnderTwoHours.status" value-field="id" text-field="name">
								</b-form-radio-group>
								<p><strong>NOTE: 2 HOUR OR LESS CLOSURES CANNOT OCCUR DURING OR EXTEND INTO PEAK PERIODS (07:00-09:00 & 15:00-18:00) and can only involve the closure of a single lane.</strong><br />When work will take less than 2 hours of TOTAL TIME, the system will automatically approve the request. If however, there is existing work in the area or any other conflicts work cannot proceed. This only applies to a single day.</p>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col lg="6">
							<p>Please enter the requested start date and time you wish to close the lane(s).</p>
							<p>Please be aware that our priority is to not close lanes for rush hours (07:00-09:00 & 15:00-18:00) whenever possible on weekdays.</p>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="12">
							<b-row>
								<b-col sm="12" lg="6">
									<b-form-group id="ig-equest-start-date" label="Requested Start Date" label-for="input-equest-start-date" :state="laneClosureRequest.fromDate.status" :invalid-feedback="laneClosureRequest.fromDate.invalidMessage">
										<date-picker bootstrap-styling id="input-request-start-date" format="MM/dd/yyyy" v-model="fromDatePicker" :key="fromDatePickerKey" :input-class="{'is-invalid': laneClosureRequest.fromDate.status == false}" @input="laneClosureRequest.fromDate.resetStatus(); checkLessThanTwoHours(); hasShownStartDateInPastModal = false; laneClosureRequest.fromDate.setDirty();" :typeable="true" :placeholder="'mm/dd/yyyy'"></date-picker>
									</b-form-group>
								</b-col>
								<b-col sm="12" lg="6">
									<b-form-group id="ig-request-start-time" label="Requested Start Time" label-for="input-request-start-time" :state="laneClosureRequest.fromTime.status" :invalid-feedback="laneClosureRequest.fromTime.invalidMessage">
										<bootstrap-text-time-picker ref="refTimeFrom" v-model="fromTime.value" v-on:update:time="onFromDateTimeChanged"></bootstrap-text-time-picker>
									</b-form-group>
								</b-col>
							</b-row>
						</b-col>
						<b-col sm="12">
							<b-row>
								<b-col sm="12" lg="6">
									<b-form-group id="ig-eta-end-date" label="Estimated Completion Date" label-for="input-eta-end-date" :state="laneClosureRequest.toDate.status" :invalid-feedback="laneClosureRequest.toDate.invalidMessage">
										<!-- <b-form-input id="input-eta-end-date" type="text" v-model="laneClosureRequest.toDate"></b-form-input> -->
										<date-picker bootstrap-styling id="input-eta-end-date" format="MM/dd/yyyy" v-model="toDatePicker" :disabled-dates="disableEndDate" :key="toDatePickerKey" :input-class="{'is-invalid': laneClosureRequest.toDate.status == false}" @input="laneClosureRequest.toDate.resetStatus(); hasShownStartDateInPastModal = false; checkLessThanTwoHours();" :typeable="true" :placeholder="'mm/dd/yyyy'"></date-picker>
									</b-form-group>
								</b-col>
								<b-col sm="12" lg="6">
									<b-form-group id="ig-eta-end-time" label="Estimated Completion Time" label-for="input-eta-end-time" :state="laneClosureRequest.toTime.status" :invalid-feedback="laneClosureRequest.toTime.invalidMessage">
										<bootstrap-text-time-picker ref="refTimeTo" v-model="toTime.value"></bootstrap-text-time-picker>
									</b-form-group>
								</b-col>
							</b-row>
						</b-col>
					</b-row>
					{{/* ======================== REQUESTERS AND REPORTERS ======================== */}}
					<b-row>
						<b-col lg="6">
							<b-form-group id="ig-primary-contact" label="Requester" label-for="input-lcr-primary-contact" description="" :state="selectRequester.status" :invalid-feedback="selectRequester.invalidMessage">
								<p>Who within your company is requesting this lane closure?</p>
								<div v-if="laneClosureRequest.requester" class="contact mb-3">
									<div class="contact__name">{{laneClosureRequest.requester.firstName}} {{laneClosureRequest.requester.lastName}}</div>
									<template v-for="(org, i) in getOrganizationTreeList(laneClosureRequest.requester)">
										<div class="contact__organization" :key="i">{{org}}</div>
									</template>
									<div class="contact__phone">{{laneClosureRequest.requester.phone}}</div>
								</div>
								<autocomplete data-position="above" :search="onRequesterSearch" @submit="onRequesterSelect" @keydown="onRequesterKeydown" placeholder="Start typing to select Primary Requester" aria-label="Start typing to select Primary Requester" ref="searchRequester" auto-select>
									<template v-slot:result=" {result, props } ">
										<li v-bind="props" class="autocomplete-result primary-contact-result">
											<div class="contact-name">{{result.firstName}} {{result.lastName}} {{result.isActive ? '' : '(inactive)'}}</div>
											<template v-for="(org, i) in getOrganizationTreeList(result)">
												<div :key="i" class="contact-organization">{{org}}</div>
											</template>
											<div class="contact-phone">{{result.phone}}</div>
										</li>
									</template>
								</autocomplete>
							</b-form-group>
						</b-col>
						<b-col lg="6">
							<b-form-group id="ig-alternate-contact" label="Alternate Requester(s)" label-for="input-lcr-alternate-contact" description="">
								<p>Who else can be contacted if the primary requester is unavailable?</p>
								<div v-if="laneClosureRequest.altRequester.length > 0" class="contact-container">
									<b-form-row v-for=" (contact, index) in laneClosureRequest.altRequester" class="contact" v-bind:key="'c'+contact.userId">
										<b-col cols="8">
											<div class="contact__name">{{contact.firstName}} {{contact.lastName}}</div>
											<template v-for="(org, i) in getOrganizationTreeList(contact)">
												<div class="contact__organization" :key="i">{{org}}</div>
											</template>
											<div class="contact__phone">{{contact.phone}}</div>
										</b-col>
										<b-col cols="4" class="text-right ">
											<b-button variant="secondary" type="button" class="btn-sm mt-3" @click="onRemoveAltRequester(index)">Remove</b-button>
										</b-col>
									</b-form-row>
								</div>
								<autocomplete data-position="above" :search="onAltRequesterSearch" @submit="onAltRequesterSelect" @keydown="onAltRequesterKeydown" placeholder="Start typing to select alternate requester" aria-label="Start typing to select alternate requester" ref="searchAltRequester" auto-select>
									<template v-slot:result=" {result, props } ">
										<li v-bind="props" class="autocomplete-result alternate-contact-result">
											<div class="autocomplete__name">{{result.firstName}} {{result.lastName}} {{result.isActive ? '' : '(inactive)'}}</div>
											<template v-for="(org, i) in getOrganizationTreeList(result)">
												<div v-if="org" :key="i" class="contact-organization">{{org}}</div>
											</template>
											<div v-if="result.phone" class="autocomplete__phone">{{result.phone}}</div>
										</li>
									</template>
								</autocomplete>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col lg="6">
							<b-form-group id="ig-last-cross" :label="projectLabel" label-for="input-requester-project" :state="laneClosureRequest.requesterProjectId.status" :invalid-feedback="laneClosureRequest.requesterProjectId.invalidMessage">
								<p>You can create or assign a project to this lane closure request.</p>
								<b-input-group>
									<b-form-select id="input-requester-project" v-model="laneClosureRequest.requesterProjectId.value" @input="projectSelectChanged" :state="laneClosureRequest.requesterProjectId.status" :options="requesterProjectIdOptions" value-field="id" text-field="displayName" inline></b-form-select>
									<b-input-group-append>
										<b-button inline variant="primary" type="button" class="btn-sm" @click="openEditProjectModal()" v-if="laneClosureRequest.requesterProjectId.value > 0">Edit</b-button>
										<b-button inline variant="primary" type="button" class="btn-sm" @click="openNewProjectModal()" v-else><font-awesome-icon icon="plus-circle" /></b-button>
									</b-input-group-append>
								</b-input-group>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row v-if="false">
						<b-col lg="6">
							<b-form-group id="ig-primary-reporter" label="Lane Closure Reporter" label-for="input-lcr-primary-reporter" description="" :state="selectClosureReporter.status" :invalid-feedback="selectClosureReporter.invalidMessage">
								<p>Who will be reporting the lanes as closed/re-opened?</p>
								<div v-if="laneClosureRequest.closureReporter" class="contact mb-3">
									<div class="contact__name">{{laneClosureRequest.closureReporter.firstName}} {{laneClosureRequest.closureReporter.lastName}}</div>
									<template v-for="(org, i) in getOrganizationTreeList(laneClosureRequest.closureReporter)">
										<div class="contact__organization" :key="i">{{org}}</div>
									</template>
									<div class="contact__phone">{{laneClosureRequest.closureReporter.phone}}</div>
								</div>
								<autocomplete data-position="above" :search="onClosureReporterSearch" @submit="onClosureReporterSelect" @keydown="onClosureReporterKeydown" placeholder="Start typing to select Primary Reporter" aria-label="Start typing to select Primary Reporter" ref="searchClosureReporter" auto-select>
									<template v-slot:result=" {result, props } ">
										<li v-bind="props" class="autocomplete-result primary-contact-result">
											<div class="contact-name">{{result.firstName}} {{result.lastName}} {{result.isActive ? '' : '(inactive)'}}</div>
											<template v-for="(org, i) in getOrganizationTreeList(result)">
												<div :key="i" class="contact-organization">{{org}}</div>
											</template>
											<div class="contact-phone">{{result.phone}}</div>
										</li>
									</template>
								</autocomplete>
							</b-form-group>
						</b-col>
						<b-col lg="6">
							<b-form-group id="ig-alternate-reporter" label="Alternate Lane Closure Reporter(s)" label-for="input-lcr-alternate-reporter" description="">
								<p>Who else can be contacted if the Lane Closure Reporter is unavailable when the lanes should be closed / re-opened?</p>
								<div v-if="laneClosureRequest.altClosureReporter.length > 0" class="contact-container">
									<b-form-row v-for=" (contact, index) in laneClosureRequest.altClosureReporter" class="contact" v-bind:key="'ccr'+contact.userId+'_'+index">
										<b-col cols="8">
											<div class="contact__name">{{contact.firstName}} {{contact.lastName}}</div>
											<template v-for="(org, i) in getOrganizationTreeList(contact)">
												<div class="contact__organization" :key="i">{{org}}</div>
											</template>
											<div class="contact__phone">{{contact.phone}}</div>
										</b-col>
										<b-col cols="4" class="text-right ">
											<b-button variant="secondary" type="button" class="btn-sm" @click="onRemoveAltClosureReporter(index)">Remove</b-button>
										</b-col>
									</b-form-row>
								</div>
								<autocomplete data-position="above" :search="onAltClosureReporterSearch" @submit="onAltClosureReporterSelect" @keydown="onAltClosureReporterKeydown" placeholder="Start typing to select alternate closure reporter" aria-label="Start typing to select alternate closure reporter" ref="searchAltClosureReporter" auto-select>
									<template v-slot:result=" {result, props } ">
										<li v-bind="props" class="autocomplete-result alternate-contact-result">
											<div class="autocomplete__name">{{result.firstName}} {{result.lastName}} {{result.isActive ? '' : '(inactive)'}}</div>
											<template v-for="(org, i) in getOrganizationTreeList(result)">
												<div v-if="org" :key="i" class="contact-organization">{{org}}</div>
											</template>
											<div v-if="result.phone" class="autocomplete__phone">{{result.phone}}</div>
										</li>
									</template>
								</autocomplete>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row  v-if="false">
						<b-col lg="6">
							<b-form-group id="ig-restriction-reporter" label="Turning Restriction Reporter" label-for="input-lcr-restriction-reporter" description="" :state="selectRestrictionReporter.status" :invalid-feedback="selectRestrictionReporter.invalidMessage">
								<p>If you are restricting turns on streets, who will be reporting the turning restrictions as in-place/removed?</p>
								<div v-if="laneClosureRequest.restrictionReporter" class="contact mb-3">
									<div class="contact__name">{{laneClosureRequest.restrictionReporter.firstName}} {{laneClosureRequest.restrictionReporter.lastName}}</div>
									<template v-for="(org, i) in getOrganizationTreeList(laneClosureRequest.restrictionReporter)">
										<div class="contact__organization" :key="i">{{org}}</div>
									</template>
									<div class="contact__phone">{{laneClosureRequest.restrictionReporter.phone}}</div>
								</div>
								<autocomplete data-position="above" :search="onRestrictionReporterSearch" @submit="onRestrictionReporterSelect" @keydown="onRestrictionReporterKeydown" placeholder="Start typing to select Turning Restriction Reporter" aria-label="Start typing to select Turning Restriction Reporter" ref="searchRestrictionReporter" auto-select>
									<template v-slot:result=" {result, props } ">
										<li v-bind="props" class="autocomplete-result primary-contact-result">
											<div class="contact-name">{{result.firstName}} {{result.lastName}} {{result.isActive ? '' : '(inactive)'}}</div>
											<template v-for="(org, i) in getOrganizationTreeList(result)">
												<div :key="i" class="contact-organization">{{org}}</div>
											</template>
											<div class="contact-phone">{{result.phone}}</div>
										</li>
									</template>
								</autocomplete>
							</b-form-group>
						</b-col>
						<b-col lg="6">
							<b-form-group id="ig-alternate-restriction-reporter" label="Alternate Turning Restriction Reporter(s)" label-for="input-lcr-alternate-restriction-reporter" description="">
								<p>Who can be contacted if the Turning Restriction Reporter is unavailable when the restrictions should be reported in-place/removed?</p>
								<div v-if="laneClosureRequest.altRestrictionReporter.length > 0" class="contact-container">
									<b-form-row v-for=" (contact, index) in laneClosureRequest.altRestrictionReporter" class="contact" v-bind:key="'ccc'+contact.userId+'_'+index">
										<b-col cols="8">
											<div class="contact__name">{{contact.firstName}} {{contact.lastName}}</div>
											<template v-for="(org, i) in getOrganizationTreeList(contact)">
												<div class="contact__organization" :key="i">{{org}}</div>
											</template>
											<div class="contact__phone">{{contact.phone}}</div>
										</b-col>
										<b-col cols="4" class="text-right ">
											<b-button variant="secondary" type="button" class="btn-sm" @click="onRemoveAltRestrictionReporter(index)">Remove</b-button>
										</b-col>
									</b-form-row>
								</div>
								<autocomplete data-position="above" :search="onAltRestrictionReporterSearch" @submit="onAltRestrictionReporterSelect" @keydown="onAltRestrictionReporterKeydown" placeholder="Start typing to select alternate restriction reporter" aria-label="Start typing to select alternate restriction reporter" ref="searchAltRestrictionReporter" auto-select>
									<template v-slot:result=" {result, props } ">
										<li v-bind="props" class="autocomplete-result alternate-contact-result">
											<div class="autocomplete__name">{{result.firstName}} {{result.lastName}} {{result.isActive ? '' : '(inactive)'}}</div>
											<template v-for="(org, i) in getOrganizationTreeList(result)">
												<div v-if="org" :key="i" class="contact-organization">{{org}}</div>
											</template>
											<div v-if="result.phone" class="autocomplete__phone">{{result.phone}}</div>
										</li>
									</template>
								</autocomplete>
							</b-form-group>
						</b-col>
					</b-row>
					{{/* ======================== END OF REQUESTERS AND REPORTERS ======================== */}}
				</tab-content>
				<tab-content title="Closures and Restrictions" :before-change="validateClosuresStepAsync">
					<b-row>
						<b-col>
							<div class="d-flex">
								<div class="flex-grow-1">
									<h2>
										{{LaneClosureRequest.getDirectionAbbreviationText(laneClosureRequest.directionId.value)}} {{laneClosureRequest.affectedStreet.value}} between {{laneClosureRequest.firstCrossStreet.value}} and {{laneClosureRequest.lastCrossStreet.value}}
									</h2>
								</div>
								<div class="pl-1">
									<b-button class="pl-2 pr-2 pt-1 pb-1" variant="text" type="button" @click="showOnMap()"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px" /></b-button>
								</div>
							</div>
						</b-col>
					</b-row>
					<b-row>
						<b-col :class="{'col':!$store.state.isMobile, 'col-12':$store.state.isMobile}">
							<b-form-group label="Please add any closures or turning restrictions">
									<!-- <b-dropdown id="dropdown-1" text="Add Closure / Restriction">
										<b-dropdown-item @click="onShowAddLaneModal()">Vehicle Lane Closure</b-dropdown-item>
										<b-dropdown-item @click="onShowAddBicycleModal()">Bicycle Lane / Path Closure</b-dropdown-item>
										<b-dropdown-item @click="onShowAddSidewalkModal()">Sidewalk Closure</b-dropdown-item>
										<b-dropdown-item @click="onShowAddRestrictionModal()">Turning Restriction</b-dropdown-item>
									</b-dropdown> -->
									<div v-if="hasPresetBlockError" tabindex="-1" role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback d-block">Please add a lane closure or turning restriction.</div>
								</b-form-group>
								<b-form-group>
									<lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" v-bind:key="'laneListing'" :renderCounter="renderCounter"></lane-closure-request-block-lane-listing>
									<LaneClosureRequestBlockAdd @click="onShowAddLaneModal()">Add Lane Closure</LaneClosureRequestBlockAdd>
								</b-form-group>
								<b-form-group  v-show="hasLaneId(null)" label="Please indicate how many VEHICLE traffic lanes PER DIRECTION you will be closing at the same time. THIS NO LONGER INCLUDES SIDEWALKS." label-for="input-closed-same-time" invalid-feedback="Field required">
									<p>EXAMPLE: no multiple lanes closed or 2 NB & 1 SB</p>
									<b-form-input maxlength="200" id="input-closed-same-time" placeholder="Lanes to be closed at the same time" v-model="laneClosureRequest.lanesClosedSameTime.value" @input="laneClosureRequest.lanesClosedSameTime.resetStatus()" :state="laneClosureRequest.lanesClosedSameTime.status" />
								</b-form-group>
								<b-form-group>
									<lane-closure-request-block-sidewalk-listing v-show="!isEditingBlock" v-bind:key="'sidewalkListing'" :renderCounter="renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></lane-closure-request-block-sidewalk-listing>
									<LaneClosureRequestBlockAdd @click="onShowAddSidewalkModal()">Add Sidewalk Closure</LaneClosureRequestBlockAdd>
								</b-form-group>
								<b-form-group>
									<lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-bind:key="'bicycleListing'" :renderCounter="renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></lane-closure-request-block-bicycle-listing>
									<LaneClosureRequestBlockAdd @click="onShowAddBicycleModal()">Add Bicycle Closure</LaneClosureRequestBlockAdd>
								</b-form-group>
								<b-form-group>
									<lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-bind:key="'restrictionListing'" :renderCounter="renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></lane-closure-request-block-restriction-listing>
									<LaneClosureRequestBlockAdd @click="onShowAddRestrictionModal()">Add Turning Restriction</LaneClosureRequestBlockAdd>
								</b-form-group>
								<lane-closure-request-block-traffic-signals-altered v-show="!isEditingBlock" v-bind:key="'trafficSignalsAlteredListing'" :renderCounter="renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></lane-closure-request-block-traffic-signals-altered>

								<b-row>
									<b-col lg="6">
										<b-form-group label="Do you want Traffic Services to complete the temporary traffic control for you?" :state="laneClosureRequest.tempTrafficControl.status" :invalid-feedback="laneClosureRequest.tempTrafficControl.invalidMessage">
											<b-form-radio-group id="rg-temp-traffic-control" v-model="laneClosureRequest.tempTrafficControl.value" :options="LaneClosureRequest.getYesNoOptions" @change="laneClosureRequest.tempTrafficControl.resetStatus(); laneClosureRequest.tempTrafficControl.setDirty();" :state="laneClosureRequest.tempTrafficControl.status" value-field="id" text-field="name">
											</b-form-radio-group>
										</b-form-group>
									</b-col>
								</b-row>



								<div v-show="canSetTrafficEffect">
									<b-form-group label="Traffic Effect for the Public" label-for="edit-lcr__traffic-effect" :state="laneClosureRequest.trafficEffect.status" :invalid-feedback="laneClosureRequest.trafficEffect.invalidMessage">
										<b-form-textarea maxlength="2000" id="edit-lcr__traffic-effect" rows="4" no-resize v-model="laneClosureRequest.trafficEffect.value" @input="laneClosureRequest.trafficEffect.resetStatus()" :state="laneClosureRequest.trafficEffect.status">
										</b-form-textarea>
									</b-form-group>
								</div>
							</b-col>
							<b-col v-if="hideMap" style="flex: 0 0 44%; max-width: 44%">
							</b-col>
						</b-row>
					</tab-content>
					<tab-content title="DCZ, Transit, Parking" :before-change="validateDCZStepAsync">
						<b-row>
							<b-col class="mb-3">
								<div class="d-flex">
									<div class="flex-grow-1">
										<h2>
											{{LaneClosureRequest.getDirectionAbbreviationText(laneClosureRequest.directionId.value)}} {{laneClosureRequest.affectedStreet.value}} between {{laneClosureRequest.firstCrossStreet.value}} and {{laneClosureRequest.lastCrossStreet.value}}
										</h2>
									</div>
									<div class="pl-1">
										<b-button v-if="hideMap" @click="showOnMap()"  variant="show-map">Map</b-button>
										<b-button v-if="!hideMap" @click="showOnMap()"  variant="hide-map">Map</b-button>
									</div>
								</div>
							</b-col>
						</b-row>
						<b-card bg-variant="primary-x-light" text-variant="primary" class="mb-4">
							<b-row class=" pt-3">
								<b-col>
									<h2 v-if="$store.state.isMobile">Designated Construction Zone</h2>
									<h2 v-if="!$store.state.isMobile">READ THIS CAREFULLY, AS IT THIS IS VERY IMPORTANT</h2>
									<h4 class="desc-subtitle" v-if="$store.state.isMobile">READ THIS CAREFULLY, AS IT THIS IS VERY IMPORTANT</h4>
									<b-form-group label="Is the speed limit in your proposed work zone 80 kph or higher?" label-for="rg-per-intes-restriction" :invalid-feedback="laneClosureRequest.workZoneKph.invalidMessage" :state="laneClosureRequest.workZoneKph.status">
										<b-radio-group id="rg-80kph-work-zone" :options="LaneClosureRequest.getWorkZoneKphOptions" value-field="id" text-field="name" v-model="laneClosureRequest.workZoneKph.value" @input="laneClosureRequest.workZoneKph.resetStatus()" :state="laneClosureRequest.workZoneKph.status">
										</b-radio-group>
									</b-form-group>
									<b-form-group v-show="laneClosureRequest.workZoneKph.value == 70" label="Do you wish to have the speed reduced to 60kph?" :state="laneClosureRequest.workZoneReduceKph.status" :invalid-feedback="laneClosureRequest.workZoneReduceKph.invalidMessage">
										<b-form-radio-group id="rg-speed-reduction" :options="LaneClosureRequest.getWorkZoneReduceKphOptions" value-field="id" text-field="name" v-model="laneClosureRequest.workZoneReduceKph.value" @change="laneClosureRequest.workZoneReduceKph.resetStatus()" :state="laneClosureRequest.workZoneReduceKph.status"></b-form-radio-group>
									</b-form-group>
									<p v-show="laneClosureRequest.dczRequired.value == 1">A Construction Agency must set up a work zone as a Designated Construction Zone (DCZ) if the work being undertaken on a road meets ALL of the following conditions:
										<ol>
											<li>Work is on the roadway portion of a street, i.e. the area of a street where vehicles travel, this does not include the shoulder, sidewalk or ditch/median</li>
											<li>Work is 4 hours or more in duration</li>
											<li>Work is on a paved roadway</li>
											<li>Work is on a roadway where the maximum posted speed is 80 km/h or more.</li>
										</ol>
									</p>
									<b-row v-show="laneClosureRequest.dczRequired.value == 1" class="pt-3">
										<b-col>
											<b-form-group label="Will the construction area limits change as work progresses?  If yes, please describe." label-for="ta-dcz-description" :state="laneClosureRequest.dczLimits.status" :invalid-feedback="laneClosureRequest.dczLimits.invalidMessage">
												<b-form-textarea maxlength="4000" id="ta-dcz-description" rows="4" no-resize v-model="laneClosureRequest.dczLimits.value" @input="laneClosureRequest.dczLimits.resetStatus()" :state="laneClosureRequest.dczLimits.status">
												</b-form-textarea>
											</b-form-group>
											<b-form-group label="Will temporary traffic control be removed at the end of each work day?" :state="laneClosureRequest.dczTemporaryTcRemoved.status" :invalid-feedback="laneClosureRequest.dczTemporaryTcRemoved.invalidMessage">
												<b-form-radio-group id="rg-dczTemporaryTcRemoved" :options="LaneClosureRequest.getYesNoOptions" value-field="id" text-field="name" v-model="laneClosureRequest.dczTemporaryTcRemoved.value" @change="laneClosureRequest.dczTemporaryTcRemoved.resetStatus()" :state="laneClosureRequest.dczTemporaryTcRemoved.status"></b-form-radio-group>
											</b-form-group>
											<b-form-group label="What physical hazards will be present to the motorist when workers are not present?" label-for="ta-dczHazards-description" :state="laneClosureRequest.dczHazards.status" :invalid-feedback="laneClosureRequest.dczHazards.invalidMessage">
												<b-form-textarea maxlength="4000" id="ta-dczHazards-description" rows="4" no-resize v-model="laneClosureRequest.dczHazards.value" @input="laneClosureRequest.dczHazards.resetStatus()" :state="laneClosureRequest.dczHazards.status">
												</b-form-textarea>
											</b-form-group>
											<b-form-group label="What will be the typical hours of work?" label-for="ta-dczHoursOfWork-description" :state="laneClosureRequest.dczHoursOfWork.status" :invalid-feedback="laneClosureRequest.dczHoursOfWork.invalidMessage">
												<b-form-textarea maxlength="500" id="ta-dczHoursOfWork-description" rows="4" no-resize v-model="laneClosureRequest.dczHoursOfWork.value" @input="laneClosureRequest.dczHoursOfWork.resetStatus()" :state="laneClosureRequest.dczHoursOfWork.status">
												</b-form-textarea>
											</b-form-group>
										</b-col>
									</b-row>
								</b-col>
							</b-row>
						</b-card>
						<b-card bg-variant="secondary-light" text-variant="text" class="mb-4">
							<b-row>
								<b-col>
									<h2>Transit</h2>
									<b-form-group label="Will you be affecting any Bus stops or affecting Winnipeg Transit in any way?" :state="laneClosureRequest.transitAffected.status" :invalid-feedback="laneClosureRequest.transitAffected.invalidMessage">
										<p>Does a bus stop need to be moved? Are you blocking a Transit Diamond lane? Any other impact to Transit service?</p>
										<b-form-radio-group id="rg-is-transit-affected" :options="LaneClosureRequest.getYesNoTransitOptions" value-field="id" text-field="name" v-model="laneClosureRequest.transitAffected.value" @change="laneClosureRequest.transitAffected.resetStatus()" :state="laneClosureRequest.transitAffected.status">
										</b-form-radio-group>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row v-show="laneClosureRequest.transitAffected.value == true">
								<b-col>
									<b-form-group label="How will you be affecting Bus stops or affecting Winnipeg Transit?" :state="transitFieldsState" invalid-feedback="Please fill in the required field">
										<b-form-checkbox-group v-model="laneClosureRequest.transit.value" id="cg-affect-transit" :state="laneClosureRequest.transit.status" @change="laneClosureRequest.transit.resetStatus()" stacked>
											<b-form-checkbox :value="{transitEffectId: LaneClosureRequest.getAffectTransitOptions[0].id}" :checked="checkTransit(LaneClosureRequest.getAffectTransitOptions[0].id)"><span>{{LaneClosureRequest.getAffectTransitOptions[0].name}}</span></b-form-checkbox>
											<b-form-checkbox :value="{transitEffectId: LaneClosureRequest.getAffectTransitOptions[1].id}" :checked="checkTransit(LaneClosureRequest.getAffectTransitOptions[1].id)"><span>{{LaneClosureRequest.getAffectTransitOptions[1].name}}</span></b-form-checkbox>
											<b-form-checkbox :value="{transitEffectId: LaneClosureRequest.getAffectTransitOptions[2].id}" :checked="checkTransit(LaneClosureRequest.getAffectTransitOptions[2].id)"><span>{{LaneClosureRequest.getAffectTransitOptions[2].name}}</span></b-form-checkbox>
											<b-input-group>
												<b-input-group-prepend>
													<b-form-checkbox :value="{transitEffectId: LaneClosureRequest.getAffectTransitOptions[3].id}" :checked="checkTransit(LaneClosureRequest.getAffectTransitOptions[3].id)"><span>{{LaneClosureRequest.getAffectTransitOptions[3].name}}</span></b-form-checkbox>
												</b-input-group-prepend>
												<b-form-input  maxlength="4000" id="input-other-affect-transit" v-model="laneClosureRequest.transitOther.value" placeholder="Other" :state="laneClosureRequest.transitOther.status" @input="laneClosureRequest.transitOther.resetStatus()" :disabled="laneClosureRequest.transitOther.required == false" inline></b-form-input>
											</b-input-group>
										</b-form-checkbox-group>
									</b-form-group>
									<b-form-group label="If you are blocking or needing to relocate bus stops you must provide the bus stop ID numbers and explain how you will be affecting them." :state="laneClosureRequest.transitStopNumbers.status" :invalid-feedback="laneClosureRequest.transitStopNumbers.invalidMessage">
										<p>
											ID numbers can be found by clicking on the affected bus stop icons on the map.
										</p>
										<a :href="getBusStopMapLink" class="btn btn-show-map mb-3" target="_blank">Show Map of Bus Stops (opens in new window)</a>
										<b-form-input maxlength="200" placeholder="Enter bus stop ID numbers affected, and explanation" v-model="laneClosureRequest.transitStopNumbers.value" :state="laneClosureRequest.transitStopNumbers.status" @input="laneClosureRequest.transitStopNumbers.resetStatus()"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
						</b-card>
						<b-card bg-variant="primary-x-light" text-variant="primary" class="mb-4">
							<b-row>
								<b-col>
									<h2>Parking</h2>

									<b-form-group label="Do you require to have parking removed from your work zone?" :state="laneClosureRequest.parkingRemovalId.status" :invalid-feedback="laneClosureRequest.parkingRemovalId.invalidMessage">
										<p>Please be aware that if you are blocking metered parking, you MUST have the parking removed.</p>
										<b-form-radio-group v-model="laneClosureRequest.parkingRemovalId.value" :options="LaneClosureRequest.getParkingRemoveOptions" value-field="id" text-field="name" id="rg-parking-remove" stacked @change="laneClosureRequest.parkingRemovalId.resetStatus()" :state="laneClosureRequest.parkingRemovalId.status">
										</b-form-radio-group>
									</b-form-group>

									<a :href="getParkingSpotMapLink" class="btn btn-show-map mb-3" target="_blank">Show Map of Parking Spots (opens in new window)</a>

								</b-col>
							</b-row>

							<b-row v-show="laneClosureRequest.parkingRemovalId.value == '1' || laneClosureRequest.parkingRemovalId.value == '3' || laneClosureRequest.parkingRemovalId.value == '4' || laneClosureRequest.parkingRemovalId.value == '5'">
								<b-col>
									<b-form-group label="Will you be impacting on-street paid parking spaces in any way?" :state="laneClosureRequest.paidParkingAffected.status" :invalid-feedback="laneClosureRequest.paidParkingAffected.invalidMessage">
										<b-form-radio-group id="rg-block-parking" :options="LaneClosureRequest.getYesNoOptions" value-field="id" text-field="name" v-model="laneClosureRequest.paidParkingAffected.value" @change="laneClosureRequest.paidParkingAffected.resetStatus()" :state="laneClosureRequest.paidParkingAffected.status"></b-form-radio-group>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row v-show="laneClosureRequest.parkingRemovalId.value == '1' || laneClosureRequest.parkingRemovalId.value == '5'">
								<b-col>
									<img src="/img/signs/no_parking_slash.png" alt="No Parking Sign" />
								</b-col>
							</b-row>
							<!-- 							
							<b-row v-show="laneClosureRequest.parkingRemovalId.value == '1' || laneClosureRequest.parkingRemovalId.value == '5'">
								<b-col md>
									<b-row>
										<b-col>
											<b-form-group label="Which lane requires parking to be removed?" :state="laneClosureRequest.parkingLane.status" :invalid-feedback="laneClosureRequest.parkingLane.invalidMessage">
												<p>NOTE: on a one way street the right hand side is the Curb Lane and the left hand side is the Median Lane.</p>
												<b-form-checkbox-group v-model="laneClosureRequest.parkingLane.value" id="cg-parking-lane" stacked @change="laneClosureRequest.parkingLane.resetStatus()" :state="laneClosureRequest.parkingLane.status" :invalid-feedback="laneClosureRequest.parkingLane.invalidMessage">
													<b-form-checkbox :value="{laneId: LaneClosureRequest.getParkingLaneOptions[0].id}" :checked="checkParkingLane(LaneClosureRequest.getParkingLaneOptions[0].id)"><span>{{LaneClosureRequest.getParkingLaneOptions[0].name}}</span></b-form-checkbox>
													<b-form-checkbox :value="{laneId: LaneClosureRequest.getParkingLaneOptions[1].id}" :checked="checkParkingLane(LaneClosureRequest.getParkingLaneOptions[1].id)"><span>{{LaneClosureRequest.getParkingLaneOptions[1].name}}</span></b-form-checkbox>
													<b-form-checkbox :value="{laneId: LaneClosureRequest.getParkingLaneOptions[2].id}" :checked="checkParkingLane(LaneClosureRequest.getParkingLaneOptions[2].id)"><span>{{LaneClosureRequest.getParkingLaneOptions[2].name}}</span></b-form-checkbox>
													<b-form-checkbox :value="{laneId: LaneClosureRequest.getParkingLaneOptions[3].id}" :checked="checkParkingLane(LaneClosureRequest.getParkingLaneOptions[3].id)"><span>{{LaneClosureRequest.getParkingLaneOptions[3].name}}</span></b-form-checkbox>
													<b-form-checkbox :value="{laneId: LaneClosureRequest.getParkingLaneOptions[4].id}" :checked="checkParkingLane(LaneClosureRequest.getParkingLaneOptions[4].id)"><span>{{LaneClosureRequest.getParkingLaneOptions[4].name}}</span></b-form-checkbox>
													<b-form-checkbox :value="{laneId: LaneClosureRequest.getParkingLaneOptions[5].id}" :checked="checkParkingLane(LaneClosureRequest.getParkingLaneOptions[5].id)"><span>{{LaneClosureRequest.getParkingLaneOptions[5].name}}</span></b-form-checkbox>
													<b-form-checkbox :value="{laneId: LaneClosureRequest.getParkingLaneOptions[6].id}" :checked="checkParkingLane(LaneClosureRequest.getParkingLaneOptions[6].id)"><span>{{LaneClosureRequest.getParkingLaneOptions[6].name}}</span></b-form-checkbox>
													<b-form-checkbox :value="{laneId: LaneClosureRequest.getParkingLaneOptions[7].id}" :checked="checkParkingLane(LaneClosureRequest.getParkingLaneOptions[7].id)"><span>{{LaneClosureRequest.getParkingLaneOptions[7].name}}</span></b-form-checkbox>
												</b-form-checkbox-group>
											</b-form-group>
										</b-col>
									</b-row>
									<b-row>
										<b-col>
											<b-form-group label="How much parking do you need removed? MEASURE IN METERS" :state="laneClosureRequest.parkingRemovalMetres.status" :invalid-feedback="laneClosureRequest.parkingRemovalMetres.invalidMessage">
												<b-input-group class="lw-25 mw-50" append="m">
													<b-form-input placeholder="Enter in meters" v-model="laneClosureRequest.parkingRemovalMetres.value" @input="laneClosureRequest.parkingRemovalMetres.resetStatus()" :state="laneClosureRequest.parkingRemovalMetres.status"></b-form-input>
												</b-input-group>
											</b-form-group>
										</b-col>
									</b-row>
								</b-col>
								<b-col>
									<b-form-group label="Starting Point for Parking Removal" label-for="ig-start-parking-removal" :state="laneClosureRequest.parkingStartAddress.status" :invalid-feedback="laneClosureRequest.parkingStartAddress.invalidMessage">
										<p>Use the closest starting street address</p>
										<b-form-input  maxlength="200" id="ig-start-parking-removal" v-model="laneClosureRequest.parkingStartAddress.value" @input="laneClosureRequest.parkingStartAddress.resetStatus()" :state="laneClosureRequest.parkingStartAddress.status" />
									</b-form-group>
									<b-button v-if="hideMap" @click="showOnMap()"  class="mb-3" variant="show-map">Map</b-button>
									<b-button v-if="!hideMap" @click="showOnMap()" class="mb-3"  variant="hide-map">Map</b-button>
									<b-form-group label="Ending Point for Parking Removal" label-for="ig-end-parking-removal" :state="laneClosureRequest.parkingEndAddress.status" :invalid-feedback="laneClosureRequest.parkingEndAddress.invalidMessage">
										<p>Use the closest ending street address</p>
										<b-form-input  maxlength="200" id="ig-end-parking-removal" v-model="laneClosureRequest.parkingEndAddress.value" @input="laneClosureRequest.parkingEndAddress.resetStatus()" :state="laneClosureRequest.parkingEndAddress.status" />
									</b-form-group>
								</b-col>
							</b-row>
							-->
							<div v-if="hasParkingRemovalError" tabindex="-1" role="alert" aria-live="assertive" aria-atomic="true" class="d-block invalid-feedback" id="__BVID__601__BV_feedback_invalid_">Please add at least one parking lane to remove.</div>
							<LaneClosureRequestParkingRemovalListing 
								class="mb-2 mt-2"
								v-show="laneClosureRequest.parkingRemovalId.value == '1' || laneClosureRequest.parkingRemovalId.value == '5'"
								:renderCounter="renderCounter"
								:parkingRemovalList="parkingRemovalListCopy"
								@delete-parking-removal-button-clicked="onRemoveLaneFromParkingRemoval" 
								@edit-parking-removal-button-clicked="onEditLaneFromParkingRemoval" 
							></LaneClosureRequestParkingRemovalListing>
							<LaneClosureRequestParkingRemovalModal  
								ref="lcrParkingRemovalModalRef"
								v-show="laneClosureRequest.parkingRemovalId.value == '1' || laneClosureRequest.parkingRemovalId.value == '5'"
								:parkingLaneRemovalOptions="getParkingLaneRemovalOptions()"
								:lcrDirectionId="laneClosureRequest.directionId.value"
								:isEditingParkingRemoval="isEditingParkingRemoval"
								:laneIndexToEditParkingRemoval="laneIndexToEditParkingRemoval"
								:laneInfoToEditParkingRemoval="laneInfoToEditParkingRemoval"
								@submit-updated-parking-removal-data="onUpdateParkingRemoval" 									
								@submit-new-parking-removal-data="onSubmitNewParkingRemoval" 									
							></LaneClosureRequestParkingRemovalModal>
							<LaneClosureRequestBlockAdd 
								v-show="laneClosureRequest.parkingRemovalId.value == '1' || laneClosureRequest.parkingRemovalId.value == '5'"
								@click="onShowModalForParkingRemoval"
							>Add Parking Lane to Remove</LaneClosureRequestBlockAdd>
						
						</b-card>
						<b-card text-variant="text" class="mb-4">
							<b-row>
								<b-col>
									<h2>Closure Information</h2>
									<b-form-group label="Comments and Explanations">
										<p>Please provide a short description of your work and any other relevant information.  <br/> Typing "N/A" in the comments box does not provide us with sufficient information and will delay processing the request.</p>
										<b-alert :show="shouldShowDescriptionMessage" variant="warning">
											You must also:
											<ul>
												<li v-if="laneClosureRequest.isEmergency.value === 1">
													Describe the nature of the emergency.
												</li>
												<li v-if="hasRestrictions()">
													Note if your turn restriction(s) will only be limited to trucks and other large vehicles.
												</li>
											</ul>
										</b-alert>
										<wysiwyg v-model="laneClosureRequest.requesterComments.value" />
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col>
									<b-form-group label="Is this area being closed by or for the City of Winnipeg or by or for any of the major utilities?" :state="laneClosureRequest.workDoneForId.status" :invalid-feedback="laneClosureRequest.workDoneForId.invalidMessage">
										<!-- <small class="form-text text-muted">
							Is this work being done by or for the City of Winnipeg, or by or for MB Hydro, Bell/MTS, Shaw, Telus? If Yes please indicate which one below below. If the answer is No then you will be taken to the Permits Information Section
						</small> -->
										<!-- <vue-select-grouped v-model="laneClosureRequest.workDoneForId.value" :options="organizations" label="name" :reduce="name => name.id" @input="setWorkForId">
												<template v-slot:option="optionGroup" :option="(typeof option === 'object')?option:{[name]: option, namePath:option.namePath, name:option.name, groupName:option.groupName}">
												</template>
												<template v-slot:option="option">
													<span :class="getLevelClassName(option.level)">{{ option.name }}</span>
												</template>
												<template v-slot:selected-option-container="option" :option="(typeof option === 'object')?option:{[name]: option, namePath:option.namePath, name:option.name}">
													<div class="vs__selected-options" v-html="getFlatTree(option.option)"></div>
												</template>
											</vue-select-grouped> -->
											<b-form-radio-group id="rg-is-work-done-for-city" v-model="workDoneForOrgType.value" :options="LaneClosureRequest.getWorkDoneForTypeOptions" @change="workDoneForOrgTypeChange" :state="workDoneForOrgType.status" value-field="id" text-field="name" inline></b-form-radio-group>
											<br />
											<treeselect
											v-show="workDoneForOrgType.value != null"
											:multiple="false"
											v-model="workDoneForOrgId"
											:options="organizations"
											:clearable="true"
											@input="setWorkForId"
											:placeholder="workDoneForOrgTypePlaceHolder"
											openDirection="above"
											:maxHeight="120"
											>
										</treeselect>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row v-show="laneClosureRequest.permitRequired.value == 1">
								<b-col><strong>A permit will be required. Be sure to click Next below to enter the required information.</strong></b-col>
							</b-row>
							<b-row v-show="laneClosureRequest.workDoneForId.isCityOfWinnipeg()">
								<b-col>
									<b-form-group label="Please provide the Bid Opportunity number or enter N/A if not applicable." label-for="input-bid-op-number" :state="laneClosureRequest.projectBidNumber.status" :invalid-feedback="laneClosureRequest.projectBidNumber.invalidMessage">
										<b-form-input  maxlength="50" id="input-bid-op-number" v-model="laneClosureRequest.projectBidNumber.value" @input="laneClosureRequest.projectBidNumber.resetStatus()" :state="laneClosureRequest.projectBidNumber.status">
										</b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row v-show="laneClosureRequest.workDoneForId.isCityOfWinnipeg()">
								<b-col>
									<b-form-group label="Please state the name of the City Administrator if one is attached to the bid opp." label-for="input-bid-admin" :state="laneClosureRequest.bidAdmin.status" :invalid-feedback="laneClosureRequest.bidAdmin.invalidMessage">
										<b-form-input  maxlength="255" id="input-bid-admin" v-model="laneClosureRequest.bidAdmin.value" @input="laneClosureRequest.bidAdmin.resetStatus()" :state="laneClosureRequest.bidAdmin.status">
										</b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row v-show="laneClosureRequest.workDoneForId.isCoWFSEO()" class="row--with-top-border">
								<b-col>
									<h2>City of Winnipeg Film and Special Events Office Identifier</h2>
									<b-form-group label="Please enter either the Control Code or the Name of the Special event." label-for="ta-wfseoControlCode-description" :state="laneClosureRequest.wfseoControlCode.status" :invalid-feedback="laneClosureRequest.wfseoControlCode.invalidMessage">
										<b-form-textarea  maxlength="255" id="ta-wfseoControlCode-description" rows="4" no-resize v-model="laneClosureRequest.wfseoControlCode.value" @input="laneClosureRequest.wfseoControlCode.resetStatus()" :state="laneClosureRequest.wfseoControlCode.status">
										</b-form-textarea>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row v-show="laneClosureRequest.workDoneForId.isCoWFSEO()">
								<b-col>
									<b-form-group label="Please copy and paste the permit request information in this box." label-for="ta-wfseoPermitRequestInfo-description" :state="laneClosureRequest.wfseoPermitRequestInfo.status" :invalid-feedback="laneClosureRequest.wfseoPermitRequestInfo.invalidMessage">
										<b-form-textarea  maxlength="4000" id="ta-wfseoPermitRequestInfo-description" rows="4" no-resize v-model="laneClosureRequest.wfseoPermitRequestInfo.value" @input="laneClosureRequest.wfseoPermitRequestInfo.resetStatus()" :state="laneClosureRequest.wfseoPermitRequestInfo.status">
										</b-form-textarea>
									</b-form-group>
								</b-col>
							</b-row>
						</b-card>
					</tab-content>
					<tab-content ref="tabPermit" key="tabPermit" title="Permit" v-if="laneClosureRequest.permitRequired.value == 1" :before-change="validatePermitsStepAsync">
						<b-row>
							<b-col class="mb-3">
								<div class="d-flex">
									<div class="flex-grow-1">
										<h2>
											{{LaneClosureRequest.getDirectionAbbreviationText(laneClosureRequest.directionId.value)}} {{laneClosureRequest.affectedStreet.value}} between {{laneClosureRequest.firstCrossStreet.value}} and {{laneClosureRequest.lastCrossStreet.value}}
										</h2>
									</div>
									<div class="pl-1">
										<b-button v-if="hideMap" @click="showOnMap()"  variant="show-map">Map</b-button>
										<b-button v-if="!hideMap" @click="showOnMap()"  variant="hide-map">Map</b-button>
									</div>
								</div>
							</b-col>
						</b-row>
						<b-row v-show="laneClosureRequest.permitRequired.value == 1" class="row--with-top-border pt-3">
							<b-col>
								<h2>Permit Is Required</h2>
								<p>This section will provide us with some of the information required to begin issuing your permit.</p>
							</b-col>
						</b-row>
						<b-row v-show="laneClosureRequest.permitRequired.value == 1">
							<b-col>
								<b-form-group label="Do you have active liability insurance with the City of Winnipeg Insurance Branch and has the Insurance Branch verified that the insurance is valid?" :state="laneClosureRequest.permitLiabilityInsurance.status" :invalid-feedback="laneClosureRequest.permitLiabilityInsurance.invalidMessage">
									<b-form-radio-group id="rg-insurance" :options="LaneClosureRequest.getYesNoInsuranceOptions" value-field="id" text-field="name" v-model="laneClosureRequest.permitLiabilityInsurance.value" @change="laneClosureRequest.permitLiabilityInsurance.resetStatus()" :state="laneClosureRequest.permitLiabilityInsurance.status">
									</b-form-radio-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row v-show="laneClosureRequest.permitLiabilityInsurance.value == 0">
							<b-col>
								<p>If you have not submitted and had your insurance coverage verified by the City of Winnipeg please be aware that no permit will be issued until such time as the insurance requirements are verified.</p>
								<p>The Applicant will supply a Certificate of Insurance with evidence of the following insurance requirements:</p>
								<ul>
									<li>Commercial General Liability insurance (CGL) with a minimum limit of two (2) million dollars, inclusive;</li>
									<li>The City of Winnipeg added as an additional insured;</li>
									<li>Evidence of Cross Liability;</li>
									<li>Minimum fifteen (15) days notice of cancellation clause;</li>
								</ul>
								Send your Certificate of Insurance to <a href="mailto:Fin-Insurance@winnipeg.ca">Fin-Insurance@winnipeg.ca</a> or <br />
								<address>The City of Winnipeg<br />
									RiskManagement-Insurance Branch<br />
									3rd Floor - 185 King Street<br />
									Winnipeg, Manitoba<br />
									R3B 1J1<br /><br />
								</address>
								<p>Please include a contact name and phone number so that the Insurance Branch may call with any concerns or necessary follow-up.</p>
								<p>The Public Works Department will be notified upon verification of the insurance, and assuming everything else is in order, they will proceed to issue the permit.</p>
							</b-col>
						</b-row>
						<b-row v-show="laneClosureRequest.permitRequired.value == 1 && 1 == 2">
							<b-col lg="6">
								<b-form-group label="Nearest Street Address Number to Affected Closure Area" label-for="input-nearest-street-address" :state="laneClosureRequest.permitNearestStreetNumber.status" :invalid-feedback="laneClosureRequest.permitNearestStreetNumber.invalidMessage">
									<b-form-input maxlength="200" id="input-nearest-street-address" placeholder="Enter Street Address Number" v-model="laneClosureRequest.permitNearestStreetNumber.value" @input="laneClosureRequest.permitNearestStreetNumber.resetStatus()" :state="laneClosureRequest.permitNearestStreetNumber.status">
									</b-form-input>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row v-show="laneClosureRequest.permitRequired.value == 1">
							<b-col lg="6">
								<b-form-group label="What is the TOTAL LENGTH of roadway on the street your affected area requires in meters.  IF NO TRAFFIC LANES ARE REQUIRED PLEASE ENTER 0." label-for="input-roadway-length" :state="laneClosureRequest.permitRoadwayMetres.status" :invalid-feedback="laneClosureRequest.permitRoadwayMetres.invalidMessage">
									<b-input-group append="m">
										<b-form-input id="input-roadway-length" placeholder="Enter in meters" v-model="laneClosureRequest.permitRoadwayMetres.value" @input="checkEmptyRoadwayMetres()" :state="laneClosureRequest.permitRoadwayMetres.status" />
									</b-input-group>
								</b-form-group>
								<div class="mb-3">
									<b-button v-if="hideMap" @click="showOnMap()"  variant="show-map">Map</b-button>
									<b-button v-if="!hideMap" @click="showOnMap()"  variant="hide-map">Map</b-button>
								</div>

							</b-col>
						</b-row>
						<b-row v-show="laneClosureRequest.permitRequired.value == 1">
							<b-col>
								<b-form-group label="Indicate where you are measuring From and To. IF NO TRAFFIC LANES ARE REQUIRED, PLEASE ENTER N/A." label-for="input-measure-from" invalid-feedback="Field required" :state="isPermitRoadwayValid">
									<p>Please also enter the amount of space occupied in a backlane, if required.</p>
									<b-input-group class="big-input-measure-from">
										<b-input-group-addon is-text style="margin-left: -1px;">Measuring Roadway From</b-input-group-addon>
										<b-form-input maxlength="200" id="input-measure-from" placeholder="Street address, intersection, or N/A" v-model="laneClosureRequest.permitRoadwayFrom.value" @input="laneClosureRequest.permitRoadwayFrom.resetStatus()" :state="laneClosureRequest.permitRoadwayFrom.status" />
									</b-input-group>
									<b-input-group class="mt-3 big-input-measure-to">
										<b-input-group-addon is-text style="margin-left: -1px;">Measuring Roadway To</b-input-group-addon>
										<b-form-input maxlength="200" id="input-measure-to" placeholder="Street address, intersection, or N/A" v-model="laneClosureRequest.permitRoadwayTo.value" @input="laneClosureRequest.permitRoadwayTo.resetStatus()" :state="laneClosureRequest.permitRoadwayTo.status" />
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row v-show="laneClosureRequest.permitRequired.value == 1">
							<b-col>
								<b-form-group label="What is the TOTAL LENGTH of sidewalk on the street your affected area requires in meters.  IF NO SIDEWALKS ARE REQUIRED, PLEASE ENTER 0" label-for="input-sidewalk-length" :state="laneClosureRequest.permitSidewalkMetres.status" :invalid-feedback="laneClosureRequest.permitSidewalkMetres.invalidMessage">
									<b-row>
										<b-col lg="6">
											<b-input-group class="big-input-measure-to">
												<b-input-group-addon is-text style="margin-left: -1px">Sidewalk Distance</b-input-group-addon>
												<b-form-input id="input-sidewalk-measure" placeholder="Enter in meters" v-model="laneClosureRequest.permitSidewalkMetres.value" @input="checkEmptySidewalkMetres()" :state="laneClosureRequest.permitSidewalkMetres.status" />
												<b-input-group-addon is-text style="margin-left: -1px">m</b-input-group-addon>
											</b-input-group>
										</b-col>
									</b-row>
								</b-form-group>
								<b-row>
									<b-col class="pt-3">
										<p>Also indicate from where you are beginning your sidewalk measurement. For example from the street corner of the 1st cross street or the property line of a nearby building. If you are blocking or impacting sidewalks please note that 1.5 meters of unobstructed sidewalk must be maintained for pedestrian access, otherwise the sidewalk is considered completely closed. Please note that you cannot close the sidewalk on both sides of a street at the same time.</p>
										<p>YOU MUST PROVIDE A SPECIFIC LOCATION. Indicate either a street address or intersection, or if no sidewalks are required, please enter N/A. </p>
									</b-col></b-row>
									<b-row>
										<b-col lg="6">
											<b-form-group :state="laneClosureRequest.permitSidewalkFrom.status" :invalid-feedback="laneClosureRequest.permitSidewalkFrom.invalidMessage">
												<b-input-group class="big-input-measure-from">
													<b-input-group-addon is-text style="margin-left: -1px">Measuring Sidewalk From</b-input-group-addon>
													<b-form-input maxlength="200" id="input-sidewalk-from" placeholder="Street address, intersection, or N/A" v-model="laneClosureRequest.permitSidewalkFrom.value" @input="laneClosureRequest.permitSidewalkFrom.resetStatus()" :state="laneClosureRequest.permitSidewalkFrom.status"/>
												</b-input-group>
											</b-form-group>
											<b-form-group :state="laneClosureRequest.permitSidewalkTo.status" :invalid-feedback="laneClosureRequest.permitSidewalkTo.invalidMessage">
												<b-input-group class="mt-3 big-input-measure-to">
													<b-input-group-addon is-text style="margin-left: -1px">Measuring Sidewalk To</b-input-group-addon>
													<b-form-input maxlength="200" id="input-sidewalk-to" placeholder="Street address, intersection, or N/A" v-model="laneClosureRequest.permitSidewalkTo.value" @input="laneClosureRequest.permitSidewalkTo.resetStatus()" :state="laneClosureRequest.permitSidewalkTo.status" />
												</b-input-group>
											</b-form-group>

											<div class="mb-3">
												<b-button v-if="hideMap" @click="showOnMap()"  variant="show-map">Map</b-button>
												<b-button v-if="!hideMap" @click="showOnMap()"  variant="hide-map">Map</b-button>
											</div>
										</b-col>
									</b-row>
								</b-col>
							</b-row>
							<b-row v-show="laneClosureRequest.permitRequired.value == 1">
								<b-col>
									<b-form-group label="Please provide any additional relevant information or requests for this permit.">
										<b-form-textarea maxlength="4000" id="ta-permitRequests-reason" rows="4" no-resize v-model="laneClosureRequest.permitRequests.value" :state="laneClosureRequest.permitRequests.status">
										</b-form-textarea>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row v-show="laneClosureRequest.permitRequired.value == 1">
								<b-col>
									<b-form-group label="Is a crossing permit required?" :state="laneClosureRequest.crossingPermitRequired.status" :invalid-feedback="laneClosureRequest.crossingPermitRequired.invalidMessage">
										<p>Will you be crossing a sidewalk/boulevard/curb in order to access PRIVATE PROPERTY to do your work? Crossing a city right-of-way onto private property at a location other than at an existing driveway approach such as mounting a curb and/or crossing a sidewalk requires a Crossing Permit.</p>
										<b-form-radio-group id="rg-crossing-permit" v-model="laneClosureRequest.crossingPermitRequired.value" :options="LaneClosureRequest.getYesNoOptions" value-field="id" text-field="name" @change="laneClosureRequest.crossingPermitRequired.resetStatus()" :state="laneClosureRequest.crossingPermitRequired.status">
										</b-form-radio-group>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row v-show="laneClosureRequest.crossingPermitRequired.value == 1">
								<b-col>
									<b-form-group label="Please indicate specifically where you will be crossing the sidewalk/boulevard/curb area. Also indicate the total width in meters." :state="laneClosureRequest.crossingPermitLocation.status" invalid-feedback="Field required">
										<b-form-textarea maxlength="4000" id="crossing-permit-location" v-model="laneClosureRequest.crossingPermitLocation.value" placeholder="" rows="3" max-rows="6"></b-form-textarea>
									</b-form-group>
									<b-form-group label="Please provide detailed information on the type of equipment used while crossing the area." :state="laneClosureRequest.crossingPermitEquipment.status" invalid-feedback="Field required">
										<b-form-textarea maxlength="4000" id="crossing-permit-equpment" v-model="laneClosureRequest.crossingPermitEquipment.value" placeholder="" rows="3" max-rows="6"></b-form-textarea>
									</b-form-group>
								</b-col>
							</b-row>
						</tab-content>
						<tab-content title="Review">
							<b-row v-if="!$store.state.isMobile" class="wizard-card-header">
								<b-col class="mb-3">
									<div class="d-flex">
										<div class="flex-grow-1">
											<h2>
												Review Lane Closure Request
											</h2>
											<p>Please confirm the closure information before submitting.</p>
										</div>
									</div>
								</b-col>
								<b-col cols="2" class="text-right">
									<b-button type="button" :disabled="isButtonDisabled" class="btn-save" variant="primary" @click="onSubmit"><b-spinner small label="Saving..." class="mr-2" v-if="saving"></b-spinner><span v-if="!saving" class="btn__icon"><img src="/img/assets/icon-checkmark.svg"/></span><span class="btn__text">Finish</span>
									</b-button>
								</b-col>
							</b-row>
							<b-row :class="{'mt-3':!$store.state.isMobile}" >
								<b-col xl="7" :class="{'lcr-summary__left-column':!$store.state.isMobile}">
									<b-row v-if="!$store.state.isMobile">
										<div class="d-flex lcr-main-summary">
											<div class="lcr-main-summary__info flex-grow-1">
												<div class="lcr-summary__label">Affected Streets</div>
												<div class="lcr-summary__value">{{directionOfTravel}}</div>
												<div class="lcr-summary__value">{{laneClosureRequest.affectedStreet.value}}</div>
												<div class="lcr-summary__value">{{laneClosureRequest.firstCrossStreet.value}} to {{laneClosureRequest.lastCrossStreet.value}}</div>
											</div>
											<div class="lcr-main-summary__info pt-4">
												<div class="show-on-map-wrapper">
													<a class="show-on-map text-left" @click="showOnMap">
														<span v-if="hideMap" class="on-container">
															<img class="on-badge responsive-img" src="@/assets/map-badge-hide.svg" alt="on-badge" />
															<img class="on-map responsive-img" src="@/assets/hide-map.svg" alt="on-map" />
														</span>
														<span v-else class="on-container">
															<img class="on-badge responsive-img" src="@/assets/map-badge.svg" alt="on-badge" />
															<img class="on-map responsive-img" src="@/assets/show-on-map.svg" alt="on-map" />
														</span>
													</a>
												</div>
											</div>
											<div class="lcr-main-summary__info">
												<div class="lcr-summary__label">Primary Reason for Closure</div>
												<div class="lcr-summary__value">{{natureOfWork}}</div>
											</div>
											<div class="lcr-main-summary__info ">
												<div class="lcr-summary__label">Date(s)</div>
												<div class="lcr-summary__value">{{Format.toLocalDateTime(laneClosureRequest.fromDate.value, 'MM/DD/YYYY')}} - {{Format.toLocalDateTime(laneClosureRequest.toDate.value, 'MM/DD/YYYY')}}</div>
												<div class="lcr-summary__value">{{Format.toLocalDateTime(laneClosureRequest.fromTime.value, 'H:mm')}} - {{Format.toLocalDateTime(laneClosureRequest.toTime.value, 'H:mm')}}</div>
											</div>
											<div class="lcr-main-summary__info" v-if="laneClosureRequest.completeTypeId.value != null">
												<div class="lcr-summary__label">Complete Status</div>
												<div class="lcr-summary__value">None</div>
											</div>
										</div>
									</b-row>
									<b-row v-if="!$store.state.isMobile">
										<b-col class="mb-2">
											<div class="lcr-summary__section-label">Comments and Explanations</div>
											<div class="lcr-summary__section-value" v-if="laneClosureRequest.requesterComments.value" v-html="laneClosureRequest.requesterComments.value"></div>
											<div class="lcr-summary__section-value" v-else>N/A</div>
										</b-col>
									</b-row>

									<b-row class="mt-3" v-if="$store.state.isMobile">
										<b-col>
											<div class="d-flex">
												<div class="flex-grow-1">
													<h2>
														Review Lane Closure Request
													</h2>
													<p>Please confirm the closure information before submitting.</p>
												</div>
											</div>
											<div class="card mb-4 bg-primary-x-light text-primary">
												<div class="card-body">
													<div class="lcr-summary__label">Affected Streets</div>
													<div class="lcr-summary__value">{{directionOfTravel}} {{laneClosureRequest.affectedStreet.value}}</div>
													<div class="lcr-summary__value">{{laneClosureRequest.firstCrossStreet.value}} to {{laneClosureRequest.lastCrossStreet.value}}</div>
													<b-button v-if="hideMap" @click="showOnMap()"  variant="show-map">Map</b-button>
													<b-button v-if="!hideMap" @click="showOnMap()"  variant="hide-map">Map</b-button>
													<div class="lcr-summary__label">Primary Reason for Closure</div>
													<div class="lcr-summary__value">{{natureOfWork}}</div>
													<div class="lcr-summary__label">Date(s)</div>
													<div class="lcr-summary__value">{{Format.toLocalDateTime(laneClosureRequest.fromDate.value, 'MM/DD/YYYY')}} - {{Format.toLocalDateTime(laneClosureRequest.toDate.value, 'MM/DD/YYYY')}}</div>
													<div class="lcr-summary__value">{{Format.toLocalDateTime(laneClosureRequest.fromTime.value, 'H:mm')}} - {{Format.toLocalDateTime(laneClosureRequest.toTime.value, 'H:mm')}}</div>
													<div class="lcr-summary__label">Comments and Explanations</div>
													<div class="lcr-summary__value" v-if="laneClosureRequest.requesterComments.value" v-html="laneClosureRequest.requesterComments.value"></div>
													<div class="lcr-summary__value" v-else>N/A</div>
												</div>
											</div>
										</b-col>
									</b-row>
									<b-row>
										<b-col class="mb-2">
											<div class="d-flex">
												<div class="lcr-summary__section-label">Closures</div>
											</div>
										</b-col>
									</b-row>

									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(1)" :expand="expandCustomizeLane['1']" :laneId="1" v-bind:key="'viewlaneListing1-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(2)" :expand="expandCustomizeLane['2']" :laneId="2" v-bind:key="'viewlaneListing2-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(24)" :expand="expandCustomizeLane['24']" :laneId="24" v-bind:key="'viewlaneListing24-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(25)" :expand="expandCustomizeLane['25']" :laneId="25" v-bind:key="'viewlaneListing25-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(3)" :expand="expandCustomizeLane['3']" :laneId="3" v-bind:key="'viewlaneListing3-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(15)" :expand="expandCustomizeLane['15']" :laneId="15" v-bind:key="'viewlaneListing15-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(32)" :expand="expandCustomizeLane['32']" :laneId="32" v-bind:key="'viewlaneListing32-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(33)" :expand="expandCustomizeLane['33']" :laneId="33" v-bind:key="'viewlaneListing33-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(19)" :expand="expandCustomizeLane['19']" :laneId="19" v-bind:key="'viewlaneListing19-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(44)" :expand="expandCustomizeLane['44']" :laneId="44" v-bind:key="'viewlaneListing44-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(40)" :expand="expandCustomizeLane['40']" :laneId="40" v-bind:key="'viewlaneListing40-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>

									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(4)" :expand="expandCustomizeLane['4']" :laneId="4" v-bind:key="'viewlaneListing4-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(5)" :expand="expandCustomizeLane['5']" :laneId="5" v-bind:key="'viewlaneListing5-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(26)" :expand="expandCustomizeLane['26']" :laneId="26" v-bind:key="'viewlaneListing26-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(27)" :expand="expandCustomizeLane['27']" :laneId="27" v-bind:key="'viewlaneListing27-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(6)" :expand="expandCustomizeLane['6']" :laneId="6" v-bind:key="'viewlaneListing6-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(16)" :expand="expandCustomizeLane['16']" :laneId="16" v-bind:key="'viewlaneListing16-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(34)" :expand="expandCustomizeLane['34']" :laneId="34" v-bind:key="'viewlaneListing34-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(35)" :expand="expandCustomizeLane['35']" :laneId="35" v-bind:key="'viewlaneListing35-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(20)" :expand="expandCustomizeLane['20']" :laneId="20" v-bind:key="'viewlaneListing20-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(45)" :expand="expandCustomizeLane['45']" :laneId="45" v-bind:key="'viewlaneListing45-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(41)" :expand="expandCustomizeLane['41']" :laneId="41" v-bind:key="'viewlaneListing41-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>

									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(7)" :expand="expandCustomizeLane['7']" :laneId="7" v-bind:key="'viewlaneListing7-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(8)" :expand="expandCustomizeLane['8']" :laneId="8" v-bind:key="'viewlaneListing8-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(28)" :expand="expandCustomizeLane['28']" :laneId="28" v-bind:key="'viewlaneListing28-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(29)" :expand="expandCustomizeLane['29']" :laneId="29" v-bind:key="'viewlaneListing29-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(9)" :expand="expandCustomizeLane['9']" :laneId="9" v-bind:key="'viewlaneListing9-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(17)" :expand="expandCustomizeLane['17']" :laneId="17" v-bind:key="'viewlaneListing17-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(36)" :expand="expandCustomizeLane['36']" :laneId="36" v-bind:key="'viewlaneListing36-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(37)" :expand="expandCustomizeLane['37']" :laneId="37" v-bind:key="'viewlaneListing37-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(21)" :expand="expandCustomizeLane['21']" :laneId="21" v-bind:key="'viewlaneListing21-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(46)" :expand="expandCustomizeLane['46']" :laneId="46" v-bind:key="'viewlaneListing46-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(42)" :expand="expandCustomizeLane['42']" :laneId="42" v-bind:key="'viewlaneListing42-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>

									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(10)" :expand="expandCustomizeLane['10']" :laneId="10" v-bind:key="'viewlaneListing10-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(11)" :expand="expandCustomizeLane['11']" :laneId="11" v-bind:key="'viewlaneListing11-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(30)" :expand="expandCustomizeLane['30']" :laneId="30" v-bind:key="'viewlaneListing30-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(31)" :expand="expandCustomizeLane['31']" :laneId="31" v-bind:key="'viewlaneListing31-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(12)" :expand="expandCustomizeLane['12']" :laneId="12" v-bind:key="'viewlaneListing12-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(22)" :expand="expandCustomizeLane['22']" :laneId="22" v-bind:key="'viewlaneListing22-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(18)" :expand="expandCustomizeLane['18']" :laneId="18" v-bind:key="'viewlaneListing18-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(38)" :expand="expandCustomizeLane['38']" :laneId="38" v-bind:key="'viewlaneListing38-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(39)" :expand="expandCustomizeLane['39']" :laneId="39" v-bind:key="'viewlaneListing39-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(13)" :expand="expandCustomizeLane['13']" :laneId="13" v-bind:key="'viewlaneListing13-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(14)" :expand="expandCustomizeLane['14']" :laneId="14" v-bind:key="'viewlaneListing14-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(23)" :expand="expandCustomizeLane['23']" :laneId="23" v-bind:key="'viewlaneListing23-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(47)" :expand="expandCustomizeLane['47']" :laneId="47" v-bind:key="'viewlaneListing47-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(43)" :expand="expandCustomizeLane['43']" :laneId="43" v-bind:key="'viewlaneListing43-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></review-lane-closure-request-block-lane-listing>
									<review-lane-closure-request-block-sidewalk-listing v-show="!isEditingBlock" v-if="hasSidewalkId(1)" :expand="expandCustomizeSidewalk['1']" :sidewalkId="1" v-bind:key="'viewsidewalkListing1-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></review-lane-closure-request-block-sidewalk-listing>
									<review-lane-closure-request-block-sidewalk-listing v-show="!isEditingBlock" v-if="hasSidewalkId(2)" :expand="expandCustomizeSidewalk['2']" :sidewalkId="2" v-bind:key="'viewsidewalkListing2-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></review-lane-closure-request-block-sidewalk-listing>
									<review-lane-closure-request-block-sidewalk-listing v-show="!isEditingBlock" v-if="hasSidewalkId(3)" :expand="expandCustomizeSidewalk['3']" :sidewalkId="3" v-bind:key="'viewsidewalkListing3-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></review-lane-closure-request-block-sidewalk-listing>
									<review-lane-closure-request-block-sidewalk-listing v-show="!isEditingBlock" v-if="hasSidewalkId(4)" :expand="expandCustomizeSidewalk['4']" :sidewalkId="4" v-bind:key="'viewsidewalkListing4-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></review-lane-closure-request-block-sidewalk-listing>
									<review-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(1)" :expand="expandCustomizeBicycle['1']" :bicycleLaneId="1" v-bind:key="'viewbicycleListing1-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></review-lane-closure-request-block-bicycle-listing>
									<review-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(2)" :expand="expandCustomizeBicycle['2']" :bicycleLaneId="2" v-bind:key="'viewbicycleListing2-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></review-lane-closure-request-block-bicycle-listing>
									<review-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(3)" :expand="expandCustomizeBicycle['3']" :bicycleLaneId="3" v-bind:key="'viewbicycleListing3-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></review-lane-closure-request-block-bicycle-listing>
									<review-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(4)" :expand="expandCustomizeBicycle['4']" :bicycleLaneId="4" v-bind:key="'viewbicycleListing4-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></review-lane-closure-request-block-bicycle-listing>
									<review-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(5)" :expand="expandCustomizeBicycle['5']" :bicycleLaneId="5" v-bind:key="'viewbicycleListing5-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></review-lane-closure-request-block-bicycle-listing>
									<review-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(6)" :expand="expandCustomizeBicycle['6']" :bicycleLaneId="6" v-bind:key="'viewbicycleListing6-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></review-lane-closure-request-block-bicycle-listing>
									<review-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(7)" :expand="expandCustomizeBicycle['7']" :bicycleLaneId="7" v-bind:key="'viewbicycleListing7-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></review-lane-closure-request-block-bicycle-listing>
									<review-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(8)" :expand="expandCustomizeBicycle['8']" :bicycleLaneId="8" v-bind:key="'viewbicycleListing8-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></review-lane-closure-request-block-bicycle-listing>

									<review-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(9)" :expand="expandCustomizeBicycle['9']" :bicycleLaneId="9" v-bind:key="'viewbicycleListing8-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></review-lane-closure-request-block-bicycle-listing>
									<review-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(10)" :expand="expandCustomizeBicycle['10']" :bicycleLaneId="10" v-bind:key="'viewbicycleListing8-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></review-lane-closure-request-block-bicycle-listing>
									<review-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(11)" :expand="expandCustomizeBicycle['11']" :bicycleLaneId="11" v-bind:key="'viewbicycleListing8-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></review-lane-closure-request-block-bicycle-listing>
									<review-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(12)" :expand="expandCustomizeBicycle['12']" :bicycleLaneId="12" v-bind:key="'viewbicycleListing8-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></review-lane-closure-request-block-bicycle-listing>

									<b-row v-if="hasRestrictions()">
										<b-col class="mb-2">
											<div class="d-flex">
												<div class="lcr-summary__section-label">Turning Restrictions</div>
											</div>
										</b-col>
									</b-row>
									<review-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(1,1)" :expand="expandCustomizeRestriction['1,1']" :restrictionTypeId="1" :directionId="1" v-bind:key="'viewrestrictionListing1-1-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></review-lane-closure-request-block-restriction-listing>
									<review-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(1,2)" :expand="expandCustomizeRestriction['1,2']" :restrictionTypeId="1" :directionId="2" v-bind:key="'viewrestrictionListing1-2-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></review-lane-closure-request-block-restriction-listing>
									<review-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(1,3)" :expand="expandCustomizeRestriction['1,3']" :restrictionTypeId="1" :directionId="3" v-bind:key="'viewrestrictionListing1-3-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></review-lane-closure-request-block-restriction-listing>
									<review-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(1,4)" :expand="expandCustomizeRestriction['1,4']" :restrictionTypeId="1" :directionId="4" v-bind:key="'viewrestrictionListing1-4-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></review-lane-closure-request-block-restriction-listing>
									<review-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(2,1)" :expand="expandCustomizeRestriction['2,1']" :restrictionTypeId="2" :directionId="1" v-bind:key="'viewrestrictionListing2-1-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></review-lane-closure-request-block-restriction-listing>
									<review-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(2,2)" :expand="expandCustomizeRestriction['2,2']" :restrictionTypeId="2" :directionId="2" v-bind:key="'viewrestrictionListing2-2-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></review-lane-closure-request-block-restriction-listing>
									<review-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(2,3)" :expand="expandCustomizeRestriction['2,3']" :restrictionTypeId="2" :directionId="3" v-bind:key="'viewrestrictionListing2-3-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></review-lane-closure-request-block-restriction-listing>
									<review-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(2,4)" :expand="expandCustomizeRestriction['2,4']" :restrictionTypeId="2" :directionId="4" v-bind:key="'viewrestrictionListing2-4-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></review-lane-closure-request-block-restriction-listing>
									<review-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(3,1)" :expand="expandCustomizeRestriction['3,1']" :restrictionTypeId="3" :directionId="1" v-bind:key="'viewrestrictionListing3-1-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></review-lane-closure-request-block-restriction-listing>
									<review-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(3,2)" :expand="expandCustomizeRestriction['3,2']" :restrictionTypeId="3" :directionId="2" v-bind:key="'viewrestrictionListing3-2-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></review-lane-closure-request-block-restriction-listing>
									<review-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(3,3)" :expand="expandCustomizeRestriction['3,3']" :restrictionTypeId="3" :directionId="3" v-bind:key="'viewrestrictionListing3-3-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></review-lane-closure-request-block-restriction-listing>
									<review-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(3,4)" :expand="expandCustomizeRestriction['3,4']" :restrictionTypeId="3" :directionId="4" v-bind:key="'viewrestrictionListing3-4-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></review-lane-closure-request-block-restriction-listing>

									<b-row>
										<b-col class="mb-2">
											<div class="lcr-summary__section-label">More Information</div>
										</b-col>
									</b-row>
									<review-lane-closure-request-block-traffic-signals-altered :expand="expandTrafficSignalsAltered" v-show="!isEditingBlock" v-bind:key="'trafficSignalsAlteredListing-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></review-lane-closure-request-block-traffic-signals-altered>

									<b-row>
										<b-col>
											<div class="text-primary collapsible collapsed mb-4">
												<div class="collapsible-heading no-click p-0">
													<div class="d-flex bottom-border">
														<div class="w-60 collapsible-heading__title">Total Number of Lanes Closed at Same Time</div>
														<div v-if="laneClosureRequest.lanesClosedSameTime.value" class="bg-primary-x-light flex-grow-1 collapsible-heading__value">{{laneClosureRequest.lanesClosedSameTime.value|uppercase}}</div>
														<div v-if="laneClosureRequest.lanesClosedSameTime.value == null" class="bg-primary-x-light flex-grow-1 collapsible-heading__value">NOT ENTERED</div>
													</div>
												</div>
											</div>
										</b-col>
									</b-row>

									<b-row>
										<b-col>
											<div class="text-primary collapsible collapsed mb-4">
												<div class="collapsible-heading no-click p-0">
													<div class="d-flex bottom-border block-info-mobile">
														<div class="flex-grow-1  collapsible-heading__title" v-html="getTempTrafficControl">
														</div>
													</div>
												</div>
											</div>
										</b-col>
									</b-row>

									<b-row>
										<b-col>
											<div class="text-primary collapsible collapsed mb-4">
												<div class="collapsible-heading no-click p-0">
													<div class="d-flex bottom-border block-info-mobile">
														<div class="flex-grow-1 bg-secondary-light  collapsible-heading__value" v-html="getAcaText">
														</div>
													</div>
												</div>
											</div>
										</b-col>
									</b-row>


									<b-row v-if="laneClosureRequest.dczRequired.value == 1">
										<b-col>
											<div :class="expandDCZ ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
												<div class="collapsible-heading p-0">
													<div class="d-flex bottom-border">
														<div class="w-60 collapsible-heading__title" @click="onToggleExpandDCZ">Designated Construction Zone (DCZ)</div>
														<div class="flex-grow-1 bg-primary-x-light collapsible-heading__value" @click="onToggleExpandDCZ">{{getDczRequiredText(laneClosureRequest.dczRequired.value)|uppercase}}</div>
														<div class="bg-primary-x-light collapsible-heading__toggle" v-show="laneClosureRequest.dczRequired.value == 1">
															<b-button href="#" variant="collapsible" :class="expandDCZ ? '' : ' collapsed'" :aria-expanded="expandDCZ ? 'true' : 'false'" aria-controls="collapseDCZ" @click="onToggleExpandDCZ">
																<span class="when-opened">
																	<font-awesome-icon icon="chevron-down" />
																</span>
																<span class="when-closed">
																	<font-awesome-icon icon="chevron-right" />
																</span>
															</b-button>
														</div>
													</div>
												</div>
												<b-collapse class="collapse--content" id="collapseDCZ" :visible="expandDCZ">
													<b-col>
														<div v-show="laneClosureRequest.dczRequired.value == 1" class="lcr-summary__label">Construction Limits Change As Work Progresses</div>
														<div v-show="laneClosureRequest.dczRequired.value == 1" class="lcr-summary__value">{{laneClosureRequest.dczLimits.value||N/A}}</div>
														<div v-show="laneClosureRequest.dczRequired.value == 1" class="lcr-summary__label">Temporary Traffic Control Removed at end of Each Work Day</div>
														<div v-show="laneClosureRequest.dczRequired.value == 1" class="lcr-summary__value">{{getYesNoText(laneClosureRequest.dczTemporaryTcRemoved.value)}}</div>
														<div v-show="laneClosureRequest.dczRequired.value == 1" class="lcr-summary__label">Physical hazards when workers are not present</div>
														<div v-show="laneClosureRequest.dczRequired.value == 1" class="lcr-summary__value">{{laneClosureRequest.dczHazards.value||N/A}}</div>
														<div v-show="laneClosureRequest.dczRequired.value == 1" class="lcr-summary__label">Typical hours of work</div>
														<div v-show="laneClosureRequest.dczRequired.value == 1" class="lcr-summary__value">{{laneClosureRequest.dczHoursOfWork.value||N/A}}</div>
													</b-col>
												</b-collapse>
											</div>
										</b-col>
									</b-row>
									<b-row v-if="laneClosureRequest.dczRequired.value != 1">
										<b-col>
											<div class="text-primary collapsible collapsed">
												<div class="collapsible-heading no-click p-0">
													<div class="d-flex">
														<div class="w-60 collapsible-heading__title">Designated Construction Zone (DCZ)</div>
														<div class="flex-grow-1 bg-primary-x-light collapsible-heading__value" style="width:100px">{{getDczRequiredText(laneClosureRequest.dczRequired.value)|uppercase}}</div>
													</div>
												</div>
											</div>
										</b-col>
									</b-row>
									<b-row v-if="laneClosureRequest.transitAffected.value != null">
										<b-col>
											<div :class="expandTransit ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
												<div class="collapsible-heading">
													<div class="d-flex bottom-border">
														<div class="w-60 collapsible-heading__title" @click="onToggleExpandTransit">Transit</div>
														<div v-if="laneClosureRequest.transitAffected.value == 1" class="collapsible-heading__value bg-primary-x-light flex-grow-1" @click="onToggleExpandTransit">AFFECTED</div>
														<div v-if="laneClosureRequest.transitAffected.value != 1" class="collapsible-heading__value bg-secondary-light flex-grow-1" @click="onToggleExpandTransit">NOT AFFECTED</div>
														<div class="bg-primary-x-light collapsible-heading__toggle" v-show="laneClosureRequest.transitAffected.value == 1">
															<b-button href="#" variant="collapsible" :class="expandTransit ? '' : ' collapsed'" :aria-expanded="expandTransit ? 'true' : 'false'" aria-controls="collapseTransit" @click="onToggleExpandTransit">
																<span class="when-opened">
																	<font-awesome-icon icon="chevron-down" />
																</span>
																<span class="when-closed">
																	<font-awesome-icon icon="chevron-right" />
																</span>
															</b-button>
														</div>
													</div>
												</div>
												<b-collapse class="collapse--content" id="collapseTransit" :visible="expandTransit">
													<b-col>
														<div class="lcr-summary__label" v-show="laneClosureRequest.transitAffected.value == 1">Transit Is Affected</div>
														<div class="lcr-summary__label" v-show="laneClosureRequest.transitAffected.value != 1">Transit Not Affected</div>
														<div v-for="t in laneClosureRequest.transit.value" v-bind:key="'transit'+t.transitEffectId" class="lcr-summary__value">{{LaneClosureRequest.getTransitText(t.transitEffectId)}}</div>
														<div class="lcr-summary__value">{{laneClosureRequest.transitOther.value}}</div>
														<div class="lcr-summary__label mt-2" v-show="laneClosureRequest.transitAffected.value == 1">Bus Stop Numbers</div>
														<div class="lcr-summary__value" v-show="laneClosureRequest.transitAffected.value == 1">{{laneClosureRequest.transitStopNumbers.value}}</div>
													</b-col>
												</b-collapse>
											</div>
										</b-col>
									</b-row>
									<b-row>
										<b-col>
											<div class="text-primary collapsible collapsed mb-4">
												<div class="collapsible-heading no-click p-0">
													<div class="d-flex bottom-border">
														<div class="w-60 collapsible-heading__title">Paid Parking</div>
														<div v-if="laneClosureRequest.paidParkingAffected.value == 1" class="flex-grow-1 bg-primary-x-light  collapsible-heading__value">AFFECTED</div>
														<div v-if="laneClosureRequest.paidParkingAffected.value != 1" class="flex-grow-1 bg-secondary-light  collapsible-heading__value">NOT AFFECTED</div>
													</div>
												</div>
											</div>
										</b-col>
									</b-row>
									<b-row>
										<b-col>
											<div :class="expandParking ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
												<div class="collapsible-heading p-0">
													<div class="d-flex bottom-border">
														<div class="w-60 collapsible-heading__title" v-if="laneClosureRequest.parkingRemovalId.value != 2" @click="onToggleExpandParking">Parking Removal</div>
														<div class="w-60 collapsible-heading__title" v-if="laneClosureRequest.parkingRemovalId.value == 2">Parking Removal</div>														
														<div @click="onToggleExpandParking" v-if="laneClosureRequest.parkingRemovalId.value == 1" class="flex-grow-1 bg-primary-x-light  collapsible-heading__value">YES, TRAFFIC SERVICES</div>
														<div v-if="laneClosureRequest.parkingRemovalId.value == 2" class="flex-grow-1 bg-primary-x-light  collapsible-heading__value">NO</div>
														<div @click="onToggleExpandParking" v-if="laneClosureRequest.parkingRemovalId.value == 3" class="flex-grow-1 bg-primary-x-light  collapsible-heading__value">STREETS AND URBAN FORESTRY</div>
														<div @click="onToggleExpandParking" v-if="laneClosureRequest.parkingRemovalId.value == 4" class="flex-grow-1 bg-primary-x-light  collapsible-heading__value">FILM AND SPECIAL EVENTS OFFICE</div>
														<div @click="onToggleExpandParking" v-if="laneClosureRequest.parkingRemovalId.value == 5" class="flex-grow-1 bg-primary-x-light  collapsible-heading__value">YES, AUTHORIZED CONSTRUCTION AGENCY OR 3RD PARTY</div>
														<div class="bg-primary-x-light collapsible-heading__toggle" v-show="laneClosureRequest.parkingRemovalId.value != 2">
															<b-button href="#" variant="collapsible" :class="expandParking ? '' : ' collapsed'" :aria-expanded="expandParking ? 'true' : 'false'" aria-controls="collapseParking" @click="onToggleExpandParking">
																<span class="when-opened">
																	<font-awesome-icon icon="chevron-down" />
																</span>
																<span class="when-closed">
																	<font-awesome-icon icon="chevron-right" />
																</span>
															</b-button>
														</div>
													</div>
												</div>
												<b-collapse class="collapse--content" id="collapseParking" :visible="expandParking">
													<!-- 
													<b-col>
														<div v-for="(l, index) in laneClosureRequest.parkingLane.value" class="lcr-summary__value" :key="'cc'+index">
															{{getParkingLaneRemovedText(l.laneId)}}
														</div>
														<div v-if="laneClosureRequest.parkingRemovalMetres.value">{{laneClosureRequest.parkingRemovalMetres.value}} metres to remove</div>
														<div v-if="laneClosureRequest.parkingStartAddress.value">Starting Point for Parking Removal: {{laneClosureRequest.parkingStartAddress.value}}</div>
														<div v-if="laneClosureRequest.parkingEndAddress.value">Ending Point for Parking Removal: {{laneClosureRequest.parkingEndAddress.value}}</div>
													</b-col>
													-->

													<ReviewLaneClosureRequestParkingRemovalListing
														:renderCounter="renderCounter"
														:parkingRemovalList="laneClosureRequest.parkingRemoval"
													></ReviewLaneClosureRequestParkingRemovalListing>
												</b-collapse>
											</div>
										</b-col>
									</b-row>
									<b-row>
										<b-col>
											<div class="text-primary collapsible collapsed">
												<div class="collapsible-heading no-click p-0">
													<div class="d-flex bottom-border">
														<div class="w-60 collapsible-heading__title">Work Done For</div>
														<div class="collapsible-heading__value bg-primary-x-light flex-grow-1" v-html="getWorkDoneForText(laneClosureRequest.workDoneForNamePath.value)"></div>
													</div>
												</div>
											</div>
										</b-col>
									</b-row>
									<b-row>
										<b-col>
											<div class="text-primary collapsible collapsed">
												<div class="collapsible-heading no-click p-0">
													<div class="d-flex bottom-border">
														<div class="w-60 collapsible-heading__title">Bid Opportunity Number</div>
														<div class="collapsible-heading__value bg-primary-x-light flex-grow-1">{{laneClosureRequest.projectBidNumber.value}}</div>
													</div>
												</div>
											</div>
										</b-col>
									</b-row>
									<b-row>
										<b-col>
											<div class="text-primary collapsible collapsed">
												<div class="collapsible-heading no-click p-0">
													<div class="d-flex bottom-border block-info-mobile">
														<div class="w-60 collapsible-heading__title">City Administrator</div>
														<div class="collapsible-heading__value bg-primary-x-light flex-grow-1" v-html="getBidAdmin()"></div>
													</div>
												</div>
											</div>
										</b-col>
									</b-row>
									<b-row v-show="laneClosureRequest.workDoneForIdPath.isCoWFSEO()">
										<b-col>
											<div class="text-primary collapsible collapsed">
												<div class="collapsible-heading  no-click p-0">
													<div class="d-flex bottom-border">
														<div class="w-60 collapsible-heading__title">City of Winnipeg Film and Special Events Office Identifier</div>
														<div class="collapsible-heading__value bg-primary-x-light flex-grow-1">{{laneClosureRequest.wfseoControlCode.value}}</div>
													</div>
												</div>
											</div>
										</b-col>
									</b-row>
									<b-row v-show="laneClosureRequest.workDoneForIdPath.isCoWFSEO()">
										<b-col>
											<div class="text-primary collapsible collapsed">
												<div class="collapsible-heading  no-click p-0">
													<div class="d-flex bottom-border">
														<div class="w-60 collapsible-heading__title">Permit Request Information</div>
														<div class="collapsible-heading__value bg-primary-x-light flex-grow-1">{{laneClosureRequest.wfseoPermitRequestInfo.value}}</div>
													</div>
												</div>
											</div>
										</b-col>
									</b-row>
									<b-row>
										<b-col>
											<div :class="expandPermit ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
												<div class="collapsible-heading p-0">
													<div class="d-flex bottom-border">
														<div class="w-60 collapsible-heading__title" @click="onToggleExpandPermit">Permit</div>
														<div @click="onToggleExpandPermit" v-if="laneClosureRequest.permitRequired.value == 1" class="bg-primary-x-light flex-grow-1 collapsible-heading__value">REQUIRED</div>
														<div @click="onToggleExpandPermit" v-if="laneClosureRequest.permitRequired.value != 1" class="bg-primary-x-light flex-grow-1 collapsible-heading__value">NOT REQUIRED</div>
														<div class="bg-primary-x-light collapsible-heading__toggle" v-show="laneClosureRequest.permitRequired.value == 1">
															<b-button href="#" variant="collapsible" :class="expandPermit ? '' : 'collapsed'" :aria-expanded="expandPermit ? 'true' : 'false'" aria-controls="collapsePermit" @click="onToggleExpandPermit">
																<span class="when-opened">
																	<font-awesome-icon icon="chevron-down" />
																</span>
																<span class="when-closed">
																	<font-awesome-icon icon="chevron-right" />
																</span>
															</b-button>
														</div>
													</div>
												</div>
												<b-collapse class="collapse--content" id="collapsePermit" :visible="expandPermit">
													<b-col>
														<b-row v-show="laneClosureRequest.permitRequired.value == 1">
															<b-col class="mb-3">
																<div class="lcr-summary__label">Liability Insurance</div>
																<div class="lcr-summary__value">{{LaneClosureRequest.getYesNoText(laneClosureRequest.permitLiabilityInsurance.value)}}</div>
															</b-col>
														</b-row>
														<b-row v-show="laneClosureRequest.permitRequired.value == 1 && 1 == 2">
															<b-col class="mb-3">
																<div class="lcr-summary__label">Nearest Street Number TO Affected Closure Area</div>
																<div class="lcr-summary__value">{{laneClosureRequest.permitNearestStreetNumber.value}}</div>
															</b-col>
														</b-row>
														<b-row v-show="laneClosureRequest.permitRequired.value == 1">
															<b-col class="mb-3">
																<div class="lcr-summary__label">Total length of affected ROADWAY</div>
																<div class="lcr-summary__value">{{laneClosureRequest.permitRoadwayMetres.value}} metres</div>
															</b-col>
														</b-row>
														<b-row v-show="laneClosureRequest.permitRequired.value == 1">
															<b-col class="mb-3">
																<div class="lcr-summary__value">Measured From: {{laneClosureRequest.permitRoadwayFrom.value}}</div>
																<div class="lcr-summary__value">Measured To: {{laneClosureRequest.permitRoadwayTo.value}}</div>
															</b-col>
														</b-row>
														<b-row v-show="laneClosureRequest.permitRequired.value == 1">
															<b-col class="mb-3">
																<div class="lcr-summary__label">SIDEWALK</div>
																<div class="lcr-summary__value">Measured From: {{laneClosureRequest.permitSidewalkFrom.value}}</div>
																<div class="lcr-summary__value">Measured To: {{laneClosureRequest.permitSidewalkTo.value}}</div>
																<div class="lcr-summary__value">Length: {{laneClosureRequest.permitSidewalkMetres.value}} m</div>
															</b-col>
														</b-row>
														<b-row v-show="laneClosureRequest.permitRequired.value == 1 && laneClosureRequest.permitRequests.value">
															<b-col class="mb-3">
																<div class="lcr-summary__label">Additional Relevant Information Provided</div>
																<div class="lcr-summary__value">{{laneClosureRequest.permitRequests.value}}</div>
															</b-col>
														</b-row>
														<b-row v-show="laneClosureRequest.permitRequired.value == 1">
															<b-col class="mb-3">
																<div class="lcr-summary__label" v-show="laneClosureRequest.crossingPermitRequired.value == 1">Crossing Permit Required</div>
																<div class="lcr-summary__label" v-show="laneClosureRequest.crossingPermitRequired.value != 1">No Crossing Permit Required</div>
															</b-col>
														</b-row>
														<b-row v-show="laneClosureRequest.crossingPermitRequired.value == 1">
															<b-col class="mb-3">
																<div class="lcr-summary__label">Crossing the sidewalk / boulevard / curb Area</div>
																<div class="lcr-summary__value">{{laneClosureRequest.crossingPermitLocation.value}}</div>
															</b-col>
														</b-row>
														<b-row v-show="laneClosureRequest.crossingPermitRequired.value == 1">
															<b-col class="mb-3">
																<div class="lcr-summary__label">Type of Equipment used while crossing the area</div>
																<div class="lcr-summary__value">{{laneClosureRequest.crossingPermitEquipment.value}}</div>
															</b-col>
														</b-row>
													</b-col>
												</b-collapse>
											</div>
										</b-col>
									</b-row>

								</b-col> <!-- End of left column -->
								<b-col lg="5" class="lcr-summary__right-column">
									<b-row class="row-lcr-summary pt-2 pb-2">
										<b-col>
											<div class="lcr-summary__label">Requester</div>
											<div class="lcr-summary__value">
												<div v-if="laneClosureRequest.requester" class="contact">
													<div class="contact__name"><a :href="emailHref(laneClosureRequest.requester.email)">{{laneClosureRequest.requester.firstName}} {{laneClosureRequest.requester.lastName}}</a></div>
													<template v-for="(org, i) in getOrganizationTreeList(laneClosureRequest.requester)">
														<div class="contact__organization" :key="i">{{org}}</div>
													</template>
													<div v-show="laneClosureRequest.requester.phone" class="contact__phone">{{laneClosureRequest.requester.phone}}</div>
												</div>
												<div v-for="contact in laneClosureRequest.altRequester" v-bind:key="'c'+contact.userId" class="contact">
													<div class="contact__name"><a :href="emailHref(contact.email)">{{contact.firstName}} {{contact.lastName}}</a></div>
													<template v-for="(org, i) in getOrganizationTreeList(contact)">
														<div class="contact__organization" :key="i">{{org}}</div>
													</template>
													<div v-show="contact.phone" class="contact__phone">{{contact.phone}}</div>
												</div>
											</div>
										</b-col>
										<b-col>
											<div class="lcr-summary__label">Approver</div>
											<div class="lcr-summary__value">
												<div v-if="laneClosureRequest.owner" class="contact">
													<div class="contact__name"><a :href="emailHref(laneClosureRequest.owner.email)">{{laneClosureRequest.owner.firstName}} {{laneClosureRequest.owner.lastName}}</a></div>
													<template v-for="(org, i) in getOrganizationTreeList(laneClosureRequest.owner)">
														<div class="contact__organization" :key="i">{{org}}</div>
													</template>
													<div v-show="laneClosureRequest.owner.phone" class="contact__phone">{{laneClosureRequest.owner.phone}}</div>
												</div>
												<div v-else>N/A</div>
											</div>
										</b-col>
									</b-row>
									<b-row class="row-lcr-summary pb-2 pt-2 review-contact">
										<b-col class="">
											<div class="lcr-summary__label">Closure Reporter</div>
											<div class="lcr-summary__value">
												<div v-if="laneClosureRequest.closureReporter" class="contact">
													<div class="contact__name"><a :href="emailHref(laneClosureRequest.closureReporter.email)">{{laneClosureRequest.closureReporter.firstName}} {{laneClosureRequest.closureReporter.lastName}}</a></div>
													<template v-for="(org, i) in getOrganizationTreeList(laneClosureRequest.closureReporter)">
														<div class="contact__organization" :key="i">{{org}}</div>
													</template>
													<div v-show="laneClosureRequest.closureReporter.phone" class="contact__phone">{{laneClosureRequest.closureReporter.phone}}</div>
												</div>
												<div v-else>
													N/A
												</div>
												<div v-for="contact in laneClosureRequest.altClosureReporter" v-bind:key="'c'+contact.userId" class="contact">
													<div class="contact__name"><a :href="emailHref(contact.email)">{{contact.firstName}} {{contact.lastName}}</a></div>
													<template v-for="(org, i) in getOrganizationTreeList(contact)">
														<div class="contact__organization" :key="i">{{org}}</div>
													</template>
													<div v-show="contact.phone" class="contact__phone">{{contact.phone}}</div>
												</div>
											</div>
										</b-col>
										<b-col>
											<div class="lcr-summary__label">Restrictions Reporter</div>
											<div class="lcr-summary__value">
												<div v-if="laneClosureRequest.restrictionReporter" class="contact">
													<div class="contact__name"><a :href="emailHref(laneClosureRequest.restrictionReporter.email)">{{laneClosureRequest.restrictionReporter.firstName}} {{laneClosureRequest.restrictionReporter.lastName}}</a></div>
													<template v-for="(org, i) in getOrganizationTreeList(laneClosureRequest.restrictionReporter)">
														<div class="contact__organization" :key="i">{{org}}</div>
													</template>
													<div v-show="laneClosureRequest.restrictionReporter.phone" class="contact__phone">{{laneClosureRequest.restrictionReporter.phone}}</div>
												</div>
												<div v-else>
													N/A
												</div>
												<div v-for="contact in laneClosureRequest.altRestrictionReporter" v-bind:key="'c'+contact.userId" class="contact">
													<div class="contact__name"><a :href="emailHref(contact.email)">{{contact.firstName}} {{contact.lastName}}</a></div>
													<template v-for="(org, i) in getOrganizationTreeList(contact)">
														<div class="contact__organization" :key="i">{{org}}</div>
													</template>
													<div v-show="contact.phone" class="contact__phone">{{contact.phone}}</div>
												</div>
											</div>
										</b-col>
									</b-row>
								</b-col>
							</b-row>
						</tab-content>
						<template slot="footer" slot-scope="props">
							<div class="wizard-footer-left">
								<b-button v-if="!$store.state.isMobile" class="mr-3" variant="light" @click="onBackToList()">Cancel</b-button>
								<b-button variant="light" v-if="props.activeTabIndex > 0" @click="props.prevTab()">Previous</b-button>
							</div>
							<div class="wizard-footer-middle">
								&nbsp;
							</div>
							<div class="wizard-footer-right">
								<b-button v-if="$store.state.isMobile && !props.isLastStep" variant="light" @click="props.nextTab()">Next</b-button>
								<b-button v-if="!$store.state.isMobile && !props.isLastStep" variant="secondary" class="mr-2"  @click="props.nextTab()">Next</b-button>

								<b-button :disabled="isButtonDisabled" v-if="props.isLastStep" class="btn-save" variant="primary" @click="onSubmit"><b-spinner small label="Saving..." class="mr-2" v-if="saving"></b-spinner><span v-if="!saving" class="btn__icon"><img src="/img/assets/icon-checkmark.svg"/></span><span class="btn__text">Finish</span>

								</b-button>
							</div>
						</template>
					</form-wizard>
				</b-form>


				<b-modal centered @shown="focusAddRestrictionDataModal" id="block-list-add-restriction-modal" title="Enter Street / Location Name" size="lg" v-model="showAddRestrictionDataModal" @ok="onBlockListAddRestrictionModalConfirm()">
					<b-row>
						<b-col>
							<p class="is-size-6">{{ $t('messages.enterTurningRestrictionStreetName') }}</p>
							<b-form-group :label="getAddRestrictionBlockText()" label-for="input-restriction-street-name" :state="restrictionCrossStreet.status" :invalid-feedback="restrictionCrossStreet.invalidMessage">
								<b-form-input ref="restrictionCrossStreet" id="input-restriction-street-name" placeholder="Enter restriction" v-model="restrictionCrossStreet.value" :state="restrictionCrossStreet.status" />
							</b-form-group>
						</b-col>
					</b-row>
					<template v-slot:modal-footer="{ ok }">
						<b-button variant="primary"  type="button" @click="onBlockListAddRestrictionModalConfirm">{{$t('labels.add')}} <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button>
						<b-button variant="secondary"  type="button" @click="onBlockListAddRestrictionModalCancel">{{$t('labels.cancel')}}</b-button>
					</template>
				</b-modal>
				<b-modal centered id="form-error-modal" title="More Information Required" size="lg" v-model="showWizardErrorModal" @ok="modalWizardOnCancel(null)">
					<template v-if="presetErrorLines.length == 0">
						<p class="is-size-6">{{errorMsg}}</p>
					</template>
					<template v-if="presetErrorLines.length > 0">
						<p class="is-size-6">You must select at least one block to close or restrict turnings for the following:</p>

						<ul class="" v-if="presetErrorLines.length > 0">
							<li v-for="line in presetErrorLines" v-html="line" v-bind:key="'errormodalline'+Math.random()"></li>
						</ul>
					</template>
					<template v-slot:modal-footer="{ ok }">
						<b-button class="mr-2 mt-2" v-if="hasErrorSubmitter" @click="modalWizardOnCancel(1)">Errors in Submitter</b-button>
						<b-button class="mr-2 mt-2" v-if="hasErrorClosures" @click="modalWizardOnCancel(2)">Errors in Closures and Restrictions</b-button>
						<b-button class="mr-2 mt-2" v-if="hasErrorDCZ" @click="modalWizardOnCancel(3)">Errors in DCZ, Transit, Parking</b-button>
						<b-button class="mr-2 mt-2" v-if="hasErrorPermit" @click="modalWizardOnCancel(4)">Errors in Permit</b-button>
					</template>
				</b-modal>
				<!-- leaving page -->
				<b-modal centered id="unsaved-changes-error-modal" title="Unsaved Changes" size="lg" v-model="showUnsavedChangesModal" @ok="modalOnCancel()">
					<p class="is-size-6">{{ $t('messages.unsavedChanges') }}</p>
					<template v-slot:modal-footer="{ ok }">
						<!-- <b-button variant="primary"  type="button" @click="modalOnSave">{{$t('labels.save')}} <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button> -->
						<b-button variant="danger" type="button" @click="modalOnLeave">{{$t('labels.leaveAnyway')}}</b-button>
						<b-button variant="secondary" type="button" @click="modalOnCancel">{{$t('labels.stay')}}</b-button>
					</template>
				</b-modal>

				<b-modal centered id="remove-all-street-blocks-modal" title="Remove All Street Blocks?" size="lg" v-model="showRemoveAllBlocksModal" @ok="modalOnRemoveAllBlocks()">
					<p class="is-size-6">{{ $t('messages.removeAllBlocks') }}</p>
					<template v-slot:modal-footer="{ ok }">
						<!-- <b-button variant="primary"  type="button" @click="modalOnSave">{{$t('labels.save')}} <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button> -->
						<b-button variant="secondary"  type="button" @click="modalOnRemoveAllBlocksCancel">Cancel</b-button>
						<b-button variant="danger" type="button" @click="modalOnRemoveAllBlocks">Remove All Blocks</b-button>
					</template>
				</b-modal>

				<b-modal no-close-on-backdrop centered id="temp-traffic-control-modal" title="Note" size="lg" v-model="showTempTrafficControlModal" ok-title="Yes" @ok="modalOnConfirmTrafficControl()">
					<b-row>
						<b-col>
							<p>Traffic Services may require two (2) weeks' notice if contracted to setup and maintain a work zone.</p>
						</b-col>
					</b-row>
					<template v-slot:modal-footer="{ ok }">
						<b-button variant="danger" type="button" @click="modalOnConfirmTrafficControl">Yes, please use Traffic Services</b-button>
						<b-button variant="secondary"  type="button" @click="modalOnCancelTrafficControl">No, we don't need to.</b-button>
					</template>
				</b-modal>

				<b-modal centered id="no-blocks-modal" title="Please select blocks" size="lg" v-model="showNoBlocksModal" ok-title="Yes" @ok="modalOnConfirmShowMap()">
					<b-row>
						<b-col>
							<p>The system was not able to find street blocks for <strong>{{laneClosureRequest.affectedStreet.value}} {{LaneClosureRequest.getDirectionAbbreviationText(laneClosureRequest.directionId.value)}}</strong> between <strong>{{laneClosureRequest.firstCrossStreet.value}}</strong> and <strong>{{laneClosureRequest.lastCrossStreet.value}}</strong>.</p>
							<p>Please open the map and click on the affected street blocks.</p>
						</b-col>
					</b-row>
					<template v-slot:modal-footer="{ ok }">
						<b-button variant="primary" type="button" @click="modalOnConfirmShowMap">Show Map</b-button>
						<b-button variant="secondary"  type="button" @click="modalOnConfirmNotShowMap">Cancel</b-button>
					</template>
				</b-modal>

				<b-modal no-close-on-backdrop centered id="no-blocks-modal" title="Confirm Selected Streets" size="lg" v-model="showConfirmBlocksModal" ok-title="Yes" @ok="modalOnConfirmShowMap()"  @cancel="modalOnConfirmShowMap()" @close="modalOnConfirmShowMap()">
					<b-row>
						<b-col>
							<p>Please confirm that the street blocks selected for this lane closure request are correct.</p>
							<p>Click on the map to add or remove blocks.</p>
						</b-col>
					</b-row>
					<template v-slot:modal-footer="{ ok }">
						<b-button variant="primary" type="button" @click="modalOnConfirmShowMap">Show Map</b-button>
					</template>
				</b-modal>

				<b-modal centered id="preset-block-error-modal" title="Closures/Restriction Problem" size="lg" v-model="showPresetErrorModal" ok-title="Yes" @ok="presetErrorModalOkClick()">
					<b-row>
						<b-col>
							<p>Could not apply lane closure / restriction settings.</p>
							<p>Please check the highlighted fields.</p>
						</b-col>
					</b-row>
					<template v-slot:modal-footer="{ ok }">
						<b-button variant="primary" @click="ok()">Ok</b-button>
					</template>
				</b-modal>
				<b-modal centered id="protected-bike-lane-modal" title="Warning" size="lg" v-model="showProtectedBikeLaneModal" ok-title="Yes" cancel-title="No" @ok="protectedBikeLaneModalOkClick()">
					<p>Closing a protected bike lane requires a protected bike detour. Please check the traffic control manual for more information.</p>
					<template v-slot:modal-footer="{ ok }">
						<b-button variant="primary" @click="ok()">Ok</b-button>
					</template>
				</b-modal>
				<b-modal centered id="time-conflict-modal" :title="timeConflictTitle()" size="lg" v-model="showTimeConflictModal" ok-title="Yes" @ok="timeConflictModalOkClick()" no-close-on-esc no-close-on-backdrop hide-header-close>
					<b-row v-if="conflictingLaneClosureRequest.conflictType.value == 'duration'">
						<b-col>
								<p>The street blocks you have chosen conflicts with the following lane closure request during the dates you have specified.</p>
								<p><strong>{{conflictingLaneClosureRequest.affectedStreet.value}} between {{conflictingLaneClosureRequest.firstCrossStreet.value}} and {{conflictingLaneClosureRequest.lastCrossStreet.value}} closed for {{LaneClosureRequest.getNatureOfWorkTextEffect(conflictingLaneClosureRequest.natureOfWorkId.value)}}.</strong><br />
									<strong>{{Format.toLocalDateTime(conflictingLaneClosureRequest.fromDate.value, 'MMMM D, Y H:mm')}} to {{Format.toLocalDateTime(conflictingLaneClosureRequest.toDate.value, 'MMMM D, Y H:mm')}}</strong></p>
									<p>We recommend starting the closure at least 3 business days after the conflicting request. Request may be denied, otherwise.</p>
									<p>The new Requested Start and Completion Dates are below.</p>
								</b-col>
							</b-row>
							<b-row v-if="conflictingLaneClosureRequest.conflictType.value == 'adjacent_start_date'">
								<b-col>
									<p>The start time of closure is within 3 business days of the end date for the following existing lane closure request:</p>
									<p><strong>{{conflictingLaneClosureRequest.affectedStreet.value}} between {{conflictingLaneClosureRequest.firstCrossStreet.value}} and {{conflictingLaneClosureRequest.lastCrossStreet.value}} closed for {{LaneClosureRequest.getNatureOfWorkTextEffect(conflictingLaneClosureRequest.natureOfWorkId.value)}}.</strong><br />
										<strong>{{Format.toLocalDateTime(conflictingLaneClosureRequest.fromDate.value, 'MMMM D, Y H:mm')}} to {{Format.toLocalDateTime(conflictingLaneClosureRequest.toDate.value, 'MMMM D, Y H:mm')}}</strong></p>
										<p>We recommend placing a 3 business day gap between the end date of the request in conflict and the start date of your lane closure request. Request may be denied, otherwise.</p>
									</b-col>
								</b-row>
								<b-row v-if="conflictingLaneClosureRequest.conflictType.value == 'adjacent_end_date'">
									<b-col>
										<p>The completion date of this closure is within 3 business days of the start date for the following existing lane closure request:</p>
										<p><strong>{{conflictingLaneClosureRequest.affectedStreet.value}} between {{conflictingLaneClosureRequest.firstCrossStreet.value}} and {{conflictingLaneClosureRequest.lastCrossStreet.value}} closed for {{LaneClosureRequest.getNatureOfWorkTextEffect(conflictingLaneClosureRequest.natureOfWorkId.value)}}.</strong><br />
											<strong>{{Format.toLocalDateTime(conflictingLaneClosureRequest.fromDate.value, 'MMMM D, Y H:mm')}} to {{Format.toLocalDateTime(conflictingLaneClosureRequest.toDate.value, 'MMMM D, Y H:mm')}}</strong></p>
											<p>We recommend placing a 3 business day gap between the end date of your request and the start date of the request in conflict. Request may be denied, otherwise.</p>
										</b-col>
									</b-row>
									<b-row>
										<b-col sm="12">
											<b-row>
												<b-col sm="12" lg="6">
													<b-form-group id="ig-equest-start-date" label="Requested Start Date" label-for="input-equest-start-date" :state="conflictingLaneClosureRequest.newFromDate.status" :invalid-feedback="conflictingLaneClosureRequest.newFromDate.invalidMessage">
														<date-picker bootstrap-styling id="input-request-start-date" format="MM/dd/yyyy" v-model="conflictingNewFromDatePicker" :input-class="{'is-invalid': conflictingLaneClosureRequest.newFromDate.status == false}" @input="conflictingLaneClosureRequest.newFromDate.resetStatus(); hasShownStartDateInPastModal = false; checkLessThanTwoHours();" :typeable="true" :placeholder="'mm/dd/yyyy'"></date-picker>
													</b-form-group>
												</b-col>
												<b-col sm="12" lg="6">
													<b-form-group id="ig-request-start-time" label="Requested Start Time" label-for="input-request-start-time" :state="conflictingLaneClosureRequest.newFromTime.status" :invalid-feedback="conflictingLaneClosureRequest.newFromTime.invalidMessage">
														<bootstrap-text-time-picker ref="refNewTimeFrom" v-model="newFromTime.value"></bootstrap-text-time-picker>
													</b-form-group>
												</b-col>
											</b-row>
										</b-col>
										<b-col sm="12">
											<b-row>
												<b-col sm="12" lg="6">
													<b-form-group id="ig-eta-end-date" label="Estimated Completion Date" label-for="input-eta-end-date" :state="conflictingLaneClosureRequest.newToDate.status" :invalid-feedback="conflictingLaneClosureRequest.newToDate.invalidMessage">
														<!-- <b-form-input id="input-eta-end-date" type="text" v-model="conflictingLaneClosureRequest.newToDate"></b-form-input> -->
														<date-picker bootstrap-styling id="input-eta-end-date" format="MM/dd/yyyy" v-model="conflictingNewToDatePicker" :disabled-dates="disableConflictingEndDate" :input-class="{'is-invalid': conflictingLaneClosureRequest.newToDate.status == false}" @input="conflictingLaneClosureRequest.newToDate.resetStatus(); hasShownStartDateInPastModal = false; checkLessThanTwoHours();" :typeable="true" :placeholder="'mm/dd/yyyy'"></date-picker>
													</b-form-group>
												</b-col>
												<b-col sm="12" lg="6">
													<b-form-group id="ig-eta-end-time" label="Estimated Completion Time" label-for="input-eta-end-time" :state="conflictingLaneClosureRequest.newToTime.status" :invalid-feedback="conflictingLaneClosureRequest.newToTime.invalidMessage">
														<bootstrap-text-time-picker ref="refNewTimeTo" v-model="newToTime.value"></bootstrap-text-time-picker>
													</b-form-group>
												</b-col>
											</b-row>
										</b-col>
									</b-row>
									<template v-slot:modal-footer="{ ok }">
										<b-button variant="primary" @click="ok()">Set New Start and Completion Dates</b-button>
										<b-button variant="secondary" @click="timeConflictModalIgnoreClick()">Keep My Original Dates</b-button>
										<b-button variant="secondary" @click="showTimeConflictModal=false">Cancel</b-button>
									</template>
								</b-modal>
								<b-modal centered id="non-regional-street-modal" title="Regional Street Not Selected" size="lg" v-model="showNonRegionalStreetModal" ok-title="Yes" @ok="nonRegionalStreetModalOkClick()">
									<b-row>
										<b-col>
											<p>The block you have selected is not part of a regional street, so a lane closure request is not required.</p>
											<p>If your lane closure request will include a regional street, select the regional street first.</p>
										</b-col>
									</b-row>
									<template v-slot:modal-footer="{ ok }">
										<b-button variant="primary" @click="ok()">Choose a Different Block</b-button>
									</template>
								</b-modal>
								<b-modal centered id="start-date-in-past-modal" title="Notice" size="lg" v-model="showStartDateInPastModal" ok-title="Yes" cancel-title="No" @ok="startDateInPastModalOkClick()">
									<p>Please note that a lane closure request must be made a minimum of 3 business days in advance of closure.</p>
									<template v-slot:modal-footer="{ ok }">
										<b-button variant="primary" @click="ok()">Ok</b-button>
									</template>
								</b-modal>
								<b-modal centered id="dates-reversed" title="Warning" size="lg" v-model="showErrorReversedDates" ok-title="OK" type="info" ok-only @ok="showErrorReversedDates = false">
									<p><strong>Estimated Completion Date cannot be before Start Date</strong>
										<ul>
											<li>Please adjust your start or completion date.</li>
										</ul>
									</p>
								</b-modal>

								<b-modal centered id="times-reversed" title="Warning" size="lg" v-model="showErrorReversedTimes" ok-title="OK" type="info" ok-only @ok="showErrorReversedTimes = false">
									<p><strong>Estimated Completion Time cannot be before Start Time when the request is for one day.</strong>
										<ul>
											<li>Please adjust your start or completion time.</li>
										</ul>
									</p>
								</b-modal>

								<b-modal centered id="longer-than-two-hours-modal" title="Warning" size="lg" v-model="showErrorTwoHourTooLongModal" ok-title="OK" type="info" ok-only @ok="showErrorTwoHourTooLongModal = false">
									<p><strong>Your start and completion times must not be greater than 2 hours apart.</strong>
										<ul>
											<li>Please adjust your Start or Completion time(s) or select No for Less Than 2 Hours.</li>
										</ul>
									</p>
								</b-modal>

								<b-modal centered id="diff-day-two-hours-modal" title="Warning" size="lg" v-model="showErrorTwoHourModal" ok-title="OK" type="info" ok-only @ok="showErrorTwoHourModal = false">
									<p><strong>Your start and completion dates must be on the same day when your request takes less than two hours.</strong>
										<ul>
											<li>Please adjust your Start or Completion date(s) or select No for Less Than 2 Hours.</li>
										</ul>
									</p>
								</b-modal>
								<b-modal centered id="less-than-two-hours-modal" title="Warning" size="lg" v-model="showLessThanTwoHourModal" ok-title="Yes" cancel-title="No" @ok="lessThanTwoHoursModalOkClick()">
									<p>{{lessThanTwoHourModalp1}}</p>
									<p>{{lessThanTwoHourModalp2}}</p>
								</b-modal>
								<b-modal centered id="new-project-modal" title="Create New Project" size="lg" v-model="showNewProjectModal" ok-title="Create Project" cancel-title="Cancel" @ok="showNewProjectModalOkClick()" @cancel="closeNewProjectModal()">
									<b-form-group label="New Project Name">
										<b-form-input id="input-new-project-name" v-model="newProject.name.value" placeholder="Other" :state="newProject.name.status" @input="newProject.name.resetStatus()" inline></b-form-input>
									</b-form-group>
								</b-modal>
								<b-modal centered id="edit-project-modal" title="Edit Project" size="lg" v-model="showEditProjectModal" ok-title="Rename Project" cancel-title="Cancel" @ok="showEditProjectModalOkClick()">
									<b-form-group label="Project Name">
										<b-form-input  maxlength="150" id="input-edit-project-name" v-model="editProject.name.value" placeholder="Other" :state="editProject.name.status" @input="editProject.name.resetStatus()" inline></b-form-input>
									</b-form-group>
									<template v-slot:modal-footer="footerScope">
										<b-button variant="light" @click="RestoreProject" v-if="editProject != null && editProject.isActive.value == 0">Restore</b-button>
										<b-button variant="light" @click="ArchiveProject" v-else>Archive</b-button>
										<b-button variant="secondary" @click="footerScope.cancel">Cancel</b-button>
										<b-button variant="primary" @click="footerScope.ok">Rename Project</b-button>
									</template>
								</b-modal>
								<b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="showRequiredFieldModal = false">
									<template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
									<ul>
										<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'req'+requiredField">{{$t(requiredField)}}</li>
									</ul>
									<template slot="footer">
										<b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
									</template>
								</b-modal>
								<b-modal centered id="add-lane-modal" title="Add Lane to be Closed" size="lg" v-model="showAddLaneModal" ok-title="Add" @ok="onConfirmAddLane()">
									<b-row>
										<b-col>
											<p>It is a priority to not have traffic lanes closed during weekday peak periods (07:00-09:00 & 15:00-18:00) if at all possible. If open excavations can be plated to reopen these lanes then that will be required. AS PER THE MANUAL OF TEMPORARY TRAFFIC CONTROL THE CONSTRUCTION AGENCY INCLUDING CITY DEPARTMENTS ARE RESPONSIBLE FOR USING STEEL PLATES TO COVER EXCAVATIONS AND REOPEN CLOSED LANES DURING WEEKDAY PEAK PERIODS WHEN DEEMED FEASIBLE BY THE CONSTRUCTION AGENCY.</p>
											<b-form-group label="Select Lane">
												<b-form-select v-model="addLane.laneId.value" @input="addLane.laneId.resetStatus()" :state="addLane.laneId.status" :options="LaneClosureRequest.getLaneAffectedOptions" value-field="id" text-field="name" inline></b-form-select>
											</b-form-group>
											<b-form-group label="Re-opening for Peak Periods">
												<b-form-select v-model="addLane.peakId.value" :options="LaneClosureRequest.getClosurePeakReason" @input="addLane.peakId.resetStatus()" :state="addLane.peakId.status" value-field="id" text-field="name" @change="addLane.laneId.setDirty();" inline></b-form-select>
											</b-form-group>
											<b-form-group v-if="addLane.peakId.value == 6 || addLane.peakId.value == 13 || addLane.peakId.value == 19" label="Explain why lane will be closed due to the nature of work">
												<b-form-textarea  maxlength="2000" id="ta-peak-reason" rows="2" no-resize v-model="addLane.peakReason.value" :state="addLane.peakReason.status">
												</b-form-textarea>
											</b-form-group>
										</b-col>
									</b-row>
									<template v-slot:modal-footer="{ ok }">
										<b-button variant="primary" @click="ok()">Add Lane</b-button>
										<b-button variant="secondary" @click="showAddLaneModal=false">Cancel</b-button>
									</template>
								</b-modal>
								<b-modal centered id="add-bicycle-modal" title="Add Bicycle Lane to be Closed" size="lg" v-model="showAddBicycleModal" ok-title="Add" @ok="onConfirmAddBicycle()">
									<b-row>
										<b-col>
											<b-form-group label="Select Bicycle Lane">
												<b-form-select v-model="addBicycle.bicycleLaneId.value" @input="addBicycle.bicycleLaneId.resetStatus()" :state="addBicycle.bicycleLaneId.status" :options="LaneClosureRequest.getDirectionalBicycleLaneOptions(laneClosureRequest.directionId.value)" value-field="id" text-field="name" inline></b-form-select>
											</b-form-group>
										</b-col>
									</b-row>
									<template v-slot:modal-footer="{ ok }">
										<b-button variant="primary" @click="ok()">Add Bicycle Lane</b-button>
										<b-button variant="secondary" @click="showAddBicycleModal=false">Cancel</b-button>
									</template>
								</b-modal>
								<b-modal centered id="add-sidewalk-modal" title="Add Sidewalk to be Closed" size="lg" v-model="showAddSidewalkModal" ok-title="Add" @ok="onConfirmAddSidewalk()">
									<b-row>
										<b-col>
											<b-form-group label="Select Sidewalk">
												<b-form-select v-model="addSidewalk.sidewalkId.value" @input="addSidewalk.sidewalkId.resetStatus()" :state="addSidewalk.sidewalkId.status" :options="LaneClosureRequest.getDirectionalSidewalkOptions(laneClosureRequest.directionId.value)" value-field="id" text-field="name" inline></b-form-select>
											</b-form-group>
										</b-col>
									</b-row>
									<template v-slot:modal-footer="{ ok }">
										<b-button variant="primary" @click="ok()">Add Sidewalk Lane</b-button>
										<b-button variant="secondary" @click="showAddSidewalkModal=false">Cancel</b-button>
									</template>
								</b-modal>
								<b-modal centered id="multiple-sidewalk-modal" title="Multiple Sidewalks" size="lg" v-model="showMultipleSidewalksModal" ok-title="Ok" @ok="showMultipleSidewalksModal = false; forceRerender();">
									<b-row>
										<b-col>
											<strong>NOTE:</strong> Make sure you do not close sidewalks on both sides of the street at the same time.
										</b-col>
									</b-row>
									<template v-slot:modal-footer="{ ok }">
										<b-button variant="primary" @click="ok()">Ok</b-button>
									</template>
								</b-modal>
								<b-modal centered id="add-restriction-modal" title="Add Turning Restriction" size="lg" v-model="showAddRestrictionModal" ok-title="Add" @ok="onConfirmAddRestriction()">
									<b-row>
										<b-col>
						<p>Please note if your turn restrictions will only be limited to trucks and other large vehicles, please indicate this in the Closure Information Comments and Explanations area below.</p>
											<b-form-group label="Direction">
												<b-form-select v-model="addRestriction.directionId.value" :options="LaneClosureRequest.getDirectionalRestrictionDirectionIdOptions(laneClosureRequest.directionId.value)"
												@input="addRestriction.directionId.resetStatus()"
												:state="addRestriction.directionId.status"
												value-field="id"
												text-field="name"
												inline
												></b-form-select>
											</b-form-group>
											<b-form-group label="Turning Restriction">
												<b-form-select  v-model="addRestriction.restrictionTypeId.value"
												@input="addRestriction.restrictionTypeId.resetStatus()"
												:state="addRestriction.restrictionTypeId.status"
												:options="LaneClosureRequest.getTurningRestrictionTypeOptions"
												value-field="id"
												text-field="name"
												inline
												></b-form-select>
											</b-form-group>
											<b-form-group label="Restriction removed during Peak Periods">
												<b-form-select class="mb-2"  v-model="addRestriction.peakId.value" :options="LaneClosureRequest.getRestrictionPeakReason"
												@input="addRestriction.peakId.resetStatus()"
												:state="addRestriction.peakId.status"
												value-field="id"
												text-field="name"
												inline
												></b-form-select>
											</b-form-group>
											<b-form-group v-if="addRestriction.peakId.value == 6 || addRestriction.peakId.value == 13 || addRestriction.peakId.value == 19" label="Explain why restriction will be closed due to the nature of work"
											>
											<b-form-textarea
											maxlength="500"
											id="ta-peak-reason"
											rows="2"
											no-resize
											v-model="addRestriction.peakReason.value"
											:state="addRestriction.peakReason.status"
											>
										</b-form-textarea>
									</b-form-group>
								</b-col>
							</b-row>
							<template v-slot:modal-footer="{ ok }">
								<b-button variant="primary" @click="ok()">Add Restriction</b-button>
								<b-button variant="secondary" @click="showAddRestrictionModal=false">Cancel</b-button>
							</template>
						</b-modal>
						<b-modal centered id="remove-block-modal" title="Confirm Block Removal" size="lg" v-model="showRemoveBlockModal" ok-title="Yes" @ok="onConfirmRemoveBlock()">
							<b-row>
								<b-col>
										<p>Are you sure you want to completely remove this block from the request?</p>
									</b-col>
								</b-row>
								<template v-slot:modal-footer="{ ok }">
									<b-button variant="primary" @click="ok()">Yes, Remove Block</b-button>
									<b-button variant="secondary" @click="showRemoveBlockModal=false">No, keep block</b-button>
								</template>
							</b-modal>
							<b-modal centered id="remove-preset-lane" title="Confirm Lane Removal" size="lg" v-model="showRemovePresetLaneModal" ok-title="Yes" @ok="onConfirmPresetRemoveLane()">
								<b-row>
									<b-col>
											<p>Are you sure you want to completely remove this lane from the request?</p>
										</b-col>
									</b-row>
									<template v-slot:modal-footer="{ ok }">
										<b-button variant="primary" @click="ok()">Yes, Remove Lane</b-button>
										<b-button variant="secondary" @click="showRemovePresetLaneModal=false">No, Keep Lane</b-button>
									</template>
								</b-modal>
								<b-modal centered id="remove-preset-bicycle" title="Confirm Bicycle Lane Removal" size="lg" v-model="showRemovePresetBicycleModal" ok-title="Yes" @ok="onConfirmPresetRemoveBicycle()">
									<b-row>
										<b-col>
												<p>Are you sure you want to completely remove this bicycle lane from the request?</p>
											</b-col>
										</b-row>
										<template v-slot:modal-footer="{ ok }">
											<b-button variant="primary" @click="ok()">Yes, Remove Bicycle Lane</b-button>
											<b-button variant="secondary" @click="showRemovePresetBicycleModal=false">No, Keep Bicycle Lane</b-button>
										</template>
									</b-modal>
									<b-modal centered id="remove-preset-sidewalk" title="Confirm Sidewalk Removal" size="lg" v-model="showRemovePresetSidewalkModal" ok-title="Yes" @ok="onConfirmPresetRemoveSidewalk()">
										<b-row>
											<b-col>
													<p>Are you sure you want to completely remove this sidewalk from the request?</p>
												</b-col>
											</b-row>
											<template v-slot:modal-footer="{ ok }">
												<b-button variant="primary" @click="ok()">Yes, Remove Sidewalk</b-button>
												<b-button variant="secondary" @click="showRemovePresetSidewalkModal=false">No, Keep Sidewalk</b-button>
											</template>
										</b-modal>
										<b-modal centered id="remove-preset-restriction" title="Confirm Turning Restriction Removal" size="lg" v-model="showRemovePresetRestrictionModal" ok-title="Yes" @ok="onConfirmPresetRemoveRestriction()">
											<b-row>
												<b-col>
														<p>Are you sure you want to completely remove this turning restriction from the request?</p>
													</b-col>
												</b-row>
												<template v-slot:modal-footer="{ ok }">
													<b-button variant="primary" @click="ok()">Yes, Remove Turning Restriction</b-button>
													<b-button variant="secondary" @click="showRemovePresetRestrictionModal=false">No, Keep Turning Restriction</b-button>
												</template>
											</b-modal>
										</b-container>
									</b-overlay>
								</template>
								<script>
								/* eslint-disable no-redeclare, no-empty */

								import LaneClosureRequest from '../../models/LaneClosureRequest';
								import Contravention from '../../models/Contravention';
								import ConflictingLaneClosureRequest from '../../models/ConflictingLaneClosureRequest';

								import LaneClosureRequestBlock from '../../models/LaneClosureRequestBlock';
								import LaneClosureRequestParkingRemoval from '../../models/LaneClosureRequestParkingRemoval';

								import Datepicker from 'vuejs-datepicker';
								import Autocomplete from '@trevoreyre/autocomplete-vue'
								import BootstrapField from '../../utility/BootstrapField';
								import BootstrapTextTimePicker from '../../components/bootstrap-text-time-picker.vue';
								import LaneClosureRequestBlockLaneListing from '../../components/LaneClosureRequestBlockLaneListing';
								import LaneClosureRequestBlockSidewalkListing from '../../components/LaneClosureRequestBlockSidewalkListing';
								import LaneClosureRequestBlockRestrictionListing from '../../components/LaneClosureRequestBlockRestrictionListing';
								import LaneClosureRequestBlockBicycleListing from '../../components/LaneClosureRequestBlockBicycleListing';
								import LaneClosureRequestBlockTrafficSignalsAltered from '../../components/LaneClosureRequestBlockTrafficSignalsAltered';
								import LaneClosureRequestBlockAdd from '../../components/LaneClosureRequestBlockAdd';

								import LaneClosureRequestParkingRemovalModal from '../../components/LaneClosureRequestParkingRemovalModal';
								import LaneClosureRequestParkingRemovalListing from '../../components/LaneClosureRequestParkingRemovalListing';

// import LaneClosureBlockBicycle from '../../models/LaneClosureBlockBicycle';
// import LaneClosureBlockSidewalk from '../../models/LaneClosureBlockSidewalk';
// import LaneClosureBlockLane from '../../models/LaneClosureBlockLane';

import LaneClosureRequestBlockRestriction from '../../models/LaneClosureRequestBlockRestriction.js'
import LaneClosureRequestBlockLane from '../../models/LaneClosureRequestBlockLane.js'
import LaneClosureRequestBlockSidewalk from '../../models/LaneClosureRequestBlockSidewalk.js'
import LaneClosureRequestBlockBicycle from '../../models/LaneClosureRequestBlockBicycle.js'

import LaneClosureRequestPresetRestriction from '../../models/LaneClosureRequestPresetRestriction.js'

import ReviewLaneClosureRequestBlockLaneListing from '../../components/ReviewLaneClosureRequestBlockLaneListing'
import ReviewLaneClosureRequestBlockSidewalkListing from '../../components/ReviewLaneClosureRequestBlockSidewalkListing'
import ReviewLaneClosureRequestBlockBicycleListing from '../../components/ReviewLaneClosureRequestBlockBicycleListing'
import ReviewLaneClosureRequestBlockRestrictionListing from '../../components/ReviewLaneClosureRequestBlockRestrictionListing'
import ReviewLaneClosureRequestBlockTrafficSignalsAltered from '../../components/ReviewLaneClosureRequestBlockTrafficSignalsAltered'
import ReviewLaneClosureRequestParkingRemovalListing from '../../components/ReviewLaneClosureRequestParkingRemovalListing';

import Format from '../../utility/Format';
import ErrorHandler from '../../utility/ErrorHandler';
import { gmapApi } from 'gmap-vue'
import KMLHelper from '../../utility/KMLHelper';
import moment from 'moment-timezone'
import Attachment from '../../models/Attachment';
import AttachmentsList from '../../components/AttachmentsList';

// Import Vue FilePond
import vueFilePond from 'vue-filepond';

// Import FilePond styles
import 'filepond/dist/filepond.min.css';

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileMetadata from 'filepond-plugin-file-metadata';
import FilePondPluginFileRename from 'filepond-plugin-file-rename';
import Vue from 'vue'

import store from '../../store';

import Spinner from "./../../components/Spinner.vue";


export default {
	name: 'AddLaneClosureRequestWithContravention',
	docTitle: "New Violation - Lane Closures",

	components: {
		'date-picker': Datepicker,
		Autocomplete,
		Spinner,
		BootstrapTextTimePicker,
		LaneClosureRequestBlockLaneListing,
		LaneClosureRequestBlockSidewalkListing,
		LaneClosureRequestBlockRestrictionListing,
		LaneClosureRequestBlockBicycleListing,
		LaneClosureRequestBlockTrafficSignalsAltered,
		LaneClosureRequestBlockAdd,
		LaneClosureRequestParkingRemovalListing,
		LaneClosureRequestParkingRemovalModal,
		'attachments-list': AttachmentsList,
		FilePond: vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview, FilePondPluginFileMetadata, FilePondPluginFileRename),
		ReviewLaneClosureRequestBlockLaneListing,
		ReviewLaneClosureRequestBlockSidewalkListing,
		ReviewLaneClosureRequestBlockBicycleListing,
		ReviewLaneClosureRequestBlockRestrictionListing,
		ReviewLaneClosureRequestBlockTrafficSignalsAltered,
		ReviewLaneClosureRequestParkingRemovalListing,

	},

	data() {
		return {
			fromDatePickerKey: 0,
			toDatePickerKey: 0,
			Format,
			hasParkingRemovalError:false,
			checkingConflicts:false,
			overrideUnsavedChanges: false,
			// Editable methods for the modal.
			modalOnSave: () => {},
			modalOnLeave: () => {},
			loadBlocksTimeout: null,
			restrictionCrossStreet: new BootstrapField({
				value: null,
				required: true,
				invalidMessage: 'Please enter the restriction location.',
			}),
			acaChoices: new BootstrapField({
				value: null,
				required: false,
				invalidMessage: 'Please select at least one option for ACA.',
			}),
			addBlockRestrictionData:null,
			affectedStreetText:{id:"", label:""},
			affectedStreetOptions:[],
			allStreetOptions: [],
			blockClosuresRestrictionsKey: "blockClosuresRestrictionsKey-0",
			blockDetailsKey: "blockDetailsKey-0",
			blockEditDetailsKey: "blockEditDetailsKey-0",
			blockEditDetailsKeyCounter: 0,
			changeSubmissionSuccess: false,
			clickedMap:false,
			ConflictingLaneClosureRequest,
			conflictingLaneClosureRequest: new ConflictingLaneClosureRequest(),
			contextFromTime: null,
			Contravention,
			contravention: null,
			currentMidx: null,
			addLane: new LaneClosureRequestBlockLane(),
			addBicycle: new LaneClosureRequestBlockBicycle(),
			addSidewalk: new LaneClosureRequestBlockSidewalk(),
			addRestriction: new LaneClosureRequestBlockRestriction(),
			downloadToken:null,
			downloadTokenExpires:null,
			showAddLaneModal: false,
			showAddBicycleModal: false,
			showAddRestrictionDataModal: false,
			showAddSidewalkModal: false,
			showMultipleSidewalksModal: false,
			showAddRestrictionModal: false,
			showRemovePresetLaneModal: false,
			showRemovePresetBicycleModal: false,
			showRemovePresetSidewalkModal: false,
			showRemovePresetRestrictionModal: false,
			showNoBlocksModal:false,
			showConfirmBlocksModal:false,
			showRemoveAllBlocksModal:false,
			showRequestChanges:false,
			showWizardErrorModal:false,
			editingBlockIndex: -1,
			errorMsg: null,
			errorLines:[],
			presetErrorLines:[],
			expandAffectedStreet: false,
			expandBicycle: false,
			expandCustomizeBicycle: [],
			expandCustomizeLane: [],
			expandCustomizeRestriction: [],
			expandCustomizeSidewalk: [],
			expandLane: false,
			expandRestriction: false,
			expandSidewalk: false,
			firstCoords: null,
			firstCrossStreetMarker: null,
			firstCrossStreetOptions: [],
			fromTime: new BootstrapField({
				value: null,
				type: BootstrapField.Types.date,
				required: true,
				// validator: function(value) {
				// 	return value instanceof Date;
				// },
				// required: true,
			}),
			googleExists: false,
			hadDurationConflict: false,
			hadEndDateConflict: false,
			hadStartDateConflict: false,
			hasChanges: false,
			hasPresetBlockError: false,
			hasRegionalBlock: false,
			hasShownStartDateInPastModal: false,
			hasErrorSubmitter: false,
			hasErrorClosures: false,
			hasErrorDCZ: false,
			hasErrorPermit: false,
			ignoreTimeConflict: false,
			ignoreAfterHoursSubmission: true,  // Don't check after hours submission for contraventions.
			infoWinOpen: false,
			isAffectedStreetsLoading: false,
			isButtonDisabled: false,
			isEditingBlock: false,
			isEditingParkingRemoval: false,
			isPermitRoadwayValid: null,
			LaneClosureRequest,
			laneClosureRequest: null,
			laneIndexToEditParkingRemoval: 0,
			laneInfoToEditParkingRemoval: {},
			lastConflictType: null,
			lastCoords: null,
			lastCrossStreetMarker: null,
			lastCrossStreetOptions: [],
			lessThanTwoHourModalp1: '',
			lessThanTwoHourModalp2: '',
			lineIndexError: null,
			loadedBlockData: [],
			loaded: false,
			loadingBlocks: false,
			loadedBlocksOnce:false,
			stillLoadingBlocks: false,
			map: null,
			markers: [],
			modalRequiredFieldList: [],
			newFromTime: new BootstrapField({
				value: null,
				type: BootstrapField.Types.date,
				required: true,
				// validator: function(value) {
				// 	return value instanceof Date;
				// },
				// required: true,
			}),
			newProject: {
				name: new BootstrapField({
					value: null
				}),
				isActive: new BootstrapField({
					value: true
				}),
				comments: new BootstrapField({
					value: null
				})
			},
			editProject: {
				id: null,
				name: new BootstrapField({
					value: null
				}),
				isActive: new BootstrapField({
					value: true
				}),
				comments: new BootstrapField({
					value: null
				})
			},
			showEditProjectModal: false,

			newRestriction: {
				blockId: new BootstrapField({
					value: null,
				}),
				laneId: new BootstrapField({
					value: null,
				}),
				restrictionTypeId: new BootstrapField({
					value: 1,
				}),
				affectedStreet: new BootstrapField({
					value: null,
				}),
				crossStreet: new BootstrapField({
					value: null,
				})
			},
			newToTime: new BootstrapField({
				value: null,
				// required: true,
				type: BootstrapField.Types.date,
				required: true,
				// validator: function(value) {
				// 	return value instanceof Date;
				// },
				invalidMessage: 'Please enter a valid estimated completion time',
			}),
			noFirstCrossStreetOptions: [{
				text: 'Select Affected Street',
				value: null
			}],
			noLastCrossStreetOptions: [{
				text: 'Select First Cross Street',
				value: null
			}],
			nonRegionalBlock: null,
			onSubmitPromiseDeferred: {
				resolve: null,
				reject: null
			},
			organizationOptions: [],
			organizations: [],
			organizationUserOptions: [],
			presetBackup: {},
			projectLabel: "Requester's Project",
			renderCounter: 0,
			requestChanges: null,
			requesterProjectIdOptions: [{
				id: null,
				name: "No Project Assigned",
				displayName: "No Project Assigned",
				isActive: 1
			}],
			requesterProjectInfo: null, // have to save the project information, in case they change the user, the project will be gone.
			saveAfterConflictResolved: false,
			saveState: null,
			saving: false,
			selectAlternateContact: new BootstrapField({
				value: null,
			}),
			selectAltRestrictionReporter: new BootstrapField({
				value: null,
			}),
			selectClosureReporter: new BootstrapField({
				value: null,
				validator: function(value) {
					if (this.laneClosureRequest.closureReporter == null) {
						return false;
					} else {
						if (this.laneClosureRequest.closureReporter.userId == null) {
							return false;
						}
					}
					return true
				},
				invalidMessage: 'Please select the Lane Closure Reporter.',
			}),
			selectRequester: new BootstrapField({
				value: null,
				validator: function(value) {
					if (this.laneClosureRequest.requester == null) {
						return false;
					} else {
						if (this.laneClosureRequest.requester.userId == null) {
							return false;
						}
					}
					return true
				},
				invalidMessage: 'Please select the Requester.',

			}),
			selectRestrictionReporter: new BootstrapField({
				value: null,
			}),

			newAHFromDate: new BootstrapField({
				value: null,
				type: BootstrapField.Types.date,
				required: true,
				invalidMessage: 'Please enter a valid estimated start date',
			}),
			newAHFromTime: new BootstrapField({
				value: null,
				type: BootstrapField.Types.date,
				required: true,
				invalidMessage: 'Please enter a valid estimated start time',
			}),
			newAHToDate: new BootstrapField({
				value: null,
				type: BootstrapField.Types.date,
				required: true,
				invalidMessage: 'Please enter a valid estimated completion date',
			}),
			newAHToTime: new BootstrapField({
				value: null,
				type: BootstrapField.Types.date,
				required: true,
				invalidMessage: 'Please enter a valid estimated completion time',
			}),
			disabledPastDates: {
					to: Format.utcToPickerDate(moment.utc())
			},
			showAfterHoursModal: false,
			show: true,
			showLessThanTwoHourModal: false,
			showNewProjectModal: false,
			showNonRegionalStreetModal: false,
			showPresetErrorModal: false,
			showProtectedBikeLaneModal: false,
			showRemoveBlockModal: false,
			showRequiredFieldModal: false,
			showSpeedReduction: new BootstrapField({
				value: null
			}),
			showStartDateInPastModal: false,
			showErrorTwoHourModal:false,
			showErrorReversedDates:false,
			showErrorReversedTimes:false,
			showErrorTwoHourTooLongModal:false,
			showTempTrafficControlModal:false,
			showTimeConflictModal: null,
			showUnsavedChangesModal: false,
			submitted: null,
			toTime: new BootstrapField({
				value: null,
				// required: true,
				type: BootstrapField.Types.date,
				required: true,
				// validator: function(value) {
				// 	return value instanceof Date;
				// },
				invalidMessage: 'Please enter a valid estimated completion time',
			}),
			hideMap: false,
			currentBlockOnMap: null,
			workDoneForOrgId: null,
			workDoneForOrgType: new BootstrapField({
				value: null,
				required: true,
			}),

			// For LCR Review
			expandTrafficSignalsAltered: false,
			expandDCZ: false,
			expandTransit: false,
			expandParking: false,
			expandPermit: false,
			validateHasBlocks: new BootstrapField({
				value: null,
				required:true,
				validator: function(value) {
					if (value ) {
						return true;
					} else {
						return false;
					}
				},
				invalidMessage: 'Open the map and select at least one street block.',
			}),
			validateConfirmedBlocks: new BootstrapField({
				value: 0,
				required:true,
				validator: function(value) {
					if (value == 1) {
						return true;
					} else {
						return false;
					}
				},
				invalidMessage: 'Please confirm that the street blocks on the map are accurate.',
			}),
		}
	},
	created() {
		this.$gmapApiPromiseLazy().then(() => {
			this.googleExists = true;
			this.setEventBusOn();
			// this.LoadLaneClosureRequest(this.$route.params.id);
		});
	},
	beforeMount() {},
	mounted() {
		this.loaded = false;
		this.$nextTick(() => {
			if (this) {
				Vue.prototype.$bus.$emit("map:clear", 1);
				Vue.prototype.$bus.$emit('map:close-street-view'); // close street view on Add page load

				if (this.$route.params.id) {
					this.LoadLaneClosureRequest(this.$route.params.id);
				} else {
					this.LoadLaneClosureRequest();
				}

			}
		})



	},
	computed: {

		fromDatePicker: {
			get() {
				return Format.utcToPickerDate(
					this.laneClosureRequest.fromDate.value
				);
			},
			set(date) {
				this.laneClosureRequest.fromDate.value =
				Format.mergePickerDate(
					this.laneClosureRequest.fromDate.value,
					date
				);
			}
		},

		toDatePicker: {
			get() {
				return Format.utcToPickerDate(
					this.laneClosureRequest.toDate.value
				);
			},
			set(date) {
				this.laneClosureRequest.toDate.value =
				Format.mergePickerDate(
					this.laneClosureRequest.toDate.value,
					date
				);
			}
		},

		conflictingNewFromDatePicker: {
			get() {
				return Format.utcToPickerDate(
					this.conflictingLaneClosureRequest.newFromDate.value
				);
			},
			set(date) {
				this.conflictingLaneClosureRequest.newFromDate.value =
				Format.mergePickerDate(
					this.conflictingLaneClosureRequest.newFromDate.value,
					date
				);
			}
		},

		conflictingNewToDatePicker: {
			get() {
				return Format.utcToPickerDate(
					this.conflictingLaneClosureRequest.newToDate.value
				);
			},
			set(date) {
				this.conflictingLaneClosureRequest.newToDate.value =
				Format.mergePickerDate(
					this.conflictingLaneClosureRequest.newToDate.value,
					date
				);
			}
		},

		parkingRemovalListCopy() {
			// Return a copy of laneClosureRequest.parkingRemoval
			return this.laneClosureRequest.parkingRemoval.map(item => ({ ...item }));
		},
		shouldShowDescriptionMessage() {
			if (this.laneClosureRequest) {
				if (this.hasRestrictions() || this.laneClosureRequest.isEmergency.value) {
						return true;
				}
			}
			return false;
		},

		hasBlocks() {
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.block) {
					if (this.laneClosureRequest.block.length <= 0) {
						return false;
					}
				} else {
					return false;
				}
			}
			return true;
		},
		confirmBlocksLabel() {
			if (this.loadingBlocks) {
				return "Confirm Streets on Map (loading...)";
			} else {
				return "Confirm Streets on Map";
			}
		},

		getAcaText() {
			let text = "";
			let comma = "";
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.actAsAca.value == 1)  {
					text = "Acting as ACA for ";

					if (this.laneClosureRequest.acaParkingRemoval.value == 1) {
						text += comma+"Parking Removal";
						comma = ", ";
					}
					if (this.laneClosureRequest.acaTurnRestrictions.value == 1) {
						text += comma+"Turn Restrictions";
						comma = ", ";
					}
					if (this.laneClosureRequest.acaFullDirectional.value == 1) {
						text += comma+"Full or Directional Closure of a Regional Street";
						comma = ", ";
					}
					if (this.laneClosureRequest.acaDcz.value == 1) {
						text += comma+"DCZ";
						comma = ", ";
					}
				} else {
					text = "Not acting as ACA";
				}
			}
			return text;
		},
		getParkingSpotMapLink() {
			let comma = "";
			let link = this.$store.state.paidParkingLotMapUrl + "&ll=";

			if (this.laneClosureRequest) {
				for (var x =0; x < this.$store.getters["map/polylines"].length; x++) {
					let polyBounds = this.$store.getters["map/polylines"][x].getPath();
					for (var z = 0; z < polyBounds.length; z++) {
						link += comma+polyBounds.getAt(z).lat()+"%2c"+polyBounds.getAt(z).lng();
						break;
					}
					break;
				}
				link += "&z=18";
				return link;
			}
			return null;
		},

		getTempTrafficControl() {
			let text = "";
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.tempTrafficControl.value == 1) {
					text = "Requires Temporary Traffic Control by Traffic Services";
				} else {
					text = "Does NOT want Temporary Traffic Control by Traffic Services";
				}
			}
			return text;
		},

		getBusStopMapLink() {
			let comma = "";
			let link = this.$store.state.busStopMapUrl + "&ll=";

			if (this.laneClosureRequest) {
				for (var x =0; x < this.$store.getters["map/polylines"].length; x++) {
					let polyBounds = this.$store.getters["map/polylines"][x].getPath();
					for (var z = 0; z < polyBounds.length; z++) {
						link += comma+polyBounds.getAt(z).lat()+"%2c"+polyBounds.getAt(z).lng();
						break;
					}
					break;
				}
				link += "&z=18";
				return link;
			}
			return null;
		},
		canSetTrafficEffect() {
			if (this.laneClosureRequest) {
				if (this.$store.getters.userHasRole('internal_admin_requests')) {
					return true;
				}
			}
			return false;
		},
		affectedStreetCollapseTitle() {
			let title = "";
			if (this.laneClosureRequest) {
				title = LaneClosureRequest.getDirectionText(this.laneClosureRequest.directionId.value);
				title += " " + this.laneClosureRequest.affectedStreet.value;
				if (this.laneClosureRequest.firstCrossStreet.value != null) {
					title += " between ";
					title += " " + this.laneClosureRequest.firstCrossStreet.value;
				}
				if (this.laneClosureRequest.lastCrossStreet.value != null) {
					title += " and ";
					title += " " + this.laneClosureRequest.lastCrossStreet.value;
				}
			}
			return title;
		},
		canReportContravention() {
			if (this.laneClosureRequest) {
				return this.$store.getters.userCanReportContravention();
			}
			return false;
		},


		getStartIndex() {
			return 0;
		},

		googleMapApi: gmapApi,
		disableStartDate() {
			return {
						to: Format.utcToPickerDate(
								Format.startOfLocalDay().utc().format()
						)
			};
		},
		disableEndDate() {
			if (this.laneClosureRequest.fromDate &&
			this.laneClosureRequest.fromDate.value) {
				return {
					to: new Date(
					Format.utcToPickerDate(
					this.laneClosureRequest.fromDate.value
					).setHours(0, 0, 0, -1)
					)
				};
			}

			return {};
		},

		disableConflictingEndDate() {
				if (this.conflictingLaneClosureRequest.newFromDate &&
						this.conflictingLaneClosureRequest.newFromDate.value) {
						return {
					to: new Date(
					Format.utcToPickerDate(
										this.conflictingLaneClosureRequest.newFromDate.value
					).setHours(0, 0, 0, -1)
								)
						};
				}

				return {};
		},
		transitFieldsState() {
			if (this.laneClosureRequest.transitAffected.status == null &&
			this.laneClosureRequest.transitOther.status == null &&
			this.laneClosureRequest.transit.status == null
			) {
				return null;
		}

		return false;
	},
	projectTimeDuration() {
			/*
			if (this.laneClosureRequest.fromDate.valid && this.laneClosureRequest.toDate.valid) {
				if (this.laneClosureRequest.fromDate.valid && this.laneClosureRequest.toTime.valid) {
					let startTime = Format.fromUtc(this.laneClosureRequest.fromDate.value);
					startTime.minutes(Number(this.laneClosureRequest.fromDate.value.mm));
					let startPmAddTime = (this.laneClosureRequest.fromDate.value.a == 'pm' && this.laneClosureRequest.fromDate.value.h != '12' ? 12 : 0);
					startPmAddTime = this.laneClosureRequest.fromDate.value.a == 'am' && this.laneClosureRequest.fromDate.value.h == '12' ? -12 : startPmAddTime;
					startTime.hours(Number(this.laneClosureRequest.fromTime.value.h) + startPmAddTime);

					let endTime = Format.fromUtc(this.laneClosureRequest.toDate.value);
					endTime.minutes(Number(this.laneClosureRequest.toTime.value.mm));
					let endPmAddTime = (this.laneClosureRequest.toTime.value.a == 'pm' && this.laneClosureRequest.toTime.value.h != '12' ? 12 : 0);
					startPmAddTime = this.laneClosureRequest.toTime.value.a == 'am' && this.laneClosureRequest.toTime.value.h == '12' ? -12 : startPmAddTime;
					endTime.hours(Number(this.laneClosureRequest.toTime.value.h) + endPmAddTime);

					// return Math.abs(this.moment.duration(startTime.diff(endTime)).asHours());
					return this.moment.duration(endTime.diff(startTime)).asHours();
				}
			}
			*/
			return null;
		},

		workDoneForOrgTypePlaceHolder() {
			if (this.workDoneForOrgType.value == 1) {
				return 'Select City of Winnipeg / Major Utilities...';
			} else if (this.workDoneForOrgType.value == 2) {
				return 'Select Third-Party...';
			}
			return null;

		},

		// For LCR Review
		directionOfTravel() {
			if (this.laneClosureRequest.directionId.value) {
				return Format.searchById(this.laneClosureRequest.directionId.value, LaneClosureRequest.getDirectionIdOptions).name;
			}
			return null;
		},
		natureOfWork() {
			if (this.laneClosureRequest.natureOfWorkId.value) {
				return Format.searchById(this.laneClosureRequest.natureOfWorkId.value, LaneClosureRequest.getNatureOfWorkOptions).name;
			}
			return null;
		},
	},

	watch: {
		'$store.state.isMobile' : function() {
			// hide everything.
			this.onCollapsePresetLanes(false);
			this.onCollapsePresetSidewalks(false);
			this.onCollapsePresetBicycles(false);
			this.onCollapsePresetRestrictions(false);
		},
		'laneClosureRequest.workZoneKph.value': function() {
			this.setupWorkZoneKph();
		},
		'laneClosureRequest.workZoneReduceKph.value': function() {
			this.setupWorkZoneReduceKph();
		},
		'laneClosureRequest.transitAffected.value': function() {
			this.setupTransitAffected();
		},
		'laneClosureRequest.fromDate.value': function() {
			this.setupFromDate();
		},
		'laneClosureRequest.toDate.value': function() {
			this.setupToDate();
		},
		'laneClosureRequest.tempTrafficControl.value': function() {
			if (!this.loaded) {
				return;
			}
			if (this.laneClosureRequest.tempTrafficControl.value == 1) {
				this.showTempTrafficControlModal = true;
			} else {
				this.showTempTrafficControlModal = false;
			}

		},
		'fromTime.value': function() {
			if (!this.loaded) {
				return;
			}

			if (this.laneClosureRequest) {
				this.onFromDateTimeChanged(this.fromTime.value);
			}
			this.ignoreTimeConflict = false;
			this.hasShownStartDateInPastModal = false;
		},
		'toTime.value': function() {
			if (!this.loaded) {
				return;
			}

			if (this.laneClosureRequest) {
				this.onToDateTimeChanged(this.toTime.value);
			}
			this.ignoreTimeConflict = false;
			this.hasShownStartDateInPastModal = false;
		},

		'laneClosureRequest.transit.value': function() {
			this.setupTransit();
		},

		'laneClosureRequest.paidParkingAffected.value': function() {
			this.setupPaidParkingAffected();
		},

		'laneClosureRequest.parkingRemovalId.value': function() {
			this.setupParkingRemovalId();
		},

		'laneClosureRequest.actAsAca.value': function() {
			this.setupAca();
		},

		'laneClosureRequest.workDoneForId.value': function() {
			this.setupWorkDoneForId();
		},
		'laneClosureRequest.requesterId': function() {
			if (!this.loaded) {
				return;
			}

			this.getRequesterProjects();
		},

		'laneClosureRequest.isUnderTwoHours.value': function() {
			this.setupIsUnderTwoHours();

		},

		'$store.state.user': function() {
			if (this.$route.params.id) {
				this.LoadLaneClosureRequest(this.$route.params.id);
			}
			else {
				this.LoadLaneClosureRequest();
			}
		},
	},
	beforeDestroy() {
		this.setEventBusOff();
	},
	methods: {
		setupRequiredFields() {
			// need to setup required fields after loading the request, otherwise parking lanes won't be sent up properly.
			if (!this.loaded) {
				return;
			}
			this.setupAca();
			this.setupIsEmergency();
			this.setupPaidParkingAffected();
			this.setupParkingRemovalId();
			this.setupIsUnderTwoHours();
			this.setupWorkDoneForId();
			this.setupWorkZoneKph();
			this.setupWorkZoneReduceKph();
			this.setupTransitAffected();
			this.setupTransit();
		},
		setupFromDate() {
			if (!this.loaded) {
				return;
			}
			this.hasShownStartDateInPastModal = false;
		},

		setupIsUnderTwoHours() {
			if (!this.loaded) {
				return;
			}
			this.laneClosureRequest.trafficSignalsAltered.resetStatus();
			this.laneClosureRequest.transit.resetStatus();
			this.laneClosureRequest.paidParkingAffected.resetStatus();
			this.laneClosureRequest.workDoneForId.resetStatus();
		},
		setupIsEmergency() {
			if (!this.loaded) {
				return;
			}

			if (this.laneClosureRequest.isEmergency.value == 1) {
				// set the requested start date and end date to now, plus 2 hours.
					let theTime = this.moment.tz(Format.TIMEZONE);
				theTime.seconds(0);
					this.laneClosureRequest.fromDate.value = theTime.clone().utc().format();
					this.laneClosureRequest.fromTime.value = theTime.clone().utc().format();
					this.laneClosureRequest.toDate.value = theTime.clone().utc().format();
					this.fromTime.value = theTime.clone().utc().format();
					this.toTime.value = theTime.add(2, "hours").clone().utc().format();
					this.laneClosureRequest.toDate.value = theTime.clone().utc().format();
					this.laneClosureRequest.toTime.value = theTime.clone().utc().format();

				// this.toTime.value = theTime.hour(15).format();
			} else {
				// Set the default start date and time to 9:00am, 3 business days from now, end time at 3:00pm
				// If submitting a new non-emergency request and the current time is after 15:00, set the initial start date to be 4 business days from now ON page load. 
					let now = this.moment.tz(Format.TIMEZONE);
				let day = now.day();
					let today1500 = now.clone().hour(15).minute(0).second(0).millisecond(0);
				let advanceTurnoverDays = (day > 0 && day < 6 && now.isSameOrAfter(today1500)) ? 4 : 3;

				let theTime = Format.addWeekdays(null, advanceTurnoverDays);
				theTime.hours(9);
				theTime.minutes(0);
				theTime.seconds(0);

					this.laneClosureRequest.fromDate.value = theTime.clone().utc().format();
					this.laneClosureRequest.fromTime.value = theTime.clone().utc().format();

					this.fromTime.value = theTime.clone().utc().format();
				// this.toTime.value = theTime.add(2, "hours").format();
					this.toTime.value = theTime.hour(15).clone().utc().format();
					this.laneClosureRequest.toDate.value = theTime.clone().utc().format();
					this.laneClosureRequest.toTime.value = theTime.clone().utc().format();
			}
		},
		setupPaidParkingAffected() {
			if (!this.loaded) {
				return;
			}
			this.laneClosureRequest.parkingRemovalId.resetStatus();
		},
		setupAca() {
			if (!this.loaded) {
				return;
			}
			if (""+this.laneClosureRequest.actAsAca.value == '1') {
				this.acaChoices.required = true;
			} else {
				this.acaChoices.required = false;
				this.laneClosureRequest.acaFullDirectional.value = 0;
				this.laneClosureRequest.acaParkingRemoval.value = 0;
				this.laneClosureRequest.acaTurnRestrictions.value = 0;
				this.laneClosureRequest.acaDcz.value = 0;
			}
			// Reset the status of the parking fields
			this.laneClosureRequest.actAsAca.resetStatus();
		},
		setupParkingRemovalId() {
			if (!this.loaded) {
				return;
			}
			/*
			if (this.laneClosureRequest.parkingRemovalId.value == '1' || laneClosureRequest.parkingRemovalId.value == '5') {
				this.laneClosureRequest.parkingLane.required = true;
				this.laneClosureRequest.parkingRemovalMetres.required = true;
				this.laneClosureRequest.parkingStartAddress.required = true;
				this.laneClosureRequest.parkingEndAddress.required = true;
			} else {
				this.laneClosureRequest.parkingLane.required = false;
				this.laneClosureRequest.parkingRemovalMetres.required = false;
				this.laneClosureRequest.parkingStartAddress.required = false;
				this.laneClosureRequest.parkingEndAddress.required = false;
			}
			*/

			// No, I will not be removing parking, so turn off paid parking affected
			if (this.laneClosureRequest.parkingRemovalId.value == '2') {
				this.laneClosureRequest.paidParkingAffected.value = null;
				this.laneClosureRequest.paidParkingAffected.required = false;
				this.laneClosureRequest.parkingRemoval = []; //reset to empty array
			} else {
				this.laneClosureRequest.paidParkingAffected.required = true;

				// if (this.laneClosureRequest.paidParkingAffected.value == 0) {
				// 	this.laneClosureRequest.paidParkingAffected.value = null;
				// }
			}

			// Reset the value of the parking fields
			// this.laneClosureRequest.parkingLane.value = [];
			// this.laneClosureRequest.parkingRemovalMetres.value = null;
			// this.laneClosureRequest.parkingStartAddress.value = null;
			// this.laneClosureRequest.parkingEndAddress.value = null;

			/*
			// Reset the status of the parking fields
			this.laneClosureRequest.parkingLane.resetStatus();
			this.laneClosureRequest.parkingRemovalMetres.resetStatus();
			this.laneClosureRequest.parkingStartAddress.resetStatus();
			this.laneClosureRequest.parkingEndAddress.resetStatus();
			*/
		},
		setupToDate() {
			if (!this.loaded) {
				return;
			}
			this.hasShownStartDateInPastModal = false;
		},
		setupTransit() {
			if (!this.loaded) {
				return;
			}

			let requiresOther = false;
			// this.laneClosureRequest.transitOther.required = false;
			for (var entry of this.laneClosureRequest.transit.value) {
				if (entry.transitEffectId == 5) {
					requiresOther = true;
				}
			}
			this.laneClosureRequest.transitOther.required = requiresOther;
			this.laneClosureRequest.transitOther.resetStatus();
		},
		setupTransitAffected() {
			if (!this.loaded) {
				return;
			}
			if (this.laneClosureRequest.transitAffected.getRawValue() == 1) {
				this.laneClosureRequest.transit.required = true;
				this.laneClosureRequest.transitStopNumbers.required = true;
			} else {
				this.laneClosureRequest.transit.required = false;
				this.laneClosureRequest.transitStopNumbers.required = false;
				this.laneClosureRequest.transitOther.required = false;
			}
			// this.laneClosureRequest.transit.value = [];
			// this.laneClosureRequest.transitStopNumbers.value = null;
			// this.laneClosureRequest.transitOther.value = null;

			this.laneClosureRequest.transit.resetStatus();
			this.laneClosureRequest.transitStopNumbers.resetStatus();
			this.laneClosureRequest.transitOther.resetStatus();

		},
		setupWorkDoneForId() {
			if (!this.loaded) {
				return;
			}
			if (this.laneClosureRequest) {
				// Reset work zone and permits required
				this.laneClosureRequest.projectBidNumber.required = false;
				this.laneClosureRequest.permitNearestStreetNumber.required = false;
				this.laneClosureRequest.permitRoadwayMetres.required = false;
				this.laneClosureRequest.permitRoadwayFrom.required = false;
				this.laneClosureRequest.permitRoadwayTo.required = false;
				this.laneClosureRequest.permitSidewalkMetres.required = false;
				this.laneClosureRequest.permitSidewalkFrom.required = false;
				this.laneClosureRequest.permitSidewalkTo.required = false;
				this.laneClosureRequest.permitLiabilityInsurance.required = false;
				this.laneClosureRequest.permitRequests.required = false;
				this.laneClosureRequest.crossingPermitRequired.required = false;

				// Reset work zone and permits status
				this.laneClosureRequest.projectBidNumber.resetStatus();
				this.laneClosureRequest.permitNearestStreetNumber.resetStatus();
				this.laneClosureRequest.permitRoadwayMetres.resetStatus();
				this.laneClosureRequest.permitRoadwayFrom.resetStatus();
				this.laneClosureRequest.permitRoadwayTo.resetStatus();
				this.laneClosureRequest.permitSidewalkMetres.resetStatus();
				this.laneClosureRequest.permitLiabilityInsurance.resetStatus();
				this.laneClosureRequest.crossingPermitRequired.resetStatus();

				// Reset work zone and permits value
				// this.laneClosureRequest.projectBidNumber.value = null;
				// this.laneClosureRequest.permitNearestStreetNumber.value = null;
				// this.laneClosureRequest.permitRoadwayMetres.value = null;
				// this.laneClosureRequest.permitRoadwayFrom.value = null;
				// this.laneClosureRequest.permitRoadwayTo.value = null;
				// this.laneClosureRequest.permitSidewalkMetres.value = null;
				// this.laneClosureRequest.permitLiabilityInsurance.value = null;
				// this.laneClosureRequest.crossingPermitRequired.value = null;

				// Determine what fields are required based on the current selection
				if (this.laneClosureRequest.workDoneForId.value == null) {
					this.laneClosureRequest.permitRequired.value = 0;
					// this.laneClosureRequest.crossingPermitRequired.value = 0;
				} else {
					if (this.laneClosureRequest.workDoneForId.isCityOfWinnipeg()) { // work done for the City of Winnipeg
						this.laneClosureRequest.projectBidNumber.required = true;
						this.laneClosureRequest.permitRequired.value = 0;
					} else if (this.laneClosureRequest.workDoneForId.getRawValue() == null || this.laneClosureRequest.workDoneForId.getRawValue() == 0) {
						this.laneClosureRequest.permitRequired.value = 0;
					} else if (this.laneClosureRequest.workDoneForId.isAgency()) { // work done for private third parties.
						this.laneClosureRequest.permitRequired.value = 1;
						// this.laneClosureRequest.permitNearestStreetNumber.required = true;
						this.laneClosureRequest.permitRoadwayMetres.required = true;
						this.laneClosureRequest.permitRoadwayFrom.required = true;
						this.laneClosureRequest.permitRoadwayTo.required = true;
						this.laneClosureRequest.permitSidewalkMetres.required = true;
						this.laneClosureRequest.permitSidewalkFrom.required = true;
						this.laneClosureRequest.permitSidewalkTo.required = true;
						this.laneClosureRequest.permitLiabilityInsurance.required = true;
						this.laneClosureRequest.crossingPermitRequired.required = true;
						this.laneClosureRequest.permitRequests.required = false;
					} else {
						this.laneClosureRequest.permitRequired.value = 0;
						// this.laneClosureRequest.crossingPermitRequired.value = 0;
					}
				}
			}

		},
		setupWorkZoneKph() {
			if (!this.loaded) {
				return;
			}
			if (this.laneClosureRequest.workZoneKph.value == null) {
				this.laneClosureRequest.dczRequired.value = 0;
			} else {
				if (this.laneClosureRequest.workZoneKph.value == 80) {
					this.laneClosureRequest.dczRequired.value = 1;
					this.laneClosureRequest.workZoneReduceKph.value = null;
				} else {
					if (this.laneClosureRequest.workZoneKph.value == 70) {
						if (this.laneClosureRequest.workZoneReduceKph.value == 60) {
							this.laneClosureRequest.dczRequired.value = 1;
						} else {
							this.laneClosureRequest.dczRequired.value = 0;
						}
					} else {
						this.laneClosureRequest.dczRequired.value = 0;
						this.laneClosureRequest.workZoneReduceKph.value = null;
					}
				}
			}
		},
		setupWorkZoneReduceKph() {
			if (!this.loaded) {
				return;
			}
			if (this.laneClosureRequest.workZoneReduceKph.value == 60) {
				this.laneClosureRequest.dczRequired.value = 1;
			} else {
				if (this.laneClosureRequest.workZoneKph.value == 80) {
					this.laneClosureRequest.dczRequired.value = 1;
				} else {
					this.laneClosureRequest.dczRequired.value = 0;
				}
			}
		},

		modalWizardOnCancel(newTab) {
			this.showWizardErrorModal = false;
			if (newTab != null) {
				this.changeTab(newTab);
			}
		},

		modalOnCancel() {
			this.showUnsavedChangesModal = false;
			if (this.$store.getters.logoutRequested) {
				this.$store.commit('logoutRequested', false);
			}
		},

		modalOnConfirmTrafficControl() {
			this.showTempTrafficControlModal = false;
			// this.laneClosureRequest.tempTrafficControl.value = 1;
		},
		modalOnCancelTrafficControl() {
			this.showTempTrafficControlModal = false;
			this.laneClosureRequest.tempTrafficControl.value = 0;
		},
		modalOnConfirmShowMap() {
			this.showNoBlocksModal = false;
			this.showConfirmBlocksModal = false;
			let that = this;
			Vue.prototype.$bus.$emit("map:toggleAndZoom", 1);
			window.setTimeout(function() {
				Vue.prototype.$bus.$emit("map:streetSearch", Format.streetSearch(that.laneClosureRequest.affectedStreet.value, that.laneClosureRequest.firstCrossStreet.value));
			}, 250);
		},
		modalOnConfirmNotShowMap() {
			this.showNoBlocksModal = false;
			this.showConfirmBlocksModal = false;

			Vue.prototype.$bus.$emit("map:streetSearch", Format.streetSearch(this.laneClosureRequest.affectedStreet.value, this.laneClosureRequest.firstCrossStreet.value));
		},
		mapButtonText() {
			if (this.hideMap) {
				return "Hide Map";
			} else {
				return "Show Map";
			}
		},


		onAffectedStreetInput(value, instance) {
			if (value == null) {
				this.laneClosureRequest.affectedStreet.value = null;
				this.laneClosureRequest.firstCrossStreet.value = null;
				this.laneClosureRequest.lastCrossStreet.value = null;
				this.firstCrossStreetOptions = this.noFirstCrossStreetOptions;
				this.lastCrossStreetOptions = this.noLastCrossStreetOptions;
				this.laneClosureRequest.affectedStreet.validate();
				return;
			}
			this.laneClosureRequest.affectedStreet.value = value.id;
			this.laneClosureRequest.affectedStreet.setDirty();
			this.laneClosureRequest.affectedStreet.validate();
			let that = this;
			// TODO: Do we clear the first cross street and last cross street?
			// fill the first cross and last cross street names...
			Vue.prototype.$http.post(this.$store.state.apiUrl + '/block/cross-street', { affectedStreetName: value.id })
			.then(resp => {
				if (resp.data.length == 0) {
					that.firstCrossStreetOptions = that.noFirstCrossStreetOptions;
					that.lastCrossStreetOptions = that.noLastCrossStreetOptions;
					that.laneClosureRequest.firstCrossStreet.value = null;
					that.laneClosureRequest.lastCrossStreet.value = null;
				} else {
					that.firstCrossStreetOptions = resp.data;
					that.firstCrossStreetOptions.unshift({text: "Select a Cross Street", value: null, disabled: true});
					that.lastCrossStreetOptions = resp.data;
				}

				if (that.firstCrossStreetOptions.filter(x => x.value == that.laneClosureRequest.firstCrossStreet.value).length == 0) {
					that.laneClosureRequest.firstCrossStreet.value = null;
					this.$store.commit('map/clearMap', null);
				}
				if (that.lastCrossStreetOptions.filter(x => x.value == that.laneClosureRequest.lastCrossStreet.value).length == 0) {
					that.laneClosureRequest.lastCrossStreet.value = null;
					this.$store.commit('map/clearMap', null);
				}

				this.loadBlocks();

					// that.setFirstCrossStreetMapMarker();
					// that.setLastCrossStreetMapMarker();
				})
			.catch(error => {})

		},
		onAffectedStreetSearch(input) {
			this.laneClosureRequest.directionId.resetStatus();
			if (input != '') {
				this.isAffectedStreetsLoading = true;
				this.$store.dispatch("laneClosureList/searchActiveStreetByName", input)
				.then(res => {
					this.affectedStreetOptions = [];
					var item = {};
					for (var x = 0; x < res.length; x++) {
						var item = {
							id: `${res[x].streetName}`,
							label: `${res[x].streetName}`,
						}
						this.affectedStreetOptions.push(item);
					}
					this.isAffectedStreetsLoading = false;
				})
			}
		},
		onViewLaneClosureRequest() {
			if (this.laneClosureRequest.id) {
				this.$router.push({ name: "ViewLaneClosureRequest", params: { id: this.laneClosureRequest.id } });
			}
		},
		onBackToContraventions() {
			this.$router.push({ name: "ReportContraventionSearch" });
		},
		onFromTimeContext(ctx) {
			this.contextFromTime = ctx;
		},

		forceRerender() {
			this.renderCounter += 1;
			this.blockDetailsKey = "blockDetailsKey-" + this.renderCounter;
			this.blockClosuresRestrictionsKey = "blockClosuresRestrictionsKey-" + this.renderCounter;
			this.blockEditDetailsKey = "blockEditDetailsKey-" + this.renderCounter;
			this.forceRerenderBlockEditDetails();
		},

		calculateLcrTrafficEffectText() {
			let effect = "";

			// if (this.laneClosureRequest.affectedStreet.value) {
			// 	effect += this.laneClosureRequest.affectedStreet.value;
			// }
			// if (this.laneClosureRequest.directionId.value) {
			// 	effect += " " + LaneClosureRequest.getDirectionText(this.laneClosureRequest.directionId.value).toLowerCase();
			// }
			// effect += ", ";

			// if (this.laneClosureRequest.firstCrossStreet.value) {
			// 	effect += " " + this.laneClosureRequest.firstCrossStreet.value;
			// 	effect += " to";
			// }
			// if (this.laneClosureRequest.lastCrossStreet.value) {
			// 	effect += " " + this.laneClosureRequest.lastCrossStreet.value;
			// }

			// get each block set...
			var comma = "";
			if (this.laneClosureRequest.presetBlock) {
				for (let x = 0; x < this.laneClosureRequest.presetBlock[0].lane.length; x++) {
					if (this.laneClosureRequest.presetBlock[0].lane[x]) {
						effect += comma + LaneClosureRequest.getLaneTextEffect(this.laneClosureRequest.presetBlock[0].lane[x].laneId.value).toLowerCase();
						comma = ", ";
					}
				}

				for (let x = 0; x < this.laneClosureRequest.presetBlock[0].bicycle.length; x++) {
					if (this.laneClosureRequest.presetBlock[0].bicycle[x]) {
						effect += comma + LaneClosureRequest.getBicycleLaneText(this.laneClosureRequest.presetBlock[0].bicycle[x].bicycleLaneId.value).toLowerCase();
						comma = ", ";
					}
				}

				for (let x = 0; x < this.laneClosureRequest.presetBlock[0].sidewalk.length; x++) {
					if (this.laneClosureRequest.presetBlock[0].sidewalk[x]) {
						effect += comma + LaneClosureRequest.getSidewalkText(this.laneClosureRequest.presetBlock[0].sidewalk[x].sidewalkId.value).toLowerCase();
						comma = ", ";
					}
				}
			}
			if (effect && this.laneClosureRequest && this.laneClosureRequest.natureOfWorkId.value != null) {
				let natureOfWorkTextEffect = "";
				if (LaneClosureRequest.getNatureOfWorkTextEffect(this.laneClosureRequest.natureOfWorkId.value) != null) {
					natureOfWorkTextEffect = LaneClosureRequest.getNatureOfWorkTextEffect(this.laneClosureRequest.natureOfWorkId.value).toLowerCase()
				}
				effect += ", closed for " + natureOfWorkTextEffect;
			}
			if (effect) effect += ".";

			// indicate if the lane(s) will be open during any rush hour.
			let lastPeakId = 0;
			let multiplePeaks = false;
			// Just put the full text in, don't shorten it, as its buggy.
			multiplePeaks = true;
			/*
			for (let x = 0; x < this.laneClosureRequest.presetBlock[0].lane.length; x++) {
				if (this.laneClosureRequest.presetBlock[0].lane[x]) {
					if (this.laneClosureRequest.presetBlock[0].lane[x].peakId.value == 1
					|| this.laneClosureRequest.presetBlock[0].lane[x].peakId.value == 8
					|| this.laneClosureRequest.presetBlock[0].lane[x].peakId.value == 14) {
						if (lastPeakId == 0) {
							lastPeakId = this.laneClosureRequest.presetBlock[0].lane[x].peakId.value;
						} else {
							if (this.laneClosureRequest.presetBlock[0].lane[x].peakId.value != lastPeakId) {
								multiplePeaks = true;
							}
						}
					}
				}
			}
			*/
			if (!multiplePeaks && lastPeakId > 0) {
				effect += "  Lanes " + LaneClosureRequest.getLanePeakReasonTextEffect(lastPeakId);
			} else {
				// do all of the 1...
				let comma = "";
				// let hasPeak = false;
				let reopenText = null;
				for (let x = 0; x < this.laneClosureRequest.presetBlock[0].lane.length; x++) {
					if (this.laneClosureRequest.presetBlock[0].lane[x]) {
							reopenText = LaneClosureRequest.getLanePeakReasonTextEffect(this.laneClosureRequest.presetBlock[0].lane[x].peakId.value);
							// hasPeak = false;
						if (reopenText != null) {
							effect += " "+ comma +  LaneClosureRequest.getLaneTextEffect(this.laneClosureRequest.presetBlock[0].lane[x].laneId.value);
							comma = " ";
							effect += " " + LaneClosureRequest.getLanePeakReasonTextEffect(this.laneClosureRequest.presetBlock[0].lane[x].peakId.value);
						}
					}
				}

				/*
				hasPeak = false;
				peakId = 8;
				comma = "";
				for (let x = 0; x < this.laneClosureRequest.presetBlock[0].lane.length; x++) {
					if (this.laneClosureRequest.presetBlock[0].lane[x]) {
						if (this.laneClosureRequest.presetBlock[0].lane[x].peakId.value == peakId) {
							effect += " "+ comma +  LaneClosureRequest.getLaneTextEffect(this.laneClosureRequest.presetBlock[0].lane[x].laneId.value);
							hasPeak = true;
							comma = ", ";
						}
					}
				}
				if (hasPeak) {
					effect += " " + LaneClosureRequest.getLanePeakReasonTextEffect(peakId);
				}



				hasPeak = false;
				peakId = 14;
				comma = "";
				for (let x = 0; x < this.laneClosureRequest.presetBlock[0].lane.length; x++) {
					if (this.laneClosureRequest.presetBlock[0].lane[x]) {
						if (this.laneClosureRequest.presetBlock[0].lane[x].peakId.value == peakId) {
							effect += " "+ comma +  LaneClosureRequest.getLaneTextEffect(this.laneClosureRequest.presetBlock[0].lane[x].laneId.value);
							hasPeak = true;
							comma = ", ";
						}
					}
				}
				if (hasPeak) {
					effect += " " + LaneClosureRequest.getLanePeakReasonTextEffect(peakId);
				}
				*/
			}

			effect = Format.capitalizeFirstLetter(effect);

			return effect;
		},


		forceRerenderBlockEditDetails() {
			this.blockEditDetailsKeyCounter += 1;
			this.blockEditDetailsKey = "blockEditDetailsKey-" + this.blockEditDetailsKeyCounter;
		},


		hasSidewalkId(id) {
			let found = false;
			let xx = 0;
			let x = 0;
			if (id == null) {
				if (this.laneClosureRequest.presetBlock[0].sidewalk.length > 0) {
					return true;
				}
				return false;
			}
			if (this.laneClosureRequest) {
				for (xx = 0; xx < this.laneClosureRequest.block.length; xx++) {
					if (this.laneClosureRequest.block[xx].sidewalk) {
						for (x = 0; x < this.laneClosureRequest.block[xx].sidewalk.length; x++) {
							if (this.laneClosureRequest.block[xx].sidewalk[x].sidewalkId.value + "" == "" + id) {
								found = true;
							}
						}
					}
				}
			}
			return found;
		},
		hasLaneId(id) {
			let found = false;
			let xx = 0;
			let x = 0;
			if (id == null) {
				if (this.laneClosureRequest.presetBlock[0].lane.length > 0) {
					return true;
				}
				return false;
			}
			if (this.laneClosureRequest) {
				for (xx = 0; xx < this.laneClosureRequest.presetBlock[0].lane.length; xx++) {
					if (this.laneClosureRequest.presetBlock[0].lane[xx].laneId.value == id) {
						return true;
					}
				}
				for (xx = 0; xx < this.laneClosureRequest.block.length; xx++) {
					if (this.laneClosureRequest.block[xx].lane) {
						for (x = 0; x < this.laneClosureRequest.block[xx].lane.length; x++) {
							if (this.laneClosureRequest.block[xx].lane[x].laneId.value + "" == "" + id) {
								found = true;
							}
						}
					}
				}
			}

			return found;
		},

		hasBicycleId(id) {
			let found = false;
			let xx = 0;
			let x = 0;
			if (id == null) {
				if (this.laneClosureRequest.presetBlock[0].bicycle.length > 0) {
					return true;
				}
				return false;
			}
			if (this.laneClosureRequest) {
				for (xx = 0; xx < this.laneClosureRequest.block.length; xx++) {
					if (this.laneClosureRequest.block[xx].bicycle) {
						for (x = 0; x < this.laneClosureRequest.block[xx].bicycle.length; x++) {
							if (this.laneClosureRequest.block[xx].bicycle[x].bicycleLaneId.value + "" == "" + id) {
								found = true;
							}
						}
					}
				}
			}
			return found;
		},
		hasRestrictionTypeId(id, directionId) {
			let found = false;
			let xx = 0;
			let x = 0;
			if (id == null) {
				if (this.laneClosureRequest.presetBlock[0].restriction.length > 0) {
					return true;
				}
				return false;
			}
			if (this.laneClosureRequest) {
				for (xx = 0; xx < this.laneClosureRequest.block.length; xx++) {
					if (this.laneClosureRequest.block[xx].restriction) {
						for (x = 0; x < this.laneClosureRequest.block[xx].restriction.length; x++) {
							if (this.laneClosureRequest.block[xx].restriction[x].restrictionTypeId.value + "" == "" + id &&
							this.laneClosureRequest.block[xx].restriction[x].directionId.value + "" == "" + directionId) {
								found = true;
						}
					}
				}
			}
		}
		return found;
	},
	protectedBikeLaneModalOkClick() {
		this.showProtectedBikeLaneModal = false;
		this.isEditingBlock = false;
		this.updateTrafficEffect();
		this.forceRerender();
	},
	timeConflictTitle() {
		if (this.conflictingLaneClosureRequest) {
			if (this.conflictingLaneClosureRequest.conflictType.value == "duration") {
				return "Street and Duration Conflict";
			}
			if (this.conflictingLaneClosureRequest.conflictType.value == "adjacent_start_date") {
				return "Start Date Adjacent to Approved Request";
			}
			if (this.conflictingLaneClosureRequest.conflictType.value == "adjacent_end_date") {
				return "End Date Adjacent to Approved Request";
			}
		}
		return "";
	},

	getLevelClassName(level) {
		return "level-" + level;
	},
	getFlatTree(option) {
		if (option.namePath) {
			return Format.pipesToFlatTree(option.namePath);
		} else {
			return option.name;
		}
	},

	setWorkForId(val) {
		let orgs = this.$store.getters['organizationList/getRecords'] || [];

		let x = 0;
		for (x = 0; x < orgs.length; x++) {
			if (val == orgs[x].id) {
					// this.organizationInfo = orgs[x];
					this.laneClosureRequest.workDoneForId.value = orgs[x];
					this.laneClosureRequest.workDoneForNamePath.value = orgs[x].namePath;
					return;
				}
			}

			this.$nextTick(() => {
				this.workDoneForOrgId = null;
				this.laneClosureRequest.workDoneForId.value = null;
			})
		},
		setEventBusOff() {
			this.$bus.$off("attachment:updateComment", this.SaveAttachmentComment);
			this.$bus.$off("attachment:autoSave", this.SaveAttachmentComment);
			this.$bus.$off("attachment:delete", this.deleteAttachment);
			this.$bus.$off('map:click', this.onMapClick);
			this.$bus.$off('map:block-click', this.onMapBlockClick);
			this.$bus.$off('map:block-edit', this.onMapBlockEdit);
			this.$bus.$off('map:block-polyline-click', this.onMapBlockPolylineClick);
			this.$bus.$off('map:block-remove', this.onMapBlockRemove);
			this.$bus.$off('map:block-remove-all', this.onMapBlockRemoveAll);


			this.$bus.$off('block:protected-bike-lane', this.onProtectedBikeLane);

			this.$bus.$off('block:save', this.onSaveBlock);
			this.$bus.$off('block:edit', this.onEditBlock);
			this.$bus.$off('block:edit-lanes', this.onEditBlockLanes);
			this.$bus.$off('block:edit-bicycle', this.onEditBlockBicycle);
			this.$bus.$off('block:edit-sidewalk', this.onEditBlockSidewalk);
			this.$bus.$off('block:edit-restriction', this.onEditBlockRestriction);

			this.$bus.$off('block:remove-block', this.onRemoveBlock);
			this.$bus.$off('block:show-on-map', this.showBlockOnMap);

			this.$bus.$off('block:add-lane', this.onAddLane);
			this.$bus.$off('block:remove-lane', this.onRemoveLane);

			this.$bus.$off('block:add-sidewalk', this.onAddSidewalk);
			this.$bus.$off('block:remove-sidewalk', this.onRemoveSidewalk);
			this.$bus.$off('block:add-bicycle', this.onAddBicycle);
			this.$bus.$off('block:remove-bicycle', this.onRemoveBicycle);
			this.$bus.$off('block:add-restriction', this.onAddRestriction);
			this.$bus.$off('block:remove-restriction', this.onRemoveRestriction);
			this.$bus.$off('block:apply-changes', this.onApplyChanges);

			this.$bus.$off('block:toggle-expand-lane', this.onToggleExpandLane);
			this.$bus.$off('block:toggle-expand-sidewalk', this.onToggleExpandSidewalk);
			this.$bus.$off('block:toggle-expand-bicycle', this.onToggleExpandBicycle);
			this.$bus.$off('block:toggle-expand-restriction', this.onToggleExpandRestriction);


			this.$bus.$off('block:list-expand-lane', this.onToggleExpandCustomizeLane);
			this.$bus.$off('block:list-expand-sidewalk', this.onToggleExpandCustomizeSidewalk);
			this.$bus.$off('block:list-expand-bicycle', this.onToggleExpandCustomizeBicycle);
			this.$bus.$off('block:list-expand-restriction', this.onToggleExpandCustomizeRestriction);
			this.$bus.$off('block:list-expand-trafficSignalsAltered', this.onToggleExpandCustomizeTrafficSingalsAltered);

			this.$bus.$off('block:list-add-lane', this.onBlockListAddLane);
			this.$bus.$off('block:list-add-sidewalk', this.onBlockListAddSidewalk);
			this.$bus.$off('block:list-add-bicycle', this.onBlockListAddBicycle);
			this.$bus.$off('block:list-add-restriction', this.onBlockListAddRestriction);
			this.$bus.$off('block:list-add-restriction-modal', this.onBlockListAddRestrictionModal);
			this.$bus.$off('block:list-add-trafficSignalsAltered', this.onBlockListAddTrafficSignalsAltered);
			this.$bus.$off('block:list-remove-lane', this.onBlockListRemoveLane);
			this.$bus.$off('block:list-remove-sidewalk', this.onBlockListRemoveSidewalk);
			this.$bus.$off('block:list-remove-bicycle', this.onBlockListRemoveBicycle);
			this.$bus.$off('block:list-remove-restriction', this.onBlockListRemoveRestriction);
			this.$bus.$off('block:list-remove-restriction-street', this.onBlockListRemoveRestrictionStreetName);
			this.$bus.$off('block:list-remove-trafficSignalsAltered', this.onBlockListRemoveTrafficSignalsAltered);


			this.$bus.$off('block:add-sidewalk', this.onAddSidewalk);
			this.$bus.$off('block:add-lane', this.onAddBlockLane);

			this.$bus.$off('preset-block:updated', this.onPresetBlockUpdated);
			this.$bus.$off('preset-block:add-lane', this.onPresetAddClosure);
			this.$bus.$off('preset-block:remove-lane', this.onPresetRemoveLane);
			this.$bus.$off('preset-block:add-sidewalk', this.onPresetAddSidewalk);
			this.$bus.$off('preset-block:remove-sidewalk', this.onPresetRemoveSidewalk);
			this.$bus.$off('preset-block:add-bicycle', this.onPresetAddBicycle);
			this.$bus.$off('preset-block:remove-bicycle', this.onPresetRemoveBicycle);
			this.$bus.$off('preset-block:add-restriction', this.onPresetAddRestriction);
			this.$bus.$off('preset-block:remove-restriction', this.onPresetRemoveRestriction);
			this.$bus.$off('preset-block:all-restrictions-in-effect', this.onPresetAllRestrictionsInEffect);
			this.$bus.$off('preset-block:all-restrictions-removed', this.onPresetAllRestrictionsRemoved);
			this.$bus.$off('preset-block:apply-changes', this.onPresetApplyChanges);

			this.$bus.$off('preset-block:expand-lane', this.onToggleExpandPresetLane);
			this.$bus.$off('preset-block:expand-sidewalk', this.onToggleExpandPresetSidewalk);
			this.$bus.$off('preset-block:expand-bicycle', this.onToggleExpandPresetBicycle);
			this.$bus.$off('preset-block:expand-restriction', this.onToggleExpandPresetRestriction);
			this.$bus.$off('preset-block:expand-trafficSignalsAltered', this.onToggleExpandPresetTrafficSignalsAltered);


			this.$bus.$off('preset-block:collapse-lanes', this.onCollapsePresetLanes);
			this.$bus.$off('preset-block:collapse-sidewalks', this.onCollapsePresetSidewalks);
			this.$bus.$off('preset-block:collapse-bicycles', this.onCollapsePresetBicycles);
			this.$bus.$off('preset-block:collapse-restrictions', this.onCollapsePresetRestrictions);
			this.$bus.$off('preset-block:expand-single-lane', this.onToggleExpandPresetLaneSingle);
			this.$bus.$off('preset-block:expand-single-sidewalk', this.onToggleExpandPresetSidewalkSingle);
			this.$bus.$off('preset-block:expand-single-bicycle', this.onToggleExpandPresetBicycleSingle);
			this.$bus.$off('preset-block:expand-single-restriction', this.onToggleExpandPresetRestrictionSingle);
			this.$bus.$off('preset-block:expand-single-trafficSignalsAltered', this.onToggleExpandPresetTrafficSignalsAlteredSingle);

			this.$bus.$off('swipe:right', this.onSwipeRight);

			this.$bus.$off('map:shown', this.changeToHideMap);
			this.$bus.$off('map:hidden', this.changeToShowMap);
		},
		setEventBusOn() {
			this.setEventBusOff();
			this.$bus.$on("attachment:updateComment", this.SaveAttachmentComment);
			this.$bus.$on("attachment:autoSave", this.SaveAttachmentComment);
			this.$bus.$on("attachment:delete", this.deleteAttachment);

			this.$bus.$on('map:click', this.onMapClick);
			this.$bus.$on('map:block-click', this.onMapBlockClick);
			this.$bus.$on('map:block-edit', this.onMapBlockEdit);
			this.$bus.$on('map:block-polyline-click', this.onMapBlockPolylineClick);
			this.$bus.$on('map:block-remove', this.onMapBlockRemove);
			this.$bus.$on('map:block-remove-all', this.onMapBlockRemoveAll);

			this.$bus.$on('block:remove-block', this.onRemoveBlock);

			this.$bus.$on('block:toggle-expand-lane', this.onToggleExpandLane);
			this.$bus.$on('block:toggle-expand-sidewalk', this.onToggleExpandSidewalk);
			this.$bus.$on('block:toggle-expand-bicycle', this.onToggleExpandBicycle);
			this.$bus.$on('block:toggle-expand-restriction', this.onToggleExpandRestriction);

			this.$bus.$on('block:list-remove-lane', this.onBlockListRemoveLane);
			this.$bus.$on('block:list-remove-sidewalk', this.onBlockListRemoveSidewalk);
			this.$bus.$on('block:list-remove-bicycle', this.onBlockListRemoveBicycle);
			this.$bus.$on('block:list-remove-restriction', this.onBlockListRemoveRestriction);
			this.$bus.$on('block:list-remove-restriction-street', this.onBlockListRemoveRestrictionStreetName);
			this.$bus.$on('block:list-remove-trafficSignalsAltered', this.onBlockListRemoveTrafficSignalsAltered);

			this.$bus.$on('block:list-add-lane', this.onBlockListAddLane);
			this.$bus.$on('block:list-add-sidewalk', this.onBlockListAddSidewalk);
			this.$bus.$on('block:list-add-bicycle', this.onBlockListAddBicycle);
			this.$bus.$on('block:list-add-restriction', this.onBlockListAddRestriction);
			this.$bus.$on('block:list-add-restriction-modal', this.onBlockListAddRestrictionModal);
			this.$bus.$on('block:list-add-trafficSignalsAltered', this.onBlockListAddTrafficSignalsAltered);

			this.$bus.$on('block:list-expand-lane', this.onToggleExpandCustomizeLane);
			this.$bus.$on('block:list-expand-sidewalk', this.onToggleExpandCustomizeSidewalk);
			this.$bus.$on('block:list-expand-bicycle', this.onToggleExpandCustomizeBicycle);
			this.$bus.$on('block:list-expand-restriction', this.onToggleExpandCustomizeRestriction);
			this.$bus.$on('block:list-expand-trafficSignalsAltered', this.onToggleExpandCustomizeTrafficSingalsAltered);

			this.$bus.$on('preset-block:collapse-lanes', this.onCollapsePresetLanes);
			this.$bus.$on('preset-block:collapse-sidewalks', this.onCollapsePresetSidewalks);
			this.$bus.$on('preset-block:collapse-bicycles', this.onCollapsePresetBicycles);
			this.$bus.$on('preset-block:collapse-restrictions', this.onCollapsePresetRestrictions);

			this.$bus.$on('preset-block:expand-single-lane', this.onToggleExpandPresetLaneSingle);
			this.$bus.$on('preset-block:expand-single-sidewalk', this.onToggleExpandPresetSidewalkSingle);
			this.$bus.$on('preset-block:expand-single-bicycle', this.onToggleExpandPresetBicycleSingle);
			this.$bus.$on('preset-block:expand-single-restriction', this.onToggleExpandPresetRestrictionSingle);
			this.$bus.$on('preset-block:expand-single-trafficSignalsAltered', this.onToggleExpandPresetTrafficSignalsAlteredSingle);


			this.$bus.$on('block:add-lane', this.onAddBlockLane);
			this.$bus.$on('block:show-on-map', this.showBlockOnMap);
			this.$bus.$on('block:protected-bike-lane', this.onProtectedBikeLane);

			this.$bus.$on('block:save', this.onSaveBlock);
			this.$bus.$on('block:edit', this.onEditBlock);

			this.$bus.$on('block:edit-lanes', this.onEditBlockLanes);
			this.$bus.$on('block:edit-bicycle', this.onEditBlockBicycle);
			this.$bus.$on('block:edit-sidewalk', this.onEditBlockSidewalk);
			this.$bus.$on('block:edit-restriction', this.onEditBlockRestriction);

			this.$bus.$on('block:add-lane', this.onAddLane);
			this.$bus.$on('block:remove-lane', this.onRemoveLane);

			this.$bus.$on('block:add-sidewalk', this.onAddSidewalk);
			this.$bus.$on('block:remove-sidewalk', this.onRemoveSidewalk);

			this.$bus.$on('block:add-bicycle', this.onAddBicycle);
			this.$bus.$on('block:remove-bicycle', this.onRemoveBicycle);

			this.$bus.$on('block:add-restriction', this.onAddRestriction);
			this.$bus.$on('block:remove-restriction', this.onRemoveRestriction);
			this.$bus.$on('block:apply-changes', this.onApplyChanges);

			this.$bus.$on('preset-block:updated', this.onPresetBlockUpdated);

			this.$bus.$on('preset-block:add-lane', this.onPresetAddClosure);
			this.$bus.$on('preset-block:remove-lane', this.onPresetRemoveLane);

			this.$bus.$on('preset-block:add-sidewalk', this.onPresetAddSidewalk);
			this.$bus.$on('preset-block:remove-sidewalk', this.onPresetRemoveSidewalk);

			this.$bus.$on('preset-block:add-bicycle', this.onPresetAddBicycle);
			this.$bus.$on('preset-block:remove-bicycle', this.onPresetRemoveBicycle);

			this.$bus.$on('preset-block:add-restriction', this.onPresetAddRestriction);
			this.$bus.$on('preset-block:remove-restriction', this.onPresetRemoveRestriction);

			this.$bus.$on('preset-block:expand-lane', this.onToggleExpandPresetLane);
			this.$bus.$on('preset-block:expand-sidewalk', this.onToggleExpandPresetSidewalk);
			this.$bus.$on('preset-block:expand-bicycle', this.onToggleExpandPresetBicycle);
			this.$bus.$on('preset-block:expand-restriction', this.onToggleExpandPresetRestriction);
			this.$bus.$on('preset-block:all-restrictions-in-effect', this.onPresetAllRestrictionsInEffect);
			this.$bus.$on('preset-block:all-restrictions-removed', this.onPresetAllRestrictionsRemoved);

			this.$bus.$on('preset-block:expand-trafficSignalsAltered', this.onToggleExpandPresetTrafficSignalsAltered);



			this.$bus.$on('swipe:right', this.onSwipeRight);


			this.$bus.$on('preset-block:apply-changes', this.onPresetApplyChanges);

			this.$bus.$on('map:shown', this.changeToHideMap);
			this.$bus.$on('map:hidden', this.changeToShowMap);
		},

		disableShouldGoTostep1() {
			this.shouldGoToStep1 = false;
		},
		onWizardLoading: function(obj) {},
		zoomAllBlocks() {
			this.$store.dispatch("map/zoomAllBlocks", null);
			let x = 0;
			for (x = 0; x < this.$store.getters["map/polylines"].length; x++) {
				if (this.$store.getters["map/polylines"][x]) {
					if (this.$store.getters["map/polylines"][x].blockData) {
						this.$store.getters["map/polylines"][x].setOptions({ strokeColor: '#293C7C' });
					}
				}
			}
		},
		SaveAttachmentComment(obj) {
			this.isButtonDisabled = true;

			if (obj.comments != null && obj.comments != "" && obj.attachmentId != null) {
				let postData = {
					comments: obj.comments
				}
				Vue.prototype.$http({
					method: 'post',
					url: `${this.$store.state.apiUrl}/attachment/${obj.attachmentId}/comment?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: postData
				}).then(resp => {

				}).catch(error => {
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						// this.laneClosureRequest.SetErrors(error.response.data);
						if (error.response) {
							this.showErrors(error.response.data.fields);
						}
					} else {
						// ErrorHandler.RedirectToLogin();
					}
				}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},
		deleteAttachment(obj) {
			//edit request tab DCZ, Transit, Parking
			this.isButtonDisabled = true;
			if (obj.userId != null && obj.attachmentId != null) {
				Vue.prototype.$http({
					method: 'delete',
					url: `${this.$store.state.apiUrl}/attachment/${obj.attachmentId}/delete?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: obj
				}).then(resp => {
					if(resp.status === 200){
						// Find the index of the attachment with the given id
						const index = this.laneClosureRequest.attachment.findIndex((attachment) => attachment.id === obj.attachmentId);
						// If found, remove it from the array TO hide the deleted attachment tile from view
						if (index !== -1) {
							this.laneClosureRequest.attachment.splice(index, 1);
						}
					}
				}).catch(error => {
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						if (error.response) {
							this.laneClosureRequest.SetErrors(error.response.data);
							this.showErrors(error.response.data.fields);
						}
					}
				}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},
		handleFilePondAddFile(e, file, m) {
			this.isButtonDisabled = true;
		},
		handleFilePondInit: function() {
			this.$refs.pond._pond.setOptions({
				server: {
					header: {
						Authorization: "Bearer " + this.$store.state.token
					},
					process: {
						method: 'POST',
						url: `${this.$store.state.apiUrl}/attachment/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
						withCredentials: true
					},
				}
			});
			this.$refs.pond._pond.setOptions({
				fileMetadataObject: {
					comments: null
				},
				allowImagePreview: false,
				allowRevert: false,
				allowReorder: false,
				allowReplace: false,
				server: {
					url: `${this.$store.state.apiUrl}/attachment/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					headers: {
						Authorization: "Bearer " + this.$store.state.token
					}
				}
			});
		},
		handleFilePondProcessFileStart(e,p) {
			this.isButtonDisabled = true;
		},
		handleFilePondProcessAllFiles(e,p) {
			this.isButtonDisabled = false;
		},
		handleFilePondProcessError(e,p) {
			this.isButtonDisabled = false;
		},
		handleFilePondProcessAbort(e,p) {
			this.isButtonDisabled = false;
		},
		handleFilePondProcessFile(e, p) {
			if (p.error) {
				// there was a problem!
			} else {
				let attachmentData = JSON.parse(p.serverId);
				this.downloadToken = attachmentData.downloadToken;
				this.downloadTokenExpires = attachmentData.downloadTokenExpires;
				this.laneClosureRequest.attachment.unshift(new Attachment(attachmentData.attachment));
			}
		},
		handleFilePondContraventionInit: function() {
			this.$refs.pondContravention._pond.setOptions({
				server: {
					header: {
						Authorization: "Bearer " + this.$store.state.token
					},
					process: {
						method: 'POST',
						url: `${this.$store.state.apiUrl}/attachment/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
						withCredentials: true
					},
				}
			});
			this.$refs.pondContravention._pond.setOptions({
				fileMetadataObject: {
					comments: null
				},
				allowImagePreview: false,
				allowRevert: false,
				allowReorder: false,
				allowReplace: false,
				server: {
					url: `${this.$store.state.apiUrl}/attachment/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					headers: {
						Authorization: "Bearer " + this.$store.state.token
					}
				}
			});
		},

		handleFilePondContraventionAddFile(e, file, m) {},

		handleFilePondContraventionProcessFile(e, p) {
			if (p.error) {
				// there was a problem!
			} else {
				let attachmentData = JSON.parse(p.serverId);
				this.downloadToken = attachmentData.downloadToken;
				this.downloadTokenExpires = attachmentData.downloadTokenExpires;
				this.contravention.attachment.unshift(new Attachment(attachmentData.attachment));
			}
		},
		loadBlocks() {
			this.showNoBlocksModal = false;
			this.showConfirmBlocksModal = false;
			this.validateConfirmedBlocks.value = 0;

			clearTimeout(this.loadBlocksTimeout);
			this.loadBlocksTimeout = setTimeout(() => {

				if (this.laneClosureRequest == null) {
					return;
				}
				if (this.laneClosureRequest.directionId.value == null) {
					return;
				}
				if (this.laneClosureRequest.affectedStreet.value == null) {
					return;
				}
				if (this.laneClosureRequest.firstCrossStreet.value == null) {
					return;
				}
				if (this.laneClosureRequest.lastCrossStreet.value == null) {
					return;
				}

				let that = this;
				// let res = null;
				if (!this.loadingBlocks) {
					this.loadingBlocks = true;
					this.loadedBlockData = [];

					this.$store.commit('map/clearMap', null);
					this.laneClosureRequest.block = [];

					Vue.prototype.$http.post(this.$store.state.apiUrl + '/block/first-last', { affectedStreetName: this.laneClosureRequest.affectedStreet.value, directionId: this.laneClosureRequest.directionId.value, firstCrossStreetName: this.laneClosureRequest.firstCrossStreet.value, lastCrossStreetName: this.laneClosureRequest.lastCrossStreet.value })
					.then(resp => {
						let ids = [];
						if (resp.data) {
							if (resp.data.blocks != null) {
								if (resp.data.blocks.length == 0) {
									// can't find any blocks... so lets show the error dialog.
									this.showNoBlocksModal = true;
								} else {
									for (var y = 0; y < resp.data.blocks.length; y++) {
										var found = 0;
										for (var z = 0; z < ids.length; z++) {
											if ("" + resp.data.blocks[y].id == "" + ids[z]) {
												found = 1;
											}
										}
										if (found == 0) {
											ids.push(resp.data.blocks[y].id);
											resp.data.blocks[y].blockId = resp.data.blocks[y].id;
											that.loadedBlockData.push(resp.data.blocks[y]);
										}
									}
								}
							} else {
								this.showNoBlocksModal = true;
							}
						} else {
							this.showNoBlocksModal = true;
						}
						this.loadedBlocksOnce = true;
						that.setLoadedBlockPolyline(0);
					})
					.catch(error => {
						that.loadingBlocks = false;
						this.loadedBlocksOnce = true;
					})
				}


			}, 2000);
		},

		setLoadedBlockPolyline(index) {
			if (this.loadedBlockData[index]) {
				for (var x = 0; x < this.loadedBlockData.length; x++) {
					this.setBlockPolyline(this.loadedBlockData[x]);
				}
				this.$nextTick(() => {
					for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
						this.applyPresetsToBlockIndex(x);
					}
					this.loadingBlocks = false;
					this.forceRerender();
					this.zoomAllBlocks();
					// refresh the side on the map.
					Vue.prototype.$bus.$emit("map:reset-side-bar",true);
					this.showConfirmBlocksModal = true;

				});
				// index++;
				// if (this.loadedBlockData[index]) {
				// } else {
				// }
			} else {
				// we're all done...

				this.loadingBlocks = false;
				// refresh the side on the map.
				Vue.prototype.$bus.$emit("map:reset-side-bar",true);
				this.forceRerender();
			}
		},

		hasRestrictions() {
			let found = false;
			let xx = 0;
			if (this.laneClosureRequest) {
				for (xx = 0; xx < this.laneClosureRequest.block.length; xx++) {
					if (this.laneClosureRequest.block[xx].restriction) {
						if (this.laneClosureRequest.block[xx].restriction.length > 0) {
							found = true;
						}
					}
				}
				if (found == false) {
					for (xx = 0; xx < this.laneClosureRequest.presetBlock.length; xx++) {
						if (this.laneClosureRequest.presetBlock[xx].restriction) {
							if (this.laneClosureRequest.presetBlock[xx].restriction.length > 0) {
								found = true;
							}
						}
					}
				}
			}
			return found;
		},
		onToggleExpandLane(value) {
			this.expandLane = value;
		},
		onToggleExpandSidewalk(value) {
			this.expandSidewalk = value;
		},
		onToggleExpandBicycle(value) {
			this.expandBicycle = value;
		},
		onToggleExpandRestriction(value) {},

		onToggleExpandPresetLane(value) {
			if (this.laneClosureRequest.presetBlock[0].lane[value.index]) {
				this.laneClosureRequest.presetBlock[0].lane[value.index].expand = value.expand;
				this.forceRerender();
			}
		},
		onToggleExpandPresetSidewalk(value) {
			if (this.laneClosureRequest.presetBlock[0].sidewalk[value.index]) {
				this.laneClosureRequest.presetBlock[0].sidewalk[value.index].expand = value.expand;
				this.forceRerender();
			}
		},
		onToggleExpandPresetBicycle(value) {
			if (this.laneClosureRequest.presetBlock[0].bicycle[value.index]) {
				this.laneClosureRequest.presetBlock[0].bicycle[value.index].expand = value.expand;
				this.forceRerender();
			}
		},
		onToggleExpandPresetRestriction(value) {
			if (this.laneClosureRequest.presetBlock[0].restriction[value.index]) {
				this.laneClosureRequest.presetBlock[0].restriction[value.index].expand = value.expand;
				this.forceRerender();
			}
		},

		onToggleExpandPresetTrafficSignalsAltered(value) {
			if (this.laneClosureRequest.presetBlock[0]) {
				this.laneClosureRequest.presetBlock[0].expandTrafficSignalsAltered = value.expand;
				this.forceRerender();
			}
		},

		onCollapsePresetLanes(value) {
			if (this.laneClosureRequest) {
				for(var x = 0; x < this.laneClosureRequest.presetBlock[0].lane.length; x++) {
					this.laneClosureRequest.presetBlock[0].lane[x].expand = false;
				}
				this.forceRerender();
			}
		},

		onCollapsePresetSidewalks(value) {
			if (this.laneClosureRequest) {
				for(var x = 0; x < this.laneClosureRequest.presetBlock[0].sidewalk.length; x++) {
					this.laneClosureRequest.presetBlock[0].sidewalk[x].expand = false;
				}
				this.forceRerender();
			}
		},
		onCollapsePresetBicycles(value) {
			if (this.laneClosureRequest) {
				for(var x = 0; x < this.laneClosureRequest.presetBlock[0].bicycle.length; x++) {
					this.laneClosureRequest.presetBlock[0].bicycle[x].expand = false;
				}
				this.forceRerender();
			}
		},
		onCollapsePresetRestrictions(value) {
			if (this.laneClosureRequest) {
				for(var x = 0; x < this.laneClosureRequest.presetBlock[0].restriction.length; x++) {
					this.laneClosureRequest.presetBlock[0].restriction[x].expand = false;
				}
				this.forceRerender();
			}
		},



		onToggleExpandPresetLaneSingle(value) {
			if (this.laneClosureRequest) {
				for(var x = 0; x < this.laneClosureRequest.presetBlock[0].lane.length; x++) {
					if (value.index == x) {
						if (this.laneClosureRequest.presetBlock[0].lane[value.index]) {
							this.laneClosureRequest.presetBlock[0].lane[value.index].expand = value.expand;
						}
					} else {
						if (this.laneClosureRequest.presetBlock[0].lane[x]) {
							this.laneClosureRequest.presetBlock[0].lane[x].expand = false;
						}
					}
				}
				this.forceRerender();
			}
		},
		onToggleExpandPresetSidewalkSingle(value) {
			if (this.laneClosureRequest) {
				for(var x = 0; x < this.laneClosureRequest.presetBlock[0].sidewalk.length; x++) {
					if (value.index == x) {
						if (this.laneClosureRequest.presetBlock[0].sidewalk[value.index]) {
							this.laneClosureRequest.presetBlock[0].sidewalk[value.index].expand = value.expand;
						}
					} else {
						if (this.laneClosureRequest.presetBlock[0].sidewalk[x]) {
							this.laneClosureRequest.presetBlock[0].sidewalk[x].expand = false;
						}
					}
				}
				this.forceRerender();
			}
		},
		onToggleExpandPresetBicycleSingle(value) {
			if (this.laneClosureRequest) {
				for(var x = 0; x < this.laneClosureRequest.presetBlock[0].bicycle.length; x++) {
					if (value.index == x) {
						if (this.laneClosureRequest.presetBlock[0].bicycle[value.index]) {
							this.laneClosureRequest.presetBlock[0].bicycle[value.index].expand = value.expand;
						}
					} else {
						if (this.laneClosureRequest.presetBlock[0].bicycle[x]) {
							this.laneClosureRequest.presetBlock[0].bicycle[x].expand = false;
						}
					}
				}
				this.forceRerender();
			}
		},
		onToggleExpandPresetRestrictionSingle(value) {
			if (this.laneClosureRequest) {
				for(var x = 0; x < this.laneClosureRequest.presetBlock[0].restriction.length; x++) {
					if (value.index == x) {
						if (this.laneClosureRequest.presetBlock[0].restriction[value.index]) {
							this.laneClosureRequest.presetBlock[0].restriction[value.index].expand = value.expand;
						}
					} else {
						if (this.laneClosureRequest.presetBlock[0].restriction[x]) {
							this.laneClosureRequest.presetBlock[0].restriction[x].expand = false;
						}
					}
				}
				this.forceRerender();
			}
		},

		onToggleExpandCustomizeLane(value) {
			this.expandCustomizeLane["" + value.laneId] = value.expand;
			this.forceRerender();
		},
		onToggleExpandCustomizeSidewalk(value) {
			this.expandCustomizeSidewalk["" + value.sidewalkId] = value.expand;
			this.forceRerender();
		},
		onToggleExpandCustomizeBicycle(value) {
			this.expandCustomizeBicycle["" + value.bicycleLaneId] = value.expand;
			this.forceRerender();
		},
		onToggleExpandCustomizeRestriction(value) {
			this.expandCustomizeRestriction["" + value.restrictionTypeId + "," + value.directionId] = value.expand;
			this.forceRerender();
		},


		anyExpanded() {
			var isExpanded = false;
			if (this.expandTrafficSignalsAltered) {
				return true;
			}
			if (this.laneClosureRequest.presetBlock[0].expandTrafficSignalsAltered == true) {
				return true;
			}
			for (var x in this.expandCustomizeLane) {
				if (this.expandCustomizeLane[x] == true) {
					isExpanded = true;
				}
			}
			if (isExpanded) {
				return true;
			}

			for (var x2 in this.expandCustomizeSidewalk) {
				if (this.expandCustomizeSidewalk[x2] == true) {
					isExpanded = true;
				}
			}
			if (isExpanded) {
				return true;
			}
			for (var x3 in this.expandCustomizeBicycle) {
				if (this.expandCustomizeBicycle[x3] == true) {
					isExpanded = true;
				}
			}
			if (isExpanded) {
				return true;
			}

			for (var x4 in this.expandCustomizeRestriction) {
				if (this.expandCustomizeRestriction[x4] == true) {
					isExpanded = true;
				}
			}

			for (var x5 in this.laneClosureRequest.presetBlock[0].lane) {
				if (this.laneClosureRequest.presetBlock[0].lane[x5].expand == true) {
					isExpanded = true;
				}
			}
			for (var x6 in this.laneClosureRequest.presetBlock[0].sidewalk) {
				if (this.laneClosureRequest.presetBlock[0].sidewalk[x6].expand == true) {
					isExpanded = true;
				}
			}
			for (var x7 in this.laneClosureRequest.presetBlock[0].bicycle) {
				if (this.laneClosureRequest.presetBlock[0].bicycle[x7].expand == true) {
					isExpanded = true;
				}
			}
			for (var x8 in this.laneClosureRequest.presetBlock[0].restriction) {
				if (this.laneClosureRequest.presetBlock[0].restriction[x8].expand == true) {
					isExpanded = true;
				}
			}

			if (isExpanded) {
				return true;
			}
		},
		onSwipeRight() {
			// if the sub transitions are open, close them, otherwise go back.
			if (this.anyExpanded()) {
				Vue.prototype.$bus.$emit("swipe:right:panel",null);
			} else {
				this.$router.go(-1);
			}
		},

		setAllBlocks() {
			for (var x = 0; x <= this.loadedBlockData.length; x++) {
				this.setBlockPolyline(this.loadedBlockData[x]);
			}
			for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				this.applyPresetsToBlockIndex(x);
			}
			this.forceRerender();
		},

		setBlockPolyline(block) {
			let that = this;
			let foundIndex = null;
			let blockPolyline = null;
			if (this.laneClosureRequest == null) {
				return;
			}
			if (block) {
				// find the existing marker/placemark.
				if (this.laneClosureRequest.block) {
					for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
						if (this.laneClosureRequest.block[x].blockId == block.blockId) {
							foundIndex = x;
							if (this.laneClosureRequest.block[x].mapPolyline) {
								blockPolyline = this.laneClosureRequest.block[x].mapPolyline;
							}
							if (that.$store.getters["map/polylines"]) {
								for (var xx = 0; xx < that.$store.getters["map/polylines"].length; xx++) {
									if (that.$store.getters["map/polylines"][xx]) {
										if (that.$store.getters["map/polylines"][xx].blockData.blockId == block.blockId) {
											blockPolyline = that.$store.getters["map/polylines"][xx];
										}
									}
								}
							}
						}
					}
				}
				if (foundIndex == null || blockPolyline == null) {
					// add the block to the map.
					// look for existing block in lane closure request, and select it.
					var myParser = new Vue.prototype.$geoXML3.parser({
						map: null,
						afterParse: function(doc) {
							let xx = 0;
							var coords = [];
							let zz = 0;
							for (xx = 0; xx < doc[0].gpolylines[0].latLngs.length; xx++) {
								for (zz = 0; zz < doc[0].gpolylines[0].latLngs.getAt(xx).length; zz++) {
									coords.push(new google.maps.LatLng(doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lat(), doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lng()));
								}
							}
							let mapPolyline = new google.maps.Polyline({
								map: that.$store.state.map.map,
								path: coords,
								strokeColor: '#666666',
								strokeOpacity: 1.0,
								strokeWeight: 8
							});
							mapPolyline.blockData = block;
							let mapIndex = -1;
							if (foundIndex == null) {
								let newBlock = new LaneClosureRequestBlock(block);
								that.laneClosureRequest.block.push(newBlock);
								foundIndex = that.laneClosureRequest.block.length - 1;
							}
							if (that.$store.getters["map/polylines"]) {
								for (x = 0; x < that.$store.getters["map/polylines"].length; x++) {
									if (that.$store.getters["map/polylines"][x]) {
										if (that.$store.getters["map/polylines"][x].blockData.blockId == block.blockId) {
											that.$store.commit("map/setPolylineByIndex", x, mapPolyline);
											mapIndex = x;
										}
									}
								}
							}
							if (mapIndex == -1) {
								// not found, so add the polyline.
								that.$store.commit("map/addPolyline", mapPolyline);
								if (that.clickedMap ) {
									that.validateConfirmedBlocks.value = 0;
								}
							}
							google.maps.event.addListener(mapPolyline, 'click', function(e) {
								// that.$bus.$emit('map:block-edit', this.blockData.blockId);
								that.$bus.$emit('map:block-polyline-click', this, e);
							});

							if (that.clickedMap) {
								that.clickedMap = false;

								for (x = 0; x < that.$store.getters["map/polylines"].length; x++) {
									if (that.$store.getters["map/polylines"][x].blockData.blockId == block.blockId) {
										that.$store.getters["map/polylines"][x].setOptions({
											strokeColor: "#f2b942",
										});
									} else {
										that.$store.getters["map/polylines"][x].setOptions({
											strokeColor: "#293C7C",
										});
									}
								}

								// its a new block, so lets apply the presets to it.
								that.applyPresetsToBlockIndex(that.laneClosureRequest.block.length - 1);

								that.$store.dispatch("map/zoomToBlockIdPopup", block.blockId);
								if (mapIndex == -1) {
									that.$bus.$emit('map:block-polyline-click', mapPolyline, null);
								}
							}

							return;
						}
					});
					let kmlString = "";
					if (block.kml != "") {
						let color = "7fff0000";
						if (block.streetName != that.laneClosureRequest.affectedStreet.value) {
							// turning restriction?
							color = "7f000000"
						}
						kmlString += KMLHelper.createPlaceMarkFromGeometry(block.blockId, block.streetName, block.fromStreet, block.toStreet, block.kml, color, "8");
						kmlString = KMLHelper.finalizeKml(kmlString);
						myParser.parseKmlString(kmlString);

					}
				} else {
					if (that.$refs.blockDetails) {
						that.$refs.blockDetails.editBlockById(block.blockId);
					}
				}
			}
		},

					/*
		setFirstCrossStreetMapMarker() {
			let that = this;
			if (this.laneClosureRequest && this.googleMapApi && this.$store.state.map) {
				if (this.laneClosureRequest.affectedStreet.value != "" && this.laneClosureRequest.firstCrossStreet.value != "") {
					var request = {
						query: Format.fixStreetSuffix(this.laneClosureRequest.affectedStreet.value) + " and " + Format.fixStreetSuffix(this.laneClosureRequest.firstCrossStreet.value) + ", Winnipeg",
						fields: ['name', 'geometry']
					};
					let service = new google.maps.places.PlacesService(this.$store.state.map.map);

					service.findPlaceFromQuery(request, function(results, status) {
						var myLatLng = null;
						if (results) {
							if (status === google.maps.places.PlacesServiceStatus.OK) {
								for (var i = 0; i < results.length; i++) {
									myLatLng = new google.maps.LatLng(results[i].geometry.location.lat(), results[i].geometry.location.lng());
									if (that.firstCrossStreetMarker == null) {
										that.firstCrossStreetMarker = new google.maps.Marker({
											position: myLatLng,
											map: that.$store.state.map.map,
											title: results[i].name,
											label: '1'
										});

										that.$store.commit("map/setMarkerByIndex", 0, that.firstCrossStreetMarker);

										google.maps.event.addListener(that.firstCrossStreetMarker, 'click', function() {
											Vue.prototype.$bus.$emit('map-first-cross-street-marker-click', this);
										});
									} else {
										that.firstCrossStreetMarker.setPosition(myLatLng);
										that.$store.commit("map/setMarkerByIndex", 0, that.firstCrossStreetMarker);

									}
								}
								that.setMapBoundaries();
							}
						}
					});
				}
			}
		},
		*/
		setMapBoundaries() {
			var bounds = new google.maps.LatLngBounds();
			if (this.firstCrossStreetMarker != null) {
				bounds.extend(new google.maps.LatLng(this.firstCrossStreetMarker.position.lat(), this.firstCrossStreetMarker.position.lng()));
			}
			if (this.lastCrossStreetMarker != null) {
				bounds.extend(new google.maps.LatLng(this.lastCrossStreetMarker.position.lat(), this.lastCrossStreetMarker.position.lng()));
			}
			// this.$store.state.map.map.setCenter(myLatLng);
			this.$store.state.map.map.fitBounds(bounds);
		},

					/*
		setLastCrossStreetMapMarker() {
			let that = this;
			if (this.laneClosureRequest && this.googleMapApi && this.$store.state.map) {
				if (this.laneClosureRequest.affectedStreet.value != "" && this.laneClosureRequest.lastCrossStreet.value != "") {
					var request = {
						query: Format.fixStreetSuffix(this.laneClosureRequest.affectedStreet.value) + " and " + Format.fixStreetSuffix(this.laneClosureRequest.lastCrossStreet.value) + ", Winnipeg",
						fields: ['name', 'geometry']
					};
					// let infowindow = new google.maps.InfoWindow();
					let service = new google.maps.places.PlacesService(this.$store.state.map.map);

					service.findPlaceFromQuery(request, function(results, status) {
						var myLatLng = null;
						if (results) {
							if (status === google.maps.places.PlacesServiceStatus.OK) {
								for (var i = 0; i < results.length; i++) {
									myLatLng = new google.maps.LatLng(results[i].geometry.location.lat(), results[i].geometry.location.lng());
									if (that.lastCrossStreetMarker == null) {
										that.lastCrossStreetMarker = new google.maps.Marker({
											position: myLatLng,
											map: that.$store.state.map.map,
											title: results[i].name,
											label: '2'
										});

										that.$store.commit("map/setMarkerByIndex", 1, that.lastCrossStreetMarker);
										google.maps.event.addListener(that.lastCrossStreetMarker, 'click', function() { Vue.prototype.$bus.$emit('map-last-cross-street-marker-click', this); });
									} else {
										that.lastCrossStreetMarker.setPosition(myLatLng);
										that.$store.commit("map/setMarkerByIndex", 1, that.lastCrossStreetMarker);
									}
								}
								that.setMapBoundaries();
							}
						}
					});
				}
			}

		},
		*/

		onWizardValidation: function(isValid, tabIndex) {
		},
		handleWizardErrorMessage: function(errorMsg) {
			this.errorMsg = errorMsg;
			if (this.errorMsg == null || this.errorMsg == "") {
				this.showWizardErrorModal = false;
			} else {
				if (
				!this.showUnsavedChangesModal &&
				!this.showPresetErrorModal &&
				!this.showProtectedBikeLaneModal &&
				!this.showAfterHoursModal &&
				!this.showTimeConflictModal &&
				!this.showNonRegionalStreetModal &&
				!this.showStartDateInPastModal &&
				!this.showLessThanTwoHourModal &&
				!this.showRequiredFieldModal &&
				!this.showErrorTwoHourModal &&
				!this.showErrorReversedDates &&
				!this.showErrorReversedTimes &&
				!this.showErrorTwoHourTooLongModal) {
					this.showWizardErrorModal = true;
			}
		}
	},
	validateSubmitterStepAsync: function() {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				let flag = true;
				flag = this.validateSubmitterStep();
				if (flag) {
					resolve(true);
				} else {
					if (this.hasBlocks) {
						reject('There are fields that require more information.  Please use the buttons below.');
					} else {
						reject('Make sure you have at least one street block selected on the map.');
					}
				}
			}, 100)
		})
	},
	validateSubmitterStep: function() {
			// force set the date
			if (this.laneClosureRequest) {
				this.onToDateTimeChanged(this.toTime.value);
				this.onFromDateTimeChanged(this.fromTime.value);
			}
			let flag = true;
			this.laneClosureRequest.isEmergency.validate();
			if (!this.laneClosureRequest.isEmergency.valid) flag = false;
			this.laneClosureRequest.natureOfWorkId.validate();
			if (!this.laneClosureRequest.natureOfWorkId.valid) flag = false;

			// validate ACA information
			this.acaChoices.resetStatus();
			this.laneClosureRequest.actAsAca.validate();
			if (!this.laneClosureRequest.actAsAca.valid) flag = false;
			if (""+this.laneClosureRequest.actAsAca.getRawValue() == "1"){
				if (""+this.laneClosureRequest.acaParkingRemoval.value == "1"
				|| ""+this.laneClosureRequest.acaTurnRestrictions.value == "1"
				|| ""+this.laneClosureRequest.acaFullDirectional.value == "1"
				|| ""+this.laneClosureRequest.acaDcz.value == "1"
				) {
					this.acaChoices.status = null;
			} else {
				this.acaChoices.status = false;
				flag = false;
			}
		}

		this.laneClosureRequest.isUnderTwoHours.validate();
		if (!this.laneClosureRequest.isUnderTwoHours.valid) flag = false;

		this.laneClosureRequest.fromDate.validate();
		if (!this.laneClosureRequest.fromDate.valid) flag = false;

		let fromd = Format.fromUtc(
				Format.mergeUtcDateTime(
						this.laneClosureRequest.fromDate.getRawValue(),
						this.laneClosureRequest.fromTime.value
				)
		);

		let tod = Format.fromUtc(
				Format.mergeUtcDateTime(
						this.laneClosureRequest.toDate.getRawValue(),
						this.laneClosureRequest.toTime.value
				)
		);




		if ( parseInt(""+fromd.format("YYYYMMDD")) > parseInt(""+tod.format("YYYYMMDD")) ) {
			this.showErrorReversedDates = true;
			flag = false;
		} else {
			if (this.laneClosureRequest.isUnderTwoHours.value == 1) {
				if (fromd.date() != tod.date() || fromd.month() != tod.month() || fromd.year() != tod.year()) {
					this.showErrorTwoHourModal = true;
					flag = false;
				} else {
					if (tod.diff(fromd, 'minutes') > 120) {
						this.showErrorTwoHourTooLongModal = true;
						flag = false;
					} else {
						if (parseInt(""+fromd.format("YYYYMMDDHHmm")) > parseInt(""+tod.format("YYYYMMDDHHmm"))) {
							this.showErrorReversedTimes = true;
							flag = false;
						}
					}
				}
			} else {
				if (parseInt(""+fromd.format("YYYYMMDD")) == parseInt(""+tod.format("YYYYMMDD"))) {
					if (parseInt(""+fromd.format("YYYYMMDDHHmm")) > parseInt(""+tod.format("YYYYMMDDHHmm"))) {
						this.showErrorReversedTimes = true;
						flag = false;
					}
				}
			}
		}


		// display the 3 business days alert
		if (this.laneClosureRequest.isEmergency.value != 1 ) {
				// let now = this.moment();
				// let from = this.moment(this.laneClosureRequest.fromDate.getRawValue());
				// let to = this.moment(this.laneClosureRequest.toDate.getRawValue());
				// // If submitting a new non-emergency request and the current time is after 15:00, suggest start date to be 4 business days in advance ON Next button click.
				// let today1500 = moment('15:00', 'HH:mm');


			// If submitting a new non-emergency request and the current time is after 15:00, suggest start date to be 4 business days in advance ON Next button click. 
				let now = this.moment.tz(Format.TIMEZONE);
				let from = Format.fromUtc(this.laneClosureRequest.fromDate.value);
				let to = Format.fromUtc(this.laneClosureRequest.toDate.value);

				let today1500 = now.clone().hour(15).minute(0).second(0).millisecond(0);


			let day = now.day();
			if (day > 0 && day < 6 && now.isSameOrAfter(today1500)) {

				// get minimum 4 business days in future.
				let extendedTime = Format.addWeekdays(null, 4);
				// let fromNum = parseInt(from.format("YYYYMMDD"));
				// let toNum = parseInt(to.format("YYYYMMDD"));

					// let duration = toNum - fromNum;
					// let extendedNum = parseInt(this.moment(extendedTime).format("YYYYMMDD"));
					// let diff = extendedNum - fromNum;


					let duration = to.clone().startOf('day')
							.diff(from.clone().startOf('day'), 'days');

					let diff = extendedTime.clone().startOf('day')
							.diff(from.clone().startOf('day'), 'days');


				if (diff > 0) {
					if (this.ignoreAfterHoursSubmission == false) {
						// check diff from selected date and today
						// if diff less than 4, update new values with 4th working day and show new values in popup
						this.showAfterHoursModal = true;

						this.newAHFromDate.value = Format.mergeUtcDateTime(
								extendedTime.clone().utc().format(),
								this.laneClosureRequest.fromTime.value
						);

						this.newAHFromTime.value = this.newAHFromDate.value;

						if (duration == 0) {
								this.newAHToDate.value = Format.mergeUtcDateTime(
										extendedTime.clone().utc().format(),
										this.laneClosureRequest.toTime.value
								);
						} else {
							let newDate = Format.addDays(this.laneClosureRequest.toDate.value, diff);
								this.newAHToDate.value = newDate.utc().format();
						}
							this.newAHToTime.value = this.newAHToDate.value;





					}
				}
			}

				now.hours(0);
				now.minutes(0);
				now.seconds(0);

				// get minimum 2 business days in future.
				let theTime = Format.addWeekdays(null, 2);
				theTime.hours(23);
				theTime.minutes(59);
				theTime.seconds(59);

				// Set the from time to the end of the day.
				from.hours(23);
				from.minutes(59);
				from.seconds(59);

					// var diff = theTime.diff(from, 'days');
					var diff = theTime.clone().startOf('day')
							.diff(from.clone().startOf('day'), 'days');

				// basically if the future date is
				if (diff <= 0) {
					// we're good, its beyond 2 business days.
				} else {
					if (!this.hasShownStartDateInPastModal && !this.showErrorTwoHourModal && !this.showErrorReversedDates && !this.showErrorReversedTimes && !this.showErrorTwoHourTooLongModal) {
						this.showStartDateInPastModal = true;
					}
				}
		}


		this.laneClosureRequest.affectedStreet.validate();
		if (!this.laneClosureRequest.affectedStreet.valid) {
			flag = false;
		} else {
			this.laneClosureRequest.affectedStreet.resetStatus();
		}

		this.laneClosureRequest.directionId.validate();
		if (!this.laneClosureRequest.directionId.valid) flag = false;

		this.laneClosureRequest.firstCrossStreet.validate();
		if (!this.laneClosureRequest.firstCrossStreet.valid) flag = false;

		this.laneClosureRequest.lastCrossStreet.validate();
		if (!this.laneClosureRequest.lastCrossStreet.valid) flag = false;
		this.laneClosureRequest.toDate.validate();
		if (!this.laneClosureRequest.toDate.valid) flag = false;

		this.laneClosureRequest.fromTime.validate();
		if (!this.laneClosureRequest.fromTime.valid) flag = false;

		this.laneClosureRequest.toTime.validate();
		if (!this.laneClosureRequest.toTime.valid) flag = false;

		this.validateHasBlocks.value = this.hasBlocks;
		this.validateHasBlocks.validate();
		if (!this.validateHasBlocks.valid) flag = false;

		this.validateConfirmedBlocks.validate();
		if (!this.validateConfirmedBlocks.valid) flag = false;


		this.selectRequester.validate();
		if (!this.selectRequester.valid) flag = false;


		this.selectClosureReporter.validate();
		if (!this.selectClosureReporter.valid) flag = false;

		this.selectRestrictionReporter.validate();
		if (!this.selectRestrictionReporter.valid) flag = false;

		this.hasErrorSubmitter = !flag;
		return flag;

	},


	validateClosuresStepAsync: function() {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				let flag = true;
				if (!this.validatePresetClosures()) {
					reject('You must add at least one closure or turn restriction.')
				} else {

					let x = 0;
					for (x = 0; x < this.laneClosureRequest.presetBlock.length; x++) {
						// validate that all blocks
						if (this.laneClosureRequest.presetBlock[x].lane.length > 0) {
							this.laneClosureRequest.lanesClosedSameTime.required = true;
							this.laneClosureRequest.lanesClosedSameTime.validate();
							if (!this.laneClosureRequest.lanesClosedSameTime.valid) flag = false;
						} else {
							this.laneClosureRequest.lanesClosedSameTime.required = false;
						}
					}
					if (!flag) {
						reject("Please indicate which VEHICLE traffic lanes PER DIRECTION you will be closing at the same time or 'no multiple lanes'");
						this.hasErrorClosures = !flag;
						return;
					}

					this.laneClosureRequest.tempTrafficControl.validate();
					if (!this.laneClosureRequest.tempTrafficControl.valid) flag = false;
					if (!flag) {
						reject("Please indicate if you want Traffic Services to complete the temporary traffic control for you.");
						this.hasErrorClosures = !flag;
						return;
					}

					flag = this.validateClosuresStep();
					if (flag) {
						let x = 0;
						let objForm = {
							lcrId: this.laneClosureRequest.id,
							isEmergency: this.laneClosureRequest.isEmergency.value,
							fromDate: this.laneClosureRequest.fromDate.getRawValue(),
							toDate: this.laneClosureRequest.toDate.getRawValue(),
							blockId: []
						}
						for (x = 0; x < this.laneClosureRequest.block.length; x++) {
							objForm.blockId.push(this.laneClosureRequest.block[x].blockId);
						}
							// we don't need to check for conflicts when it is a violation entry...
							resolve(true);
						} else {
							reject('You must choose to close or restrict one or more blocks.')

						}
					}
				}, 100)
		})
	},
	validateClosuresStep: function() {
		let flag = true;
		let x = 0;
			// we need at least one block...
			if (this.laneClosureRequest.block.length == 0) {
				flag = false;
			} else {
				flag = false;
				for (x = 0; x < this.laneClosureRequest.block.length; x++) {
					// validate that all blocks
					if (this.laneClosureRequest.block[x].lane.length > 0 ||
					this.laneClosureRequest.block[x].bicycle.length > 0 ||
					this.laneClosureRequest.block[x].sidewalk.length > 0 ||
					this.laneClosureRequest.block[x].restriction.length > 0
					) {
						flag = true;
				}
			}
		}
		this.laneClosureRequest.tempTrafficControl.validate();
		if (!this.laneClosureRequest.tempTrafficControl.valid) flag = false;

		this.hasErrorClosures = !flag;
		return flag;
	},



	validateContraventionStepAsync: function() {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				let flag = true;
				flag = this.validateContraventionStep();
				if (flag) {
					resolve(true);
				} else {
					reject('You must enter all of the information for a violation.')
				}
			}, 100)
		})
	},
	validateContraventionStep: function() {
		let flag = true;
		this.contravention.comments.required = true;
		this.contravention.comments.validate();
		if (!this.contravention.comments.valid) flag = false;


		return flag;
	},

	validatePresetClosures: function() {
		let flag = true;
		this.presetErrorLines = [];
			// we need at least one preset block closure...
			if (this.laneClosureRequest.presetBlock.length == 0) {
				flag = false;
			} else {
				let x = 0;
				let y = 0;
				let z = 0;
				let i = 0;
				var foundBlock = false;
				// make sure each preset lane closure has at least one block attached.
				for (x = 0; x < this.laneClosureRequest.presetBlock.length; x++) {
					// validate that all blocks
					if (this.laneClosureRequest.presetBlock[x].lane.length > 0 ) {
						for (y = 0; y < this.laneClosureRequest.presetBlock[x].lane.length; y++) {
							foundBlock = false;

							this.laneClosureRequest.presetBlock[x].lane[y].hasBlock = false;
							// make sure at least one block in each lane is picked to be closed.
							for (z = 0; z < this.laneClosureRequest.block.length; z++) {
								// validate that all blocks
								if (this.laneClosureRequest.block[z].lane.length > 0) {
									for (i = 0; i < this.laneClosureRequest.block[z].lane.length; i++) {
										if (this.laneClosureRequest.block[z].lane[i].laneId.value == this.laneClosureRequest.presetBlock[x].lane[y].laneId.value
										&& this.laneClosureRequest.block[z].lane[i].peakId.value == this.laneClosureRequest.presetBlock[x].lane[y].peakId.value
										) {
											this.laneClosureRequest.presetBlock[x].lane[y].hasBlock = true;
										foundBlock = true;
									}
								}
							}
						}
						if (!foundBlock) {
								// append the details of the ones that need blocks.
								var txt =  LaneClosureRequest.getLaneText(this.laneClosureRequest.presetBlock[x].lane[y].laneId.value);
								txt += "<br/>" + LaneClosureRequest.getLanePeakReasonText(this.laneClosureRequest.presetBlock[x].lane[y].peakId.value);
								this.presetErrorLines.push(txt);
							}
						}
					}

					if (this.laneClosureRequest.presetBlock[x].sidewalk.length > 0 ) {
						for (y = 0; y < this.laneClosureRequest.presetBlock[x].sidewalk.length; y++) {
							foundBlock = false;
							this.laneClosureRequest.presetBlock[x].sidewalk[y].hasBlock = false;
							// make sure at least one block in each lane is picked to be closed.
							for (z = 0; z < this.laneClosureRequest.block.length; z++) {
								// validate that all blocks
								if (this.laneClosureRequest.block[z].sidewalk.length > 0) {
									for (i = 0; i < this.laneClosureRequest.block[z].sidewalk.length; i++) {
										if (this.laneClosureRequest.block[z].sidewalk[i].sidewalkId.value == this.laneClosureRequest.presetBlock[x].sidewalk[y].sidewalkId.value) {
											this.laneClosureRequest.presetBlock[x].sidewalk[y].hasBlock = true;
											foundBlock = true;
										}
									}
								}
							}
							if (!foundBlock) {
								// append the details of the ones that need blocks.
								var txt =  LaneClosureRequest.getSidewalkText(this.laneClosureRequest.presetBlock[x].sidewalk[y].sidewalkId.value);
								this.presetErrorLines.push(txt);
							}
						}
					}

					if (this.laneClosureRequest.presetBlock[x].bicycle.length > 0 ) {
						for (y = 0; y < this.laneClosureRequest.presetBlock[x].bicycle.length; y++) {
							foundBlock = false;
							this.laneClosureRequest.presetBlock[x].bicycle[y].hasBlock = false;
							// make sure at least one block in each lane is picked to be closed.
							for (z = 0; z < this.laneClosureRequest.block.length; z++) {
								// validate that all blocks
								if (this.laneClosureRequest.block[z].bicycle.length > 0) {
									for (i = 0; i < this.laneClosureRequest.block[z].bicycle.length; i++) {
										if (this.laneClosureRequest.block[z].bicycle[i].bicycleLaneId.value == this.laneClosureRequest.presetBlock[x].bicycle[y].bicycleLaneId.value) {
											// console.log(this.laneClosureRequest.block[z].bicycle[i]);
											this.laneClosureRequest.presetBlock[x].bicycle[y].hasBlock = true;
											foundBlock = true;
										}
									}
								}
							}
							// console.log(this.laneClosureRequest.presetBlock[x].bicycle[y]);
							// console.log(this.laneClosureRequest.presetBlock[x].bicycle[y].hasBlock);
							if (!foundBlock) {
								// append the details of the ones that need blocks.
								var txt =  LaneClosureRequest.getBicycleLaneText(this.laneClosureRequest.presetBlock[x].bicycle[y].bicycleLaneId.value);
								this.presetErrorLines.push(txt);
							}
						}
					}


					if (this.laneClosureRequest.presetBlock[x].restriction.length > 0 ) {
						for (y = 0; y < this.laneClosureRequest.presetBlock[x].restriction.length; y++) {
							foundBlock = false;
							this.laneClosureRequest.presetBlock[x].restriction[y].hasBlock = false;
							// make sure at least one block in each lane is picked to be closed.
							for (z = 0; z < this.laneClosureRequest.block.length; z++) {
								// validate that all blocks
								if (this.laneClosureRequest.block[z].restriction.length > 0) {
									for (i = 0; i < this.laneClosureRequest.block[z].restriction.length; i++) {
										if (
										this.laneClosureRequest.block[z].restriction[i].restrictionTypeId.value == this.laneClosureRequest.presetBlock[x].restriction[y].restrictionTypeId.value
										&& this.laneClosureRequest.block[z].restriction[i].directionId.value == this.laneClosureRequest.presetBlock[x].restriction[y].directionId.value
										&& this.laneClosureRequest.block[z].restriction[i].peakId.value == this.laneClosureRequest.presetBlock[x].restriction[y].peakId.value
										) {
											this.laneClosureRequest.presetBlock[x].restriction[y].hasBlock = true;
											// console.log(this.laneClosureRequest.block[z].restriction[i]);
											foundBlock = true;
										}
									}
								}

								// if (typeof this.laneClosureRequest.presetBlock[x].restriction[y].turningStreetName["b"+ this.laneClosureRequest.block[z].blockId] != "undefined") {
								// 	for (y = 0; y < this.laneClosureRequest.presetBlock[x].restriction[y].turningStreetName["b"+ this.laneClosureRequest.block[z].blockId].length; y++) {
								// 			if (this.laneClosureRequest.presetBlock[x].restriction[y].turningStreetName["b"+ this.laneClosureRequest.block[z].blockId][y] != null) {

								// 			}
								// 	}
								// }

							}
							// console.log(this.laneClosureRequest.presetBlock[x].restriction[y]);
							// console.log(this.laneClosureRequest.presetBlock[x].restriction[y].hasBlock);
							if (!foundBlock) {
								// append the details of the ones that need blocks.
								var txt = "";
								txt += " " + LaneClosureRequest.getDirectionText(this.laneClosureRequest.presetBlock[x].restriction[y].directionId.value);
								txt += " "+ LaneClosureRequest.getRestrictionTypeText(this.laneClosureRequest.presetBlock[x].restriction[y].restrictionTypeId.value);
								txt += "<br/>"+ LaneClosureRequest.getRestrictionPeakIdText(this.laneClosureRequest.presetBlock[x].restriction[y].peakId.value);
								if (this.laneClosureRequest.presetBlock[x].restriction[y].peakReason.value !=  null) {
									txt += "<br/>"+this.laneClosureRequest.presetBlock[x].restriction[y].peakReason.value;
								}
								this.presetErrorLines.push(txt);
							}
						}
					}

					if (this.laneClosureRequest.presetBlock[x].lane.length > 0 ||
					this.laneClosureRequest.presetBlock[x].bicycle.length > 0 ||
					this.laneClosureRequest.presetBlock[x].sidewalk.length > 0 ||
					this.laneClosureRequest.presetBlock[x].restriction.length > 0
					) {
						// flag = true;
				}
			}

			if (this.presetErrorLines.length > 0) {
				flag = false;
			}
		}

		if (flag) {
			this.hasPresetBlockError = false;
		} else {
			this.hasPresetBlockError = true;
		}
		this.hasErrorClosures = !flag;
		return flag;
	},



	validateDCZStepAsync: function() {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				let flag = true;
				flag = this.validateDCZStep();
				if (flag) {
					resolve(true);
				} else {
					reject('There are fields that require more information.  Please use the buttons below.')
				}
			}, 100)
		})
	},
	validateDCZStep: function() {
		let flag = true;

			// let flagCounter = 1;

			this.laneClosureRequest.workZoneKph.validate();
			if (!this.laneClosureRequest.workZoneKph.valid) flag = false;

			this.laneClosureRequest.workZoneReduceKph.validate();
			if (!this.laneClosureRequest.workZoneReduceKph.valid) flag = false;

			this.laneClosureRequest.transitAffected.validate();
			if (!this.laneClosureRequest.transitAffected.valid) flag = false;

			this.laneClosureRequest.transit.validate();
			if (!this.laneClosureRequest.transit.valid) flag = false;

			this.laneClosureRequest.transitStopNumbers.validate();
			if (!this.laneClosureRequest.transitStopNumbers.valid) flag = false;

			this.laneClosureRequest.transitOther.validate();
			if (!this.laneClosureRequest.transitOther.valid) flag = false;

			// Parking Validation
			this.laneClosureRequest.paidParkingAffected.validate();
			if (!this.laneClosureRequest.paidParkingAffected.valid) flag = false;

			this.laneClosureRequest.parkingRemovalId.validate();
			if (!this.laneClosureRequest.parkingRemovalId.valid) flag = false;

			this.hasParkingRemovalError = false;
			if (this.laneClosureRequest.parkingRemovalId.value != 2) {
				if (this.laneClosureRequest.parkingRemoval.length == 0) {
					this.hasParkingRemovalError = true;
					flag = false;
				}
			}
			/*

			if (this.laneClosureRequest.parkingRemovalId.value == 1) {
				if (this.laneClosureRequest.parkingLane.value.length == 0) {
					this.laneClosureRequest.parkingLane.status = false;
					flag = false;
				}
				this.laneClosureRequest.parkingRemovalMetres.required = true;
				this.laneClosureRequest.parkingRemovalMetres.validate();
				if (!this.laneClosureRequest.parkingRemovalMetres.valid) flag = false;

				this.laneClosureRequest.parkingStartAddress.required = true;
				this.laneClosureRequest.parkingStartAddress.validate();
				if (!this.laneClosureRequest.parkingStartAddress.valid) flag = false;

				this.laneClosureRequest.parkingEndAddress.required = true;
				this.laneClosureRequest.parkingEndAddress.validate();
				if (!this.laneClosureRequest.parkingEndAddress.valid) flag = false;

			} else {
				this.laneClosureRequest.parkingRemovalMetres.required = false;
				this.laneClosureRequest.parkingStartAddress.required = false;
				this.laneClosureRequest.parkingEndAddress.required = false;

				this.laneClosureRequest.parkingRemovalMetres.value = null;
				this.laneClosureRequest.parkingStartAddress.value = null;
				this.laneClosureRequest.parkingEndAddress.value = null;

			}
			*/

			// Work Done For
			this.workDoneForOrgType.validate();
			if (!this.workDoneForOrgType.valid) flag = false;

			this.laneClosureRequest.workDoneForId.validate();
			if (!this.laneClosureRequest.workDoneForId.valid) flag = false;


			if (this.laneClosureRequest.workDoneForId.isCityOfWinnipeg()) { // City of Winnipeg
				this.laneClosureRequest.projectBidNumber.required = true;
				this.laneClosureRequest.projectBidNumber.validate();
				if (!this.laneClosureRequest.projectBidNumber.valid) flag = false;
			} else {
				this.laneClosureRequest.projectBidNumber.required = false;
			}

			if (this.laneClosureRequest.workDoneForId.isCoWFSEO()) { // WF
				this.laneClosureRequest.wfseoControlCode.required = true;
				this.laneClosureRequest.wfseoControlCode.validate();
				if (!this.laneClosureRequest.wfseoControlCode.valid) flag = false;

				this.laneClosureRequest.wfseoPermitRequestInfo.required = true;
				this.laneClosureRequest.wfseoPermitRequestInfo.validate();
				if (!this.laneClosureRequest.wfseoPermitRequestInfo.valid) flag = false;

			} else {
				this.laneClosureRequest.wfseoControlCode.required = false;
				this.laneClosureRequest.wfseoPermitRequestInfo.required = false;
			}


			// DCZ required
			if (this.laneClosureRequest.dczRequired.value == 1 ) { // && this.laneClosureRequest.workZoneReduceKph.value == 60

				// check the fields.
				this.laneClosureRequest.dczLimits.required = true;
				this.laneClosureRequest.dczHazards.required = true;
				this.laneClosureRequest.dczTemporaryTcRemoved.required = true;
				this.laneClosureRequest.dczHoursOfWork.required = true;

				this.laneClosureRequest.dczLimits.validate();
				if (!this.laneClosureRequest.dczLimits.valid) flag = false;

				this.laneClosureRequest.dczHazards.validate();
				if (!this.laneClosureRequest.dczHazards.valid) flag = false;

				this.laneClosureRequest.dczTemporaryTcRemoved.validate();
				if (!this.laneClosureRequest.dczTemporaryTcRemoved.valid) flag = false;

				this.laneClosureRequest.dczHoursOfWork.validate();
				if (!this.laneClosureRequest.dczHoursOfWork.valid) flag = false;
			} else {
				this.laneClosureRequest.dczLimits.required = false;
				this.laneClosureRequest.dczHazards.required = false;
				this.laneClosureRequest.dczTemporaryTcRemoved.required = false;
				this.laneClosureRequest.dczHoursOfWork.required = false;
			}

			if (flag) {
				this.hasErrorDCZ = false;
			} else {
				this.hasErrorDCZ = true;
			}

			return flag;
		},


		validatePermitsStepAsync: function() {
			return new Promise((resolve, reject) => {
				setTimeout(() => {
					let flag = true;
					flag = this.validatePermitsStep();
					if (flag) {
						resolve(true);
					} else {
						reject('There are fields that require more information.  Please use the buttons below.')
					}
				}, 100)
			})
		},

		validatePermitsStep: function() {
			let flag = true;
			if (this.laneClosureRequest.permitRequired.value == 1) {

				// this.laneClosureRequest.permitNearestStreetNumber.required = true;
				this.laneClosureRequest.permitRoadwayMetres.required = true;
				this.laneClosureRequest.permitRoadwayFrom.required = true;
				this.laneClosureRequest.permitRoadwayTo.required = true;
				this.laneClosureRequest.permitSidewalkMetres.required = true;
				this.laneClosureRequest.permitSidewalkFrom.required = true;
				this.laneClosureRequest.permitSidewalkTo.required = true;
				this.laneClosureRequest.permitLiabilityInsurance.required = true;
				this.laneClosureRequest.crossingPermitRequired.required = true;
				this.laneClosureRequest.permitRequests.required = false;

				this.laneClosureRequest.permitLiabilityInsurance.validate();
				if (!this.laneClosureRequest.permitLiabilityInsurance.valid) flag = false;

				this.laneClosureRequest.permitNearestStreetNumber.validate();
				if (!this.laneClosureRequest.permitNearestStreetNumber.valid) flag = false;

				this.laneClosureRequest.permitRoadwayMetres.validate();
				if (!this.laneClosureRequest.permitRoadwayMetres.valid) flag = false;

				this.laneClosureRequest.permitRoadwayFrom.validate();
				if (!this.laneClosureRequest.permitRoadwayFrom.valid) flag = false;

				this.laneClosureRequest.permitRoadwayTo.validate();
				if (!this.laneClosureRequest.permitRoadwayTo.valid) flag = false;

				this.laneClosureRequest.permitSidewalkMetres.validate();
				if (!this.laneClosureRequest.permitSidewalkMetres.valid) flag = false;

				this.laneClosureRequest.permitSidewalkFrom.validate();
				if (!this.laneClosureRequest.permitSidewalkFrom.valid) flag = false;

				this.laneClosureRequest.permitSidewalkTo.validate();
				if (!this.laneClosureRequest.permitSidewalkTo.valid) flag = false;


				this.laneClosureRequest.permitRequests.validate();
				if (!this.laneClosureRequest.permitRequests.valid) flag = false;

				if (this.laneClosureRequest.permitRoadwayFrom.value == null || this.laneClosureRequest.permitRoadwayFrom.value == null) {
					this.isPermitRoadwayValid = false;
				} else {
					this.isPermitRoadwayValid = true;
				}


				this.laneClosureRequest.crossingPermitRequired.required = true;
				if (this.laneClosureRequest.crossingPermitRequired.value != 1 && this.laneClosureRequest.crossingPermitRequired.value != 0) {
					this.laneClosureRequest.crossingPermitRequired.status = false;
					this.laneClosureRequest.crossingPermitRequired.invalidMessage = "Please choose if crossing permit is required.";
					flag = false;
				} else {
					this.laneClosureRequest.crossingPermitRequired.status = null;
					this.laneClosureRequest.crossingPermitRequired.invalidMessage = null;
				}


				if (this.laneClosureRequest.crossingPermitRequired.value == 1) {
					this.laneClosureRequest.crossingPermitLocation.required = true;
					this.laneClosureRequest.crossingPermitEquipment.required = true;

					this.laneClosureRequest.crossingPermitLocation.validate();
					if (!this.laneClosureRequest.crossingPermitLocation.valid) flag = false;

					this.laneClosureRequest.crossingPermitEquipment.validate();
					if (!this.laneClosureRequest.crossingPermitEquipment.valid) flag = false;
				} else {
					this.laneClosureRequest.crossingPermitLocation.required = false;
					this.laneClosureRequest.crossingPermitEquipment.required = false;
				}

			} else {
				this.laneClosureRequest.permitNearestStreetNumber.required = false;
				this.laneClosureRequest.permitRoadwayMetres.required = false;
				this.laneClosureRequest.permitRoadwayFrom.required = false;
				this.laneClosureRequest.permitRoadwayTo.required = false;
				this.laneClosureRequest.permitSidewalkMetres.required = false;
				this.laneClosureRequest.permitSidewalkFrom.required = false;
				this.laneClosureRequest.permitSidewalkTo.required = false;
				this.laneClosureRequest.permitLiabilityInsurance.required = false;
				this.laneClosureRequest.crossingPermitRequired.required = false;
				this.laneClosureRequest.permitRequests.required = false;
			}

			this.hasErrorPermit = !flag;
			return flag;
		},
		onWizardStep: function(prevIndex, nextIndex) {
			if (this.$refs.blockDetails) {
				this.$refs.blockDetails.onCancelBlock();
			}


			if (nextIndex == -1) {
				nextIndex = 0;
			}
			let that = this;
			var maindiv = document.getElementById('wizardTabs');
			if (maindiv) {
				var div = maindiv.getElementsByTagName('div')[nextIndex];//third div
				if (div) {
					if (document.body.classList.contains('is-android')) {
						that.scrollTopOfWizard();
						setTimeout(function() {
							div.scrollIntoView({block: "center", inline: "center",behavior: 'smooth'});
						}, 250);
					} else {
						div.scrollIntoView({block: "center", inline: "center",behavior: 'smooth'});
						setTimeout(function() {
							that.scrollTopOfWizard();
						}, 250);
					}
				}
			}
		},


		scrollTopOfWizard() {
			var element = document.getElementById("main");
			if (element) {
				// var top = element.top;
				// element.scrollTo(0, top);  // IE 11
				element.scrollTop = 0;
			}
		},

		scrollBottomOfWizard() {
			var element = document.getElementById("main");
			if (element) {
				// var top = element.top;
				// element.scrollTo(0, top);  // IE 11
				element.scrollTop = element.scrollHeight;
			}
		},


		getLastCrossStreets() {
			// Get the list of last cross streets based on affected and first cross street names.
			if (this.laneClosureRequest.affectedStreet.value == null || this.laneClosureRequest.firstCrossStreet.value == null) {
				return;
			}
			Vue.prototype.$http.post(this.$store.state.apiUrl + '/block/last-cross-street', { affectedStreetName: this.laneClosureRequest.affectedStreet.value, firstStreetName: this.laneClosureRequest.firstCrossStreet.value })
			.then(resp => {
				if (resp.data.length == 0) {
					this.lastCrossStreetOptions = this.noLastCrossStreetOptions;
					this.laneClosureRequest.lastCrossStreet.value = null;
				} else {
					this.lastCrossStreetOptions = resp.data;
				}

				this.allStreetOptions = [];
				this.allStreetOptions.push({ value: this.laneClosureRequest.firstCrossStreet.value, text: this.laneClosureRequest.firstCrossStreet.value });

				for (let i = 0; i < this.lastCrossStreetOptions.length; i++) {
					let foundIt = false;
					for (var ii = 0; ii < this.allStreetOptions.length; ii++) {
						if (this.lastCrossStreetOptions[i].value === this.allStreetOptions[ii].value) {
							foundIt = true;
						}
					}
					if (!foundIt) {
						this.allStreetOptions.push({ value: this.lastCrossStreetOptions[i].value, text: this.lastCrossStreetOptions[i].text });
					}
				}
					// now add the affectedStreet to the combined list
					let foundIt = false;
					for (let ii = 0; ii < this.allStreetOptions.length; ii++) {
						if (this.allStreetOptions[ii].value === this.laneClosureRequest.affectedStreet.value) {
							foundIt = true;
						}
					}
					if (!foundIt) {
						this.allStreetOptions.push({ value: this.laneClosureRequest.affectedStreet.value, text: this.laneClosureRequest.affectedStreet.value });
					}
					this.allStreetOptions.sort(Format.dynamicSort("value"));
				})
			.catch(error => {})


		},
		onBackToDetails() {
			this.$router.go(-1);
		},
		onBackToList() {
			this.$router.push({ name: "LaneClosureList" });
		},
		onReportLaneClosure() {
			if (this.laneClosureRequest.id) {
				this.$router.push({ name: "ReportClosure", params: { id: this.laneClosureRequest.id } });
			}
		},

		onReportRestriction() {
			if (this.laneClosureRequest.id) {
				this.$router.push({ name: "ReportRestriction", params: { id: this.laneClosureRequest.id } });
			}
		},
		onProtectedBikeLane() {
			this.showProtectedBikeLaneModal = true;
		},

		applyPresetToBlocks() {
			// for now, overwrite all lane closure settings.
			this.onPresetApplyChanges();
		},
		onPresetBlockUpdated() {},

		applyPresetsToBlockIndex(x) {
			var xx = 0;
			var y = 0;
			var foundUnique = -1;
			// var sameTime = this.laneClosureRequest.presetBlock[0].lanesClosedSameTime.getRawValue();
			if (this.laneClosureRequest.block[x] == null) {
				return false;
			}
			this.laneClosureRequest.block[x].lanesClosedSameTime.value = this.laneClosureRequest.presetBlock[0].lanesClosedSameTime.getRawValue();
			this.laneClosureRequest.block[x].trafficSignalsAltered.value = 0;
			this.laneClosureRequest.block[x].bicycle = [];
			for (xx = 0; xx < this.laneClosureRequest.presetBlock[0].bicycle.length; xx++) {
				this.laneClosureRequest.block[x].bicycle.push(new LaneClosureRequestBlockBicycle({ bicycleLaneId: this.laneClosureRequest.presetBlock[0].bicycle[xx].bicycleLaneId.value }));
			}
			this.laneClosureRequest.block[x].sidewalk = [];
			for (xx = 0; xx < this.laneClosureRequest.presetBlock[0].sidewalk.length; xx++) {
				this.laneClosureRequest.block[x].sidewalk.push(new LaneClosureRequestBlockSidewalk({ sidewalkId: this.laneClosureRequest.presetBlock[0].sidewalk[xx].sidewalkId.value }));
			}
			for (xx = 0; xx < this.laneClosureRequest.block.length; xx++) {
				this.laneClosureRequest.block[x].lane.splice(xx, 1);
			}
			var lanes = [];
			for (xx = 0; xx < this.laneClosureRequest.presetBlock[0].lane.length; xx++) {
				// this.laneClosureRequest.block[x].lane.push(new LaneClosureRequestBlockLane({laneId:this.laneClosureRequest.presetBlock[0].lane[xx].laneId.value,peakId:this.laneClosureRequest.presetBlock[0].lane[xx].peakId.value,peakReason:this.laneClosureRequest.presetBlock[0].lane[xx].peakReason.value}));
				if (LaneClosureRequest.hasTrafficLaneInDirection(this.laneClosureRequest.presetBlock[0].lane[xx].laneId.value, this.laneClosureRequest.block[x].directionId)) {
					lanes.push(new LaneClosureRequestBlockLane({ laneId: this.laneClosureRequest.presetBlock[0].lane[xx].laneId.value, peakId: this.laneClosureRequest.presetBlock[0].lane[xx].peakId.value, peakReason: this.laneClosureRequest.presetBlock[0].lane[xx].peakReason.value }));
				}
			}
			this.laneClosureRequest.block[x] = { ...this.laneClosureRequest.block[x], lane: lanes }
			// .push(new LaneClosureRequestBlockLane({laneId:this.laneClosureRequest.presetBlock[0].lane[xx].laneId.value,peakId:this.laneClosureRequest.presetBlock[0].lane[xx].peakId.value,peakReason:this.laneClosureRequest.presetBlock[0].lane[xx].peakReason.value}));

			this.laneClosureRequest.block[x].restriction = [];
			for (xx = 0; xx < this.laneClosureRequest.presetBlock[0].restriction.length; xx++) {
				let resObj = {
					directionId: this.laneClosureRequest.presetBlock[0].restriction[xx].directionId.value,
					restrictionTypeId: this.laneClosureRequest.presetBlock[0].restriction[xx].restrictionTypeId.value,
					affectedStreet: this.laneClosureRequest.block[x].streetName.value,
					crossStreet: "",
					peakId: this.laneClosureRequest.presetBlock[0].restriction[xx].peakId.value,
					peakReason: this.laneClosureRequest.presetBlock[0].restriction[xx].peakReason.value
				};
				// No Left Turn
				if (resObj.restrictionTypeId == 1) {
					// Northbound
					if (resObj.directionId == 1 || resObj.directionId == 6) {
						resObj.crossStreet = this.laneClosureRequest.block[x].northboundLeft;
					}
					// Southbound
					if (resObj.directionId == 2 || resObj.directionId == 6) {
						resObj.crossStreet = this.laneClosureRequest.block[x].southboundLeft;
					}
					// Eastbound
					if (resObj.directionId == 3 || resObj.directionId == 5) {
						resObj.crossStreet = this.laneClosureRequest.block[x].eastboundLeft;
					}
					// Westbound
					if (resObj.directionId == 4 || resObj.directionId == 5) {
						resObj.crossStreet = this.laneClosureRequest.block[x].westboundLeft;
					}
				}
				// No Right Turn
				if (resObj.restrictionTypeId == 2) {
					// Northbound
					if (resObj.directionId == 1 || resObj.directionId == 6) {
						resObj.crossStreet = this.laneClosureRequest.block[x].northboundRight;
					}
					// Southbound
					if (resObj.directionId == 2 || resObj.directionId == 6) {
						resObj.crossStreet = this.laneClosureRequest.block[x].southboundRight;
					}
					// Eastbound
					if (resObj.directionId == 3 || resObj.directionId == 5) {
						resObj.crossStreet = this.laneClosureRequest.block[x].eastboundRight;
					}
					// Westbound
					if (resObj.directionId == 4 || resObj.directionId == 5) {
						resObj.crossStreet = this.laneClosureRequest.block[x].westboundRight;
					}
				}
				// No Through
				if (resObj.restrictionTypeId == 3) {
					// Northbound
					if (resObj.directionId == 1 || resObj.directionId == 6) {
						resObj.crossStreet = this.laneClosureRequest.block[x].northboundThrough;
					}
					// Southbound
					if (resObj.directionId == 2 || resObj.directionId == 6) {
						resObj.crossStreet = this.laneClosureRequest.block[x].southboundThrough;
					}
					// Eastbound
					if (resObj.directionId == 3 || resObj.directionId == 5) {
						resObj.crossStreet = this.laneClosureRequest.block[x].eastboundThrough;
					}
					// Westbound
					if (resObj.directionId == 4 || resObj.directionId == 5) {
						resObj.crossStreet = this.laneClosureRequest.block[x].westboundThrough;
					}
				}
				if (resObj.crossStreet != "" && resObj.crossStreet != null) {
					this.laneClosureRequest.block[x].restriction.push(new LaneClosureRequestBlockRestriction(
					resObj
					));
				}

				foundUnique = xx;
				// push this block's chosen street names into the preset block...
				if (typeof this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId] == "undefined") {
					this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId] = [];
				}
				if (this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(resObj.crossStreet) == -1) {
					this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(resObj.crossStreet);
				}
				for (y = 0; y < this.laneClosureRequest.block[x].turningStreetName.length; y++) {
					if (this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(this.laneClosureRequest.block[x].turningStreetName[y]) == -1) {
						this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(this.laneClosureRequest.block[x].turningStreetName[y]);
					}
				}
				// add the block turning entries too...
				if (this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(this.laneClosureRequest.block[x].northboundLeft) == -1) {
					this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(this.laneClosureRequest.block[x].northboundLeft);
				}
				if (this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(this.laneClosureRequest.block[x].northboundRight) == -1) {
					this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(this.laneClosureRequest.block[x].northboundRight);
				}
				if (this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(this.laneClosureRequest.block[x].southboundLeft) == -1) {
					this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(this.laneClosureRequest.block[x].southboundLeft);
				}
				if (this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(this.laneClosureRequest.block[x].southboundRight) == -1) {
					this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(this.laneClosureRequest.block[x].southboundRight);
				}
				if (this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(this.laneClosureRequest.block[x].eastboundLeft) == -1) {
					this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(this.laneClosureRequest.block[x].eastboundLeft);
				}
				if (this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(this.laneClosureRequest.block[x].eastboundRight) == -1) {
					this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(this.laneClosureRequest.block[x].eastboundRight);
				}
				if (this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(this.laneClosureRequest.block[x].westboundLeft) == -1) {
					this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(this.laneClosureRequest.block[x].westboundLeft);
				}
				if (this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(this.laneClosureRequest.block[x].westboundRight) == -1) {
					this.laneClosureRequest.presetBlock[0].restriction[foundUnique].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(this.laneClosureRequest.block[x].westboundRight);
				}

			}
		},
		onPresetApplyChanges() {
			// re-assign all of the closures and restrictions to the blocks already chosen.
			// TODO: determine what has changed and apply those changes to all of the blocks..
			// currently, just overwrit everything at the block level.
			let x = 0;
			let mustChange = false;
			// let checkLaneClosedSameTime = false;
			// if (this.laneClosureRequest.presetBlockBackup.lanesClosedSameTime != this.laneClosureRequest.presetBlock[0].lanesClosedSameTime.getRawValue()) {
			// 	// checkLaneClosedSameTime = true;
			// 	mustChange = true;
			// }
			mustChange = true;

			// validate the presets...
			// for (x = 0; x < this.laneClosureRequest.presetBlock[0].lane.length;x++) {
			// 	this.laneClosureRequest.presetBlock[0].lane[x].validate();
			// }
			// for (x = 0; x < this.laneClosureRequest.presetBlock[0].sidewalk.length;x++) {
			// 	this.laneClosureRequest.presetBlock[0].sidewalk[x].sidewalkId.validate();
			// }
			// for (x = 0; x < this.laneClosureRequest.presetBlock[0].bicycle.length;x++) {
			// 	this.laneClosureRequest.presetBlock[0].bicycle[x].bicycleLaneId.validate();
			// }

			var isValidPreset = this.laneClosureRequest.presetBlock[0].validate();
			if (!isValidPreset) {
				mustChange = false;
				this.showPresetErrorModal = true;
			}

			if (mustChange) {
				for (x = 0; x < this.laneClosureRequest.block.length; x++) {
					this.applyPresetsToBlockIndex(x);
				}

				this.forceRerender();
			}
			// return !IsEqual(originalLaneClosureData.getRawValue(), this.getRawValue());
		},

		onPresetAddClosure: function() {
			this.forceRerender();
		},
		onPresetRemoveLane: function(data) {
			this.removeData = data;
			this.showRemovePresetLaneModal = true;
		},
		onConfirmPresetRemoveLane: function() {
			var data = this.removeData;
			if (this.removeData == null) {
				return;
			}
			// first the blocks
			for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				for (var xx = 0; xx < this.laneClosureRequest.block[x].lane.length; xx++) {
					if (this.laneClosureRequest.block[x].lane[xx].laneId.value == this.laneClosureRequest.presetBlock[0].lane[data.index].laneId.value &&
					this.laneClosureRequest.block[x].lane[xx].peakId.value == this.laneClosureRequest.presetBlock[0].lane[data.index].peakId.value
					) {
						this.laneClosureRequest.block[x].lane.splice(xx, 1);
				}
			}
		}

			// then the preset lane...
			this.laneClosureRequest.presetBlock[0].lane.splice(data.index, 1);
			this.removeData = null;
			this.updateTrafficEffect();
			this.forceRerender();
		},


		onPresetAddSidewalk: function() {
			this.forceRerender();
		},
		onPresetRemoveSidewalk: function(data) {
			this.removeData = data;
			this.showRemovePresetSidewalkModal = true;
		},
		onConfirmPresetRemoveSidewalk: function() {
			var data = this.removeData;
			// first the blocks
			for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				for (var xx = 0; xx < this.laneClosureRequest.block[x].sidewalk.length; xx++) {
					if (this.laneClosureRequest.block[x].sidewalk[xx].sidewalkId.value == this.laneClosureRequest.presetBlock[0].sidewalk[data.index].sidewalkId.value) {
						this.laneClosureRequest.block[x].sidewalk.splice(xx, 1);
					}
				}
			}
			// then the preset...
			this.laneClosureRequest.presetBlock[0].sidewalk.splice(data.index, 1);
			this.removeData = null;
			this.updateTrafficEffect();
			this.forceRerender();
		},
		onPresetAddBicycle: function() {
			this.forceRerender();
		},
		onPresetRemoveBicycle: function(data) {
			this.removeData = data;
			this.showRemovePresetBicycleModal = true;
		},
		onConfirmPresetRemoveBicycle: function() {
			var data = this.removeData;

			// first the blocks
			for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				for (var xx = 0; xx < this.laneClosureRequest.block[x].bicycle.length; xx++) {
					if (this.laneClosureRequest.block[x].bicycle[xx].bicycleLaneId.value == this.laneClosureRequest.presetBlock[0].bicycle[data.index].bicycleLaneId.value) {
						this.laneClosureRequest.block[x].bicycle.splice(xx, 1);
					}
				}
			}

			// then the preset...
			this.laneClosureRequest.presetBlock[0].bicycle.splice(data.index, 1);
			this.removeData = null;
			this.updateTrafficEffect();
			this.forceRerender();
		},
		onPresetAddRestriction: function() {
			this.forceRerender();
		},
		onPresetRemoveRestriction: function(data) {
			this.removeData = data;
			this.showRemovePresetRestrictionModal = true;
		},
		onConfirmPresetRemoveRestriction: function() {
			var data = this.removeData;

			// first the blocks
			for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				for (var xx = 0; xx < this.laneClosureRequest.block[x].restriction.length; xx++) {
					if (
					this.laneClosureRequest.block[x].restriction[xx].restrictionTypeId.value == this.laneClosureRequest.presetBlock[0].restriction[data.index].restrictionTypeId.value &&
					this.laneClosureRequest.block[x].restriction[xx].directionId.value == this.laneClosureRequest.presetBlock[0].restriction[data.index].directionId.value &&
					this.laneClosureRequest.block[x].restriction[xx].peakId.value == this.laneClosureRequest.presetBlock[0].restriction[data.index].peakId.value
					) {
						this.laneClosureRequest.block[x].restriction.splice(xx, 1);
				}
			}
		}
			// then the preset...
			this.laneClosureRequest.presetBlock[0].restriction.splice(data.index, 1);
			this.removeData = null;
			this.updateTrafficEffect();
			this.forceRerender();
		},

		onPresetAllRestrictionsInEffect:function(data) {
			// first the blocks
			// var start = 0;
			var uindex = data.uindex;
			var foundRestriction = false;
			for (var s in this.laneClosureRequest.presetBlock[0].restriction[uindex].turningStreetName) {
				if (typeof this.laneClosureRequest.presetBlock[0].restriction[uindex].turningStreetName[s] == "object") {
					for (var x = 0; x < this.laneClosureRequest.presetBlock[0].restriction[uindex].turningStreetName[s].length; x++) {
						// match the turning street block id with each of the blocks.
						for (var xx = 0; xx < this.laneClosureRequest.block.length; xx++) {
							// for each block, see if this restriction is defined already for this street name.
							if ("b"+this.laneClosureRequest.block[xx].blockId == s) {
								foundRestriction = false;
								for (var zz = 0; zz < this.laneClosureRequest.block[xx].restriction.length; zz++) {
									if (
									this.laneClosureRequest.block[xx].restriction[zz].restrictionTypeId.value == data.restrictionTypeId &&
									this.laneClosureRequest.block[xx].restriction[zz].directionId.value == data.directionId &&
									this.laneClosureRequest.block[xx].restriction[zz].peakId.value == data.peakId &&
									this.laneClosureRequest.block[xx].restriction[zz].crossStreet.value == this.laneClosureRequest.presetBlock[0].restriction[uindex].turningStreetName[s][x]
									) {
										// found it
									foundRestriction = true;
									// console.log("found restriction street:" + this.laneClosureRequest.block[xx].restriction[zz].crossStreet.value);

										// xx = 0;
										// x = 0;
									}
								}

								if (!foundRestriction) {
									// add it in...
									let resObj = {
										directionId: data.directionId,
										restrictionTypeId: data.restrictionTypeId,
										affectedStreet: this.laneClosureRequest.block[xx].streetName.value,
										crossStreet: this.laneClosureRequest.presetBlock[0].restriction[uindex].turningStreetName[s][x],
										peakId: data.peakId,
										peakReason: this.laneClosureRequest.presetBlock[0].restriction[uindex].peakReason.value
									};
									// console.log(resObj);
									this.laneClosureRequest.block[xx].restriction.push(new LaneClosureRequestBlockRestriction(
									resObj
									));
								}

								// now remove the restriction from any other matching restriction type/direction.
								for (var zz = 0; zz < this.laneClosureRequest.block[xx].restriction.length; zz++) {
									if (
									this.laneClosureRequest.block[xx].restriction[zz].restrictionTypeId.value == data.restrictionTypeId &&
									this.laneClosureRequest.block[xx].restriction[zz].directionId.value == data.directionId &&
									this.laneClosureRequest.block[xx].restriction[zz].crossStreet.value == this.laneClosureRequest.presetBlock[0].restriction[uindex].turningStreetName[s][x]
									) {
										if (this.laneClosureRequest.block[xx].restriction[zz].peakId.value != data.peakId) {
											this.laneClosureRequest.block[xx].restriction.splice(zz, 1);
											zz = 0;
										}
									}
								}

							}
						}
					}
				}
				// console.log(s);
			}
			this.forceRerender();
		},
		onPresetAllRestrictionsRemoved:function(data) {
			// first the blocks
			// var start = 0;
			for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				for (var xx = 0; xx < this.laneClosureRequest.block[x].restriction.length; xx++) {
					if (
					this.laneClosureRequest.block[x].restriction[xx].restrictionTypeId.value == data.restrictionTypeId &&
					this.laneClosureRequest.block[x].restriction[xx].directionId.value == data.directionId &&
					this.laneClosureRequest.block[x].restriction[xx].peakId.value == data.peakId
					) {
						this.laneClosureRequest.block[x].restriction.splice(xx, 1);
					xx = 0;
					x = 0;
				}
			}
		}
		this.forceRerender();
	},

	onAddLane: function(index) {
		if (this.laneClosureRequest.block[this.editingBlockIndex].lane.length == 0) {
			if (this.laneClosureRequest.presetBlock) {
					// push in the defaults from the preset.
					if (this.laneClosureRequest.presetBlock[0].lane.length > 0) {
						let x = 0;
						for (x = 0; x < this.laneClosureRequest.presetBlock[0].lane.length; x++) {
							this.laneClosureRequest.block[this.editingBlockIndex].lane.push(new LaneClosureRequestBlockLane(this.laneClosureRequest.presetBlock[0].lane[x].getRawValue()));
						}
					}
				} else {
					this.laneClosureRequest.block[this.editingBlockIndex].lane.push(new LaneClosureRequestBlockLane);
				}
			} else {
				this.laneClosureRequest.block[this.editingBlockIndex].lane.push(new LaneClosureRequestBlockLane);
			}
			this.expandLane = true;
			this.forceRerender();
		},
		onRemoveLane(index) {
			this.laneClosureRequest.block[this.editingBlockIndex].lane.splice(index, 1);
			this.expandLane = true;
			this.forceRerender();
		},

		onShowAddLaneModal() {
			// TODO: automatically populate the likely lane id based on what the direction is.


			// re-open for peak-periods.
			this.addLane.peakId.value = 1;

			// westbound median
			if (this.laneClosureRequest.directionId.value == 4 || this.laneClosureRequest.directionId.value == 5) {
				this.addLane.laneId.value = 6;
			}

			// eastbound median.
			if (this.laneClosureRequest.directionId.value == 3 || this.laneClosureRequest.directionId.value == 5) {
				this.addLane.laneId.value = 3;
			}

			// southbound median.
			if (this.laneClosureRequest.directionId.value == 2 || this.laneClosureRequest.directionId.value == 6) {
				this.addLane.laneId.value = 12;
			}

			//  northbound median.
			if (this.laneClosureRequest.directionId.value == 1 || this.laneClosureRequest.directionId.value == 6) {
				this.addLane.laneId.value = 9;
			}

			this.showAddLaneModal = true;
		},

		onConfirmAddLane() {
			// add to the preset blocks...
			var laneIndex = null;
			for (var x = 0; x < this.laneClosureRequest.presetBlock.length; x++) {
				laneIndex = null;
				for (var xx = 0; xx < this.laneClosureRequest.presetBlock[x].lane.length; xx++) {
					if (
					this.laneClosureRequest.presetBlock[x].lane[xx].laneId.value == this.addLane.laneId.value &&
					this.laneClosureRequest.presetBlock[x].lane[xx].peakId.value == this.addLane.peakId.value
					) {
						laneIndex = xx;
					this.laneClosureRequest.presetBlock[x].lane[xx].peakReason.value = this.addLane.peakReason.value;
				}
			}
			if (laneIndex == null) {
				this.laneClosureRequest.presetBlock[x].lane.push(new LaneClosureRequestBlockLane({ laneId: this.addLane.laneId.value, peakId: this.addLane.peakId.value, peakReason: this.addLane.peakReason.value }));
			}
		}
			// add the relevant blocks too.
			for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				laneIndex = null;
				for (var xx = 0; xx < this.laneClosureRequest.block[x].lane.length; xx++) {
					// since they can't close the same block at two different peak ids, we will only add the lane if it isn't already assigned to the block.
					// && this.laneClosureRequest.block[x].lane[xx].peakId.value == this.addLane.peakId.value
					if (
					this.laneClosureRequest.block[x].lane[xx].laneId.value == this.addLane.laneId.value
					) {
						laneIndex = xx;
				}
			}
			if (laneIndex == null) {
				if (LaneClosureRequest.hasTrafficLaneInDirection(this.addLane.laneId.value, this.laneClosureRequest.block[x].directionId)) {
					this.laneClosureRequest.block[x].lane.push(new LaneClosureRequestBlockLane({ laneId: this.addLane.laneId.value, peakId: this.addLane.peakId.value, peakReason: this.addLane.peakReason.value }));
				}
			}
		}
		this.addLane.laneId.value = null;
		this.updateTrafficEffect();
		this.forceRerender();
	},

	onShowAddBicycleModal() {
			// re-open for peak-periods.

			// westbound median
			if (this.laneClosureRequest.directionId.value == 4 || this.laneClosureRequest.directionId.value == 5) {
				this.addBicycle.bicycleLaneId.value = 3;
			}

			// eastbound median.
			if (this.laneClosureRequest.directionId.value == 3 || this.laneClosureRequest.directionId.value == 5) {
				this.addBicycle.bicycleLaneId.value = 1;
			}

			// southbound median.
			if (this.laneClosureRequest.directionId.value == 2 || this.laneClosureRequest.directionId.value == 6) {
				this.addBicycle.bicycleLaneId.value = 7;
			}

			//  northbound median.
			if (this.laneClosureRequest.directionId.value == 1 || this.laneClosureRequest.directionId.value == 6) {
				this.addBicycle.bicycleLaneId.value = 5;
			}

			this.showAddBicycleModal = true;
		},


		onConfirmAddBicycle() {
			var laneIndex = null;
			var x = 0;
			var xx = 0;

			// add to the preset blocks...
			for (x = 0; x < this.laneClosureRequest.presetBlock.length; x++) {
				laneIndex = null;
				for (var xx = 0; xx < this.laneClosureRequest.presetBlock[x].bicycle.length; xx++) {
					if (
					this.laneClosureRequest.presetBlock[x].bicycle[xx].bicycleLaneId.value == this.addBicycle.bicycleLaneId.value
					) {
						laneIndex = xx;
				}
			}
			if (laneIndex == null) {
				this.laneClosureRequest.presetBlock[x].bicycle.push(new LaneClosureRequestBlockBicycle({ bicycleLaneId: this.addBicycle.bicycleLaneId.value }));
			}
		}
			// add the relevant blocks too.
			for (x = 0; x < this.laneClosureRequest.block.length; x++) {
				laneIndex = null;
				for (xx = 0; xx < this.laneClosureRequest.block[x].bicycle.length; xx++) {
					if (
					this.laneClosureRequest.block[x].bicycle[xx].bicycleLaneId.value == this.addBicycle.bicycleLaneId.value
					) {
						laneIndex = xx;
				}
			}
			if (laneIndex == null) {
				this.laneClosureRequest.block[x].bicycle.push(new LaneClosureRequestBlockBicycle({ bicycleLaneId: this.addBicycle.bicycleLaneId.value }));
			}
		}
		if (LaneClosureRequest.isProtectedBikeLane(this.addBicycle.bicycleLaneId.value)) {
			this.showProtectedBikeLaneModal = true;
			this.addBicycle.bicycleLaneId.value = null;
		} else {
			this.updateTrafficEffect();
			this.forceRerender();
		}
	},



	onShowAddSidewalkModal() {
			// re-open for peak-periods.

			// westbound median
			if (this.laneClosureRequest.directionId.value == 4 || this.laneClosureRequest.directionId.value == 5) {
				this.addSidewalk.sidewalkId.value = 3;
			}

			// eastbound median.
			if (this.laneClosureRequest.directionId.value == 3 || this.laneClosureRequest.directionId.value == 5) {
				this.addSidewalk.sidewalkId.value = 4;
			}

			// southbound median.
			if (this.laneClosureRequest.directionId.value == 2 || this.laneClosureRequest.directionId.value == 6) {
				this.addSidewalk.sidewalkId.value = 2;
			}

			//  northbound median.
			if (this.laneClosureRequest.directionId.value == 1 || this.laneClosureRequest.directionId.value == 6) {
				this.addSidewalk.sidewalkId.value = 1;
			}

			this.showAddSidewalkModal = true;
		},

		onConfirmAddSidewalk() {
			// add to the preset blocks...
			for (var x = 0; x < this.laneClosureRequest.presetBlock.length; x++) {
				var laneIndex = null;
				for (var xx = 0; xx < this.laneClosureRequest.presetBlock[x].sidewalk.length; xx++) {
					if (
					this.laneClosureRequest.presetBlock[x].sidewalk[xx].sidewalkId.value == this.addSidewalk.sidewalkId.value
					) {
						laneIndex = xx;
				}
			}
			if (laneIndex == null) {
				this.laneClosureRequest.presetBlock[x].sidewalk.push(new LaneClosureRequestBlockSidewalk({ sidewalkId: this.addSidewalk.sidewalkId.value }));
			}
		}
			// add the relevant blocks too.
			for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				var laneIndex = null;
				for (var xx = 0; xx < this.laneClosureRequest.block[x].sidewalk.length; xx++) {
					if (
					this.laneClosureRequest.block[x].sidewalk[xx].sidewalkId.value == this.addSidewalk.sidewalkId.value
					) {
						laneIndex = xx;
				}
			}
			if (laneIndex == null) {
				this.laneClosureRequest.block[x].sidewalk.push(new LaneClosureRequestBlockSidewalk({ sidewalkId: this.addSidewalk.sidewalkId.value }));
			}
		}
		this.addSidewalk.sidewalkId.value = null;
		this.updateTrafficEffect();
		this.$nextTick(() => {
			if (this.laneClosureRequest.presetBlock[0].sidewalk.length > 1) {
				this.showMultipleSidewalksModal = true;
			} else {
				this.forceRerender();
			}
		});

	},


	onShowAddRestrictionModal() {
			// re-open for peak-periods.
			this.addRestriction.peakId.value = 1;
			this.addRestriction.restrictionTypeId.value = 1;

			// westbound median
			if (this.laneClosureRequest.directionId.value == 4 || this.laneClosureRequest.directionId.value == 5) {
				this.addRestriction.directionId.value = 4;
			}

			// eastbound median.
			if (this.laneClosureRequest.directionId.value == 3 || this.laneClosureRequest.directionId.value == 5) {
				this.addRestriction.directionId.value = 3;
			}

			// southbound median.
			if (this.laneClosureRequest.directionId.value == 2 || this.laneClosureRequest.directionId.value == 6) {
				this.addRestriction.directionId.value = 2;
			}

			//  northbound median.
			if (this.laneClosureRequest.directionId.value == 1 || this.laneClosureRequest.directionId.value == 6) {
				this.addRestriction.directionId.value = 1;
			}

			this.showAddRestrictionModal = true;
		},

		onConfirmAddRestriction() {
			// add to the preset blocks...
			var presetIndex = null;
			var y = 0;
			for (var x = 0; x < this.laneClosureRequest.presetBlock.length; x++) {
				for (var xx = 0; xx < this.laneClosureRequest.presetBlock[x].restriction.length; xx++) {
					if (
					this.laneClosureRequest.presetBlock[x].restriction[xx].restrictionTypeId.value == this.addRestriction.restrictionTypeId.value &&
					this.laneClosureRequest.presetBlock[x].restriction[xx].directionId.value == this.addRestriction.directionId.value &&
					this.laneClosureRequest.presetBlock[x].restriction[xx].peakId.value == this.addRestriction.peakId.value
					) {
						presetIndex = xx;
					this.laneClosureRequest.presetBlock[x].restriction[xx].peakReason.value = this.addRestriction.peakReason.value;
				}
			}
			if (presetIndex == null) {
				this.laneClosureRequest.presetBlock[x].restriction.push(new LaneClosureRequestPresetRestriction({ restrictionTypeId: this.addRestriction.restrictionTypeId.value, directionId: this.addRestriction.directionId.value,  peakId: this.addRestriction.peakId.value, peakReason: this.addRestriction.peakReason.value }));
				presetIndex = this.laneClosureRequest.presetBlock[x].restriction.length - 1;
			}
		}



			// add the relevant blocks too.
			for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				var rIndex = null;
				var thisCrossStreet = null;
				for (var xx = 0; xx < this.laneClosureRequest.block[x].restriction.length; xx++) {
					if (
					this.laneClosureRequest.block[x].restriction[xx].restrictionTypeId.value == this.addRestriction.restrictionTypeId.value &&
					this.laneClosureRequest.block[x].restriction[xx].peakId.value == this.addRestriction.peakId.value &&
					this.laneClosureRequest.block[x].restriction[xx].directionId.value == this.addRestriction.directionId.value
					) {
						rIndex = xx;
					this.laneClosureRequest.block[x].restriction[xx].peakReason.value = this.addRestriction.peakReason.value;
				}
			}
			if (rIndex == null) {
					// if (LaneClosureRequest.hasRestrictionInDirection(this.addRestriction.restrictionTypeId.value, this.laneClosureRequest.block[x].directionId)) {
					// this.laneClosureRequest.block[x].restriction.push(new LaneClosureRequestBlockRestriction({ restrictionTypeId: this.addRestriction.restrictionTypeId.value, directionId: this.addRestriction.directionId.value, peakId: this.addRestriction.peakId.value, peakReason: this.addRestriction.peakReason.value }));

					let resObj = {
						directionId: this.laneClosureRequest.presetBlock[0].restriction[presetIndex].directionId.value,
						restrictionTypeId: this.laneClosureRequest.presetBlock[0].restriction[presetIndex].restrictionTypeId.value,
						affectedStreet: this.laneClosureRequest.block[x].streetName.value,
						crossStreet: "",
						peakId: this.laneClosureRequest.presetBlock[0].restriction[presetIndex].peakId.value,
						peakReason: this.laneClosureRequest.presetBlock[0].restriction[presetIndex].peakReason.value
					};
					// No Left Turn
					if (resObj.restrictionTypeId == 1) {
						// Northbound
						if (resObj.directionId == 1 || resObj.directionId == 6) {
							resObj.crossStreet = this.laneClosureRequest.block[x].northboundLeft;
						}
						// Southbound
						if (resObj.directionId == 2 || resObj.directionId == 6) {
							resObj.crossStreet = this.laneClosureRequest.block[x].southboundLeft;
						}
						// Eastbound
						if (resObj.directionId == 3 || resObj.directionId == 5) {
							resObj.crossStreet = this.laneClosureRequest.block[x].eastboundLeft;
						}
						// Westbound
						if (resObj.directionId == 4 || resObj.directionId == 5) {
							resObj.crossStreet = this.laneClosureRequest.block[x].westboundLeft;
						}
					}
					// No Right Turn
					if (resObj.restrictionTypeId == 2) {
						// Northbound
						if (resObj.directionId == 1 || resObj.directionId == 6) {
							resObj.crossStreet = this.laneClosureRequest.block[x].northboundRight;
						}
						// Southbound
						if (resObj.directionId == 2 || resObj.directionId == 6) {
							resObj.crossStreet = this.laneClosureRequest.block[x].southboundRight;
						}
						// Eastbound
						if (resObj.directionId == 3 || resObj.directionId == 5) {
							resObj.crossStreet = this.laneClosureRequest.block[x].eastboundRight;
						}
						// Westbound
						if (resObj.directionId == 4 || resObj.directionId == 5) {
							resObj.crossStreet = this.laneClosureRequest.block[x].westboundRight;
						}
					}
					// No Through
					if (resObj.restrictionTypeId == 3) {
						// Northbound
						if (resObj.directionId == 1 || resObj.directionId == 6) {
							resObj.crossStreet = this.laneClosureRequest.block[x].northboundThrough;
						}
						// Southbound
						if (resObj.directionId == 2 || resObj.directionId == 6) {
							resObj.crossStreet = this.laneClosureRequest.block[x].southboundThrough;
						}
						// Eastbound
						if (resObj.directionId == 3 || resObj.directionId == 5) {
							resObj.crossStreet = this.laneClosureRequest.block[x].eastboundThrough;
						}
						// Westbound
						if (resObj.directionId == 4 || resObj.directionId == 5) {
							resObj.crossStreet = this.laneClosureRequest.block[x].westboundThrough;
						}
					}
					if (resObj.crossStreet != "" && resObj.crossStreet != null) {
						this.laneClosureRequest.block[x].restriction.push(new LaneClosureRequestBlockRestriction(
						resObj
						));
						thisCrossStreet = resObj.crossStreet;
					}
					// }
				}



				// push this block's chosen street names into the preset block...
				if (typeof this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId] == "undefined") {
					this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId] = [];
				}
				if (this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(thisCrossStreet) == -1) {
					this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(thisCrossStreet);
				}
				for (y = 0; y < this.laneClosureRequest.block[x].turningStreetName.length; y++) {
					if (this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(this.laneClosureRequest.block[x].turningStreetName[y]) == -1) {
						this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(this.laneClosureRequest.block[x].turningStreetName[y]);
					}
				}
				// add the block turning entries too...
				if (this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(this.laneClosureRequest.block[x].northboundLeft) == -1) {
					this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(this.laneClosureRequest.block[x].northboundLeft);
				}
				if (this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(this.laneClosureRequest.block[x].northboundRight) == -1) {
					this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(this.laneClosureRequest.block[x].northboundRight);
				}
				if (this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(this.laneClosureRequest.block[x].southboundLeft) == -1) {
					this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(this.laneClosureRequest.block[x].southboundLeft);
				}
				if (this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(this.laneClosureRequest.block[x].southboundRight) == -1) {
					this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(this.laneClosureRequest.block[x].southboundRight);
				}
				if (this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(this.laneClosureRequest.block[x].eastboundLeft) == -1) {
					this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(this.laneClosureRequest.block[x].eastboundLeft);
				}
				if (this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(this.laneClosureRequest.block[x].eastboundRight) == -1) {
					this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(this.laneClosureRequest.block[x].eastboundRight);
				}
				if (this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(this.laneClosureRequest.block[x].westboundLeft) == -1) {
					this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(this.laneClosureRequest.block[x].westboundLeft);
				}
				if (this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].indexOf(this.laneClosureRequest.block[x].westboundRight) == -1) {
					this.laneClosureRequest.presetBlock[0].restriction[presetIndex].turningStreetName["b" + this.laneClosureRequest.block[x].blockId].push(this.laneClosureRequest.block[x].westboundRight);
				}

			}




			this.addRestriction.restrictionTypeId.value = null;
			this.updateTrafficEffect();
			this.forceRerender();
		},

		onBlockListAddLane(data) {
			var laneIndex = null;
			var blockIndex = null;
			for (var bx = 0; bx < data.blockId.length; bx++) {
				laneIndex = null;
				blockIndex = null;
				for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
					if (this.laneClosureRequest.block[x].blockId == data.blockId[bx]) {
						blockIndex = x;
						for (var xx = 0; xx < this.laneClosureRequest.block[x].lane.length; xx++) {
							if (
							this.laneClosureRequest.block[x].lane[xx].laneId.value == data.laneId &&
							this.laneClosureRequest.block[x].lane[xx].peakId.value == data.peakId
							) {
								laneIndex = xx;
							this.laneClosureRequest.block[blockIndex].lane[xx].peakReason.value = data.peakReason;
						}
					}
				}
			}
				// go through and slice all of the non laneIndex entries...
				for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
					if (this.laneClosureRequest.block[x].blockId == data.blockId[bx]) {
						for (var xx = 0; xx < this.laneClosureRequest.block[x].lane.length; xx++) {
							if (
							this.laneClosureRequest.block[x].lane[xx].laneId.value == data.laneId &&
							this.laneClosureRequest.block[x].lane[xx].peakId.value == data.peakId
							) {
								// we're all good.
						} else {
							if (this.laneClosureRequest.block[x].lane[xx].laneId.value == data.laneId) {
								this.laneClosureRequest.block[x].lane.splice(xx, 1);
							}
						}
					}
				}
			}

			if (blockIndex != null && laneIndex == null) {
				this.laneClosureRequest.block[blockIndex].lane.push(new LaneClosureRequestBlockLane({ laneId: data.laneId, peakId: data.peakId, peakReason: data.peakReason }));
			}
		}
		this.forceRerender();
	},
	onBlockListAddSidewalk(data) {
		for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
			if (this.laneClosureRequest.block[x].blockId == data.blockId || data.blockId == null) {
				for (var xx = 0; xx < this.laneClosureRequest.presetBlock[0].sidewalk.length; xx++) {
					if (this.laneClosureRequest.presetBlock[0].sidewalk[xx].sidewalkId.value == data.sidewalkId) {
						this.laneClosureRequest.block[x].sidewalk.push(new LaneClosureRequestBlockSidewalk({ sidewalkId: this.laneClosureRequest.presetBlock[0].sidewalk[xx].sidewalkId.value }));
					}
				}
			}
		}
		this.forceRerender();
	},
	onBlockListAddBicycle(data) {
		var found = false;
		if (data.blockId == null) {
			for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				found = false;
				for (var y = 0; y < this.laneClosureRequest.block[x].bicycle.length; y++) {
					if (this.laneClosureRequest.block[x].bicycle[y].bicycleLaneId.value == data.bicycleLaneId) {
						found = true;
					}
				}
				if (!found) {
					this.laneClosureRequest.block[x].bicycle.push(new LaneClosureRequestBlockBicycle({ bicycleLaneId: data.bicycleLaneId }));
				}
			}
		} else {
			for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				if (this.laneClosureRequest.block[x].blockId == data.blockId) {
					var found = false;
					for (var y = 0; y < this.laneClosureRequest.block[x].bicycle.length; y++) {
						if (this.laneClosureRequest.block[x].bicycle[y].bicycleLaneId.value == data.bicycleLaneId) {
							found = true;
						}
					}
					if (!found) {
						this.laneClosureRequest.block[x].bicycle.push(new LaneClosureRequestBlockBicycle({ bicycleLaneId: data.bicycleLaneId }));
					}
				}
			}
		}
		this.forceRerender();
	},

	getAddRestrictionBlockText() {
		let text = "";
		if (this.addBlockRestrictionData) {
			if (this.laneClosureRequest.block[this.addBlockRestrictionData.blockIndex]) {

				text +=  LaneClosureRequest.getDirectionAbbreviationText(this.addBlockRestrictionData.directionId) + " ";
				text +=  this.laneClosureRequest.block[this.addBlockRestrictionData.blockIndex].streetName.value;
				text += " between " + this.laneClosureRequest.block[this.addBlockRestrictionData.blockIndex].fromStreet.value ;
				text += "  and " + this.laneClosureRequest.block[this.addBlockRestrictionData.blockIndex].toStreet.value + ", ";
				text +=  LaneClosureRequest.getRestrictionTypeText(this.addBlockRestrictionData.restrictionTypeId);
				text += " on to";

				return text;
			}
		}
		return null;
	},
	onBlockListAddRestrictionModal(data) {
		this.addBlockRestrictionData = data;
		this.showAddRestrictionDataModal = true;
	},
	onBlockListAddRestrictionModalCancel(data) {
		this.addBlockRestrictionData = null;
		this.showAddRestrictionDataModal = false;
	},
	onBlockListAddRestrictionModalConfirm(data) {
		if (this.restrictionCrossStreet.validate() !== false) {
			this.addBlockRestrictionData.crossStreet = this.restrictionCrossStreet.value;
			this.onBlockListAddRestriction(this.addBlockRestrictionData);
			this.showAddRestrictionDataModal = false;
		}
	},
	focusAddRestrictionDataModal() {
		this.$refs.restrictionCrossStreet.focus();
	},

	onBlockListAddRestriction(arrayData) {
		var restrictionIndex = null;
		var blockIndex = null;
		var data = {};
		for (var z = 0; z < arrayData.items.length; z++) {
			data = arrayData.items[z];
			restrictionIndex = null;
			blockIndex = null;

			if (arrayData.crossStreet) {
				if (data.crossStreet == "Other") {
					data.crossStreet = arrayData.crossStreet;
				}
			}
			for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				if (this.laneClosureRequest.block[x].blockId == data.blockId || data.blockId == null) {
					blockIndex = x;
					for (var xx = 0; xx < this.laneClosureRequest.block[x].restriction.length; xx++) {
						if (
						this.laneClosureRequest.block[x].restriction[xx].restrictionTypeId.value == data.restrictionTypeId &&
						this.laneClosureRequest.block[x].restriction[xx].directionId.value == data.directionId &&
						this.laneClosureRequest.block[x].restriction[xx].peakId.value == data.peakId &&
						this.laneClosureRequest.block[x].restriction[xx].crossStreet.value == data.crossStreet
						) {
							restrictionIndex = xx;
						this.laneClosureRequest.block[blockIndex].restriction[xx].peakReason.value = data.peakReason;
					}
				}
			}
		}

			// now remove any restrictions that match, but the peakID does not.
			for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				if (this.laneClosureRequest.block[x].blockId == data.blockId || data.blockId == null) {
					blockIndex = x;
					for (var xx = 0; xx < this.laneClosureRequest.block[x].restriction.length; xx++) {
						if (
						this.laneClosureRequest.block[x].restriction[xx].restrictionTypeId.value == data.restrictionTypeId &&
						this.laneClosureRequest.block[x].restriction[xx].directionId.value == data.directionId &&
						this.laneClosureRequest.block[x].restriction[xx].peakId.value == data.peakId &&
						this.laneClosureRequest.block[x].restriction[xx].crossStreet.value == data.crossStreet
						) {} else {
							if (
							this.laneClosureRequest.block[x].restriction[xx].restrictionTypeId.value == data.restrictionTypeId &&
							this.laneClosureRequest.block[x].restriction[xx].directionId.value == data.directionId &&
							this.laneClosureRequest.block[x].restriction[xx].crossStreet.value == data.crossStreet
							) {
								this.laneClosureRequest.block[x].restriction.splice(xx, 1);
						}

					}
				}
			}
		}

			// Now also add the block crossstreet to the block in the preset blocks so we can see it.
			if (blockIndex != null && restrictionIndex == null) {
				this.laneClosureRequest.block[blockIndex].restriction.push(
				new LaneClosureRequestBlockRestriction({
					directionId: data.directionId,
					restrictionTypeId: data.restrictionTypeId,
					affectedStreet: this.laneClosureRequest.block[blockIndex].affectedStreet,
					crossStreet: data.crossStreet,
					peakId: data.peakId,
					peakReason: data.peakReason
				}));
			}

			if (typeof this.laneClosureRequest.presetBlock[0].restriction[data.presetIndex].turningStreetName["b"+data.blockId] == "undefined") {
				this.laneClosureRequest.presetBlock[0].restriction[data.presetIndex].turningStreetName["b"+data.blockId] = [];
			}
			var foundStreet = false;
			for (var x = 0; x < this.laneClosureRequest.presetBlock[0].restriction[data.presetIndex].turningStreetName["b"+data.blockId].length; x++) {
				if (this.laneClosureRequest.presetBlock[0].restriction[data.presetIndex].turningStreetName["b"+data.blockId][x] == data.crossStreet) {
					foundStreet = true;
				}
			}
			if (!foundStreet) {
				this.laneClosureRequest.presetBlock[0].restriction[data.presetIndex].turningStreetName["b"+data.blockId].push(data.crossStreet);
			}
		}

		this.forceRerender();
	},
	onBlockListAddTrafficSignalsAltered(data) {
		for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
			if (this.laneClosureRequest.block[x].blockId == data.blockId || data.blockId == null) {
				this.laneClosureRequest.block[x].trafficSignalsAltered.value = data.trafficSignalsAltered;
			}
		}
		var anyAltered = false;
		for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
			if (this.laneClosureRequest.block[x].trafficSignalsAltered.value == 1) {
				anyAltered = true;
			}
		}
		if (anyAltered == true) {
			this.laneClosureRequest.trafficSignalsAltered.value = 1;
		} else {
			this.laneClosureRequest.trafficSignalsAltered.value = 0;
		}
		this.forceRerender();
	},

	onSaveBlock: function(index) {
		this.isEditingBlock = false;
		this.forceRerender();
	},

	onAddSidewalk: function() {
		this.laneClosureRequest.block[this.editingBlockIndex].sidewalk.push(new LaneClosureRequestBlockSidewalk);
		this.expandSidewalk = true;
		this.forceRerender();
	},
	onRemoveSidewalk(index) {
		this.laneClosureRequest.block[this.editingBlockIndex].sidewalk.splice(index, 1);
		this.expandSidewalk = true;
		this.forceRerender();
	},

	onAddBicycle: function(index) {
		if (this.laneClosureRequest.block[this.editingBlockIndex]) {
			this.laneClosureRequest.block[index].bicycle.push(new LaneClosureRequestBlockBicycle);
			this.expandBicycle = true;
			this.forceRerender();
		}
	},
	onRemoveBicycle(index) {
		if (this.laneClosureRequest.block[this.editingBlockIndex]) {
			this.laneClosureRequest.block[this.editingBlockIndex].bicycle.splice(index, 1);
			this.expandBicycle = true;
			this.forceRerenderBlockEditDetails();
		}
	},

	onRemoveBlock() {
		this.showRemoveBlockModal = true;
	},

	modalOnRemoveAllBlocks: function() {
		this.showRemoveAllBlocksModal = false;
		this.validateConfirmedBlocks.value = 0;
		this.$store.commit('map/clearMap', null);
		this.laneClosureRequest.block = [];
		Vue.prototype.$bus.$emit("map:reset-side-bar",false);
		this.updateTrafficEffect();
	},

	modalOnRemoveAllBlocksCancel: function() {
		this.showRemoveAllBlocksModal = false;
	},


	onConfirmRemoveBlock() {
			// this.isEditing = false;
			this.showRemoveBlockModal = false;
			this.validateConfirmedBlocks.value = 0;
			var deleteBlockIndex = this.editingBlockIndex + 0;
			let x = 0;
			// delete the line from the map.
			if (this.laneClosureRequest.block[deleteBlockIndex]) {
				if (this.laneClosureRequest.block[deleteBlockIndex].mapPolyline) {
					this.laneClosureRequest.block[deleteBlockIndex].mapPolyline.setMap(null);
				}

				for (x = 0; x < this.$store.getters["map/polylines"].length; x++) {
					if (this.$store.getters["map/polylines"][x]) {
						if (this.$store.getters["map/polylines"][x].blockData) {
							if (this.$store.getters["map/polylines"][x].blockData.blockId == this.laneClosureRequest.block[deleteBlockIndex].blockId) {
								this.$store.commit('map/removePolyLineByBlockId', this.laneClosureRequest.block[deleteBlockIndex].blockId);
							}
						}
					}
				}
				this.laneClosureRequest.block.splice(deleteBlockIndex, 1);
				this.editingBlockIndex = -1;
				this.isEditingBlock = false;
				this.updateTrafficEffect();
				this.forceRerender();
			} else {
				this.editingBlockIndex = -1;
				this.isEditingBlock = false;
			}
		},
		onRemoveRestriction(index) {
			this.laneClosureRequest.block[this.editingBlockIndex].restriction.splice(index, 1);
			this.expandRestriction = true;
			this.forceRerender();
		},
		onAddRestriction() {
			this.laneClosureRequest.block[this.editingBlockIndex].restriction.push(new LaneClosureRequestBlockRestriction);
			this.expandRestriction = true;
			this.forceRerender();
		},


		updateTrafficEffect() {
			if (this.canSetTrafficEffect) {
				this.laneClosureRequest.trafficEffect.value = this.calculateLcrTrafficEffectText();
			}
			this.laneClosureRequest.trafficEffect.value = this.calculateLcrTrafficEffectText();
		},

		onMapBlockClick: function(evt) {
			if (evt.blockData) {
				// we clicked a block!
				//
				// check if we have the block defined
				let x = 0;
				let found = false;
				for (x = 0; x < this.laneClosureRequest.block.length; x++) {
					if (this.laneClosureRequest.block[x].blockId == evt.blockData.blockId) {
						found = true;
					}
				}
				if (!found) {
					// don't do anything...
				} else {
					if (typeof this.$refs.blockDetails != "undefined") {
						// this.$bus.$emit('map:block-popup', evt);
						// this.$refs.blockDetails.editBlockById(evt.blockData.blockId);
					}
				}
			}
		},


		onMapBlockClickEdit: function(evt) {
			if (evt.blockData) {
				// we clicked a block!
				//
				// check if we have the block defined
				let x = 0;
				let found = false;
				for (x = 0; x < this.laneClosureRequest.block.length; x++) {
					if (this.laneClosureRequest.block[x].blockId == evt.blockData.blockId) {
						found = true;
					}
				}
				if (!found) {
					// let's add it back in
					evt.setMap(null);
					this.setBlockPolyline(evt.blockData);
				} else {
					if (typeof this.$refs.blockDetails != "undefined") {
						this.$refs.blockDetails.editBlockById(evt.blockData.blockId);
					}
				}
			}
		},

		onMapBlockPolylineClick: function(polyline, e) {
			var x = 0;
			for (x = 0; x < this.$store.getters["map/polylines"].length; x++) {
				if (this.$store.getters["map/polylines"][x].blockData.blockId == polyline.blockData.blockId) {
					this.$store.getters["map/polylines"][x].setOptions({
						strokeColor: "#f2b942",
					});
				} else {
					this.$store.getters["map/polylines"][x].setOptions({
						strokeColor: "#293C7C",
					});
				}
			}
			// this.$bus.$emit('map:block-popup', {polyline:this, e:e});
			this.$bus.$emit('map:block-picker-popup', { polyline: polyline, e: e });
		},

		onMapBlockEdit: function(id) {
			// this.onEditBlock(id);
			// this.$bus.$emit('map:block-popup', {polyline:this, e:e});
		},

		onMapBlockRemove: function(id) {
			let x = 0;
			let xx = 0;
			this.validateConfirmedBlocks.value = 0;

			// delete the line from the map.
			for (xx = 0; xx < this.laneClosureRequest.block.length; xx++) {
				if (this.laneClosureRequest.block[xx].blockId == id) {
					if (this.laneClosureRequest.block[xx].mapPolyline) {
						this.laneClosureRequest.block[xx].mapPolyline.setMap(null);
					}
					for (x = 0; x < this.$store.getters["map/polylines"].length; x++) {
						if (this.$store.getters["map/polylines"][x]) {
							if (this.$store.getters["map/polylines"][x].blockData) {
								if (this.$store.getters["map/polylines"][x].blockData.blockId == this.laneClosureRequest.block[xx].blockId) {
									this.$store.commit('map/removePolyLineByBlockId', this.laneClosureRequest.block[xx].blockId);
								}
							}
						}
					}
					this.laneClosureRequest.block.splice(xx, 1);
					this.updateTrafficEffect();
					// this.forceRerender();
					break;
				}
			}
		},

		onMapBlockRemoveAll: function() {
			this.showRemoveAllBlocksModal = true;
		},

		onEditBlockLanes: function(id) {
			this.expandLane = true;
			this.expandSidewalk = false;
			this.expandBicycle = false;
			this.expandRestriction = false;
			this.onEditBlock(id);
		},

		onEditBlockBicycle: function(id) {
			this.expandLane = false;
			this.expandSidewalk = false;
			this.expandBicycle = true;
			this.expandRestriction = false;
			this.onEditBlock(id);
		},

		onEditBlockSidewalk: function(id) {
			this.expandLane = false;
			this.expandSidewalk = true;
			this.expandBicycle = false;
			this.expandRestriction = false;
			this.onEditBlock(id);
		},
		onEditBlockRestriction: function(id) {
			this.expandLane = false;
			this.expandSidewalk = false;
			this.expandBicycle = false;
			this.expandRestriction = true;
			this.onEditBlock(id);
		},

		onEditBlock: function(id) {
			let foundIndex = -1;
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.block) {
					let x = 0;
					for (x = 0; x < this.laneClosureRequest.block.length; x++) {
						if (this.laneClosureRequest.block[x].blockId == id) {
							foundIndex = x;
						}
					}
				}
			}
			if (this.$refs.lcrWizard) {
				if (this.$refs.lcrWizard.activeTabIndex == 2) {
					// lookup the block clicked on.
				} else {
					this.$nextTick(() => {
						this.$refs.lcrWizard.navigateToTab(2);
					})


				}
			}
			if (foundIndex > -1) {
				this.isEditingBlock = true;
				this.editingBlockIndex = foundIndex;
				this.setPolylineColours(foundIndex);
				this.zoomToBlock(foundIndex);
			} else {
				this.isEditingBlock = false;
				this.editingBlockIndex = -1;
				this.setPolylineColours(this.editingBlockIndex);
			}
		},

		zoomToBlock(index) {
			var bounds = new google.maps.LatLngBounds();
			let setBounds = false;
			let x = 0;
			let z = 0;
			if (this.laneClosureRequest.block[index]) {
				if (this.$store.getters["map/polylines"]) {
					for (x = 0; x < this.$store.getters["map/polylines"].length; x++) {
						if (this.$store.getters["map/polylines"][x]) {
							if (this.$store.getters["map/polylines"][x].blockData) {
								if (this.$store.getters["map/polylines"][x].blockData.blockId == this.laneClosureRequest.block[index].blockId) {
									let polyBounds = this.$store.getters["map/polylines"][x].getPath();
									for (z = 0; z < polyBounds.length; z++) {
										bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
									}
									setBounds = true;
								}
							}
						}
					}
				}
			}
			if (setBounds) {
				this.$store.state.map.map.fitBounds(bounds);
			}
		},

		setPolylineColours(index) {
			let x = 0;
			for (x = 0; x < this.$store.getters["map/polylines"].length; x++) {
				if (this.$store.getters["map/polylines"][x]) {
					if (this.$store.getters["map/polylines"][x].blockData) {
						if (this.$store.getters["map/polylines"][x].blockData.blockId == this.laneClosureRequest.block[index].blockId) {
							this.$store.getters["map/polylines"][x].setOptions({ strokeColor: '#293C7C' });
						} else {
							this.$store.getters["map/polylines"][x].setOptions({ strokeColor: '#F2B942' });
						}
					}
				}
			}

		},


		onMapClick: function(evt) {
			if (evt.placeId) {
				// ignore the click, because they clicked on a place.
			} else {
				if (this.$refs.lcrWizard) {
					if (this.$refs.lcrWizard.activeTabIndex == 2 || this.$refs.lcrWizard.activeTabIndex == 1 ) {
						// lookup the block clicked on.
						this.clickedMap = true;
						this.getBlockByLatLng(evt.latLng.lat(), evt.latLng.lng());
					}
				}
			}
		},

		getBlockByLatLng(lat, lng) {
			let that = this;

			Vue.prototype.$http.post(this.$store.state.apiUrl + '/block/lat-lng', { lat: lat, lng: lng, distanceInMetres: 10 })
			.then(resp => {
				if (resp.data.length > 0) {
					that.setBlockPolyline(resp.data[0]);
					// that.validateConfirmedBlocks.value = 0;
					this.showNonRegionalStreetModal = false;
						// let them pick non-regional blocks.
						/*
						if (resp.data[0].sRoute != "Regional") {
							// check if they have any blocks.
							this.hasRegionalBlock = false;
							for (let x = 0; x < this.laneClosureRequest.block.length; x++) {
								if (this.laneClosureRequest.block[x].sRoute.value == "Regional") {
									this.hasRegionalBlock = true;
								}
							}
							if (!this.hasRegionalBlock) {
								this.nonRegionalBlock = resp.data[0];
								this.showNonRegionalStreetModal = true;
							} else {
								that.setBlockPolyline(resp.data[0]);
								this.showNonRegionalStreetModal = false;
							}
						} else {
							that.setBlockPolyline(resp.data[0]);
							this.showNonRegionalStreetModal = false;
						}
						*/
					}
				})
			.catch(error => {})
		},


		onFromDateTimeChanged: function(val) {
			if (this.laneClosureRequest.fromDate.value && val) {
						const utc = Format.mergeUtcDateTime(
								this.laneClosureRequest.fromDate.value,
								val
						);

						this.laneClosureRequest.fromDate.value = utc;
						this.laneClosureRequest.fromTime.value = utc;
			} else {
				if (val) {
								this.laneClosureRequest.fromTime.value =
										Format.fromUtc(val).utc().format();
				}
			}
		},
		onToDateTimeChanged: function(val) {
			if (this.laneClosureRequest.toDate.value && val) {
						const utc = Format.mergeUtcDateTime(
								this.laneClosureRequest.toDate.value,
								val
						);

						this.laneClosureRequest.toDate.value = utc;
						this.laneClosureRequest.toTime.value = utc;
			} else {
				if (val) {
								this.laneClosureRequest.toTime.value =
										Format.fromUtc(val).utc().format();
				}
			}
		},

		checkEmptyRoadwayMetres: function() {
			this.laneClosureRequest.permitRoadwayMetres.resetStatus();
			if (this.laneClosureRequest.permitRoadwayMetres.value +"" == "0") {
				if (this.laneClosureRequest.permitRoadwayFrom.value == null || this.laneClosureRequest.permitRoadwayFrom.value == "") {
					this.laneClosureRequest.permitRoadwayFrom.value = "N/A";
				}
				if (this.laneClosureRequest.permitRoadwayTo.value == null || this.laneClosureRequest.permitRoadwayTo.value == "") {
					this.laneClosureRequest.permitRoadwayTo.value = "N/A";
				}
			} else {
				if (this.laneClosureRequest.permitRoadwayFrom.value == "N/A") {
					this.laneClosureRequest.permitRoadwayFrom.value = null;
				}
				if (this.laneClosureRequest.permitRoadwayTo.value == "N/A") {
					this.laneClosureRequest.permitRoadwayTo.value = null;
				}
			}

		},
		checkEmptySidewalkMetres: function() {
			this.laneClosureRequest.permitSidewalkMetres.resetStatus()
			if (this.laneClosureRequest.permitSidewalkMetres.value +"" == "0") {
				if (this.laneClosureRequest.permitSidewalkFrom.value == null || this.laneClosureRequest.permitSidewalkFrom.value == "") {
					this.laneClosureRequest.permitSidewalkFrom.value = "N/A";
					this.laneClosureRequest.permitSidewalkFrom.status = null;

				}
				if (this.laneClosureRequest.permitSidewalkTo.value == null || this.laneClosureRequest.permitSidewalkTo.value == "") {
					this.laneClosureRequest.permitSidewalkTo.value = "N/A";
					this.laneClosureRequest.permitSidewalkTo.status = null;
				}
			} else {
				if (this.laneClosureRequest.permitSidewalkFrom.value == "N/A") {
					this.laneClosureRequest.permitSidewalkFrom.value = null;
				}
				if (this.laneClosureRequest.permitSidewalkTo.value == "N/A") {
					this.laneClosureRequest.permitSidewalkTo.value = null;
				}
			}
		},

		checkSidewalks: function(id) {
			let i = 0;
			for (i = 0; i < this.laneClosureRequest.sidewalk.length; i++) {
				if (this.laneClosureRequest.sidewalk[i].sidewalkId == id) {
					this.laneClosureRequest.sidewalk.splice(i, 1)
					return true;
				}
				return false;
			}
		},
		checkTransit: function(id) {
			let i = 0;
			for (i = 0; i < this.laneClosureRequest.transit.length; i++) {
				if (this.laneClosureRequest.transit[i].transitEffectId == id) {
					this.laneClosureRequest.transit.splice(i, 1)
					return true;
				}
				return false;
			}
		},
		checkParkingLane: function(id) {
			let i = 0;
			for (i = 0; i < this.laneClosureRequest.parkingLane.length; i++) {
				if (this.laneClosureRequest.parkingLane[i].parkingId == id) {
					this.laneClosureRequest.parkingLane.splice(i, 1)
					return true;
				}
				return false;
			}
			return false;
		},


		// required fields notifying modal
		modalRequiredFieldClose() {
			this.showRequiredFieldModal = false;
		},

		showErrors(errors) {
			this.submissionStatus = 'submission-error';
			this.modalRequiredFieldList = [];
			for (let field in errors) {
				this.modalRequiredFieldList.push(errors[field]);
			}
			this.showRequiredFieldModal = true;
		},


		closeNewProjectModal() {
			this.showNewProjectModal = false;
			this.laneClosureRequest.requesterProjectId.value = null;
		},
		openNewProjectModal() {
			this.showNewProjectModal = true;
		},
		getRequesterProjects() {
			return Vue.prototype.$http.post(this.$store.state.apiUrl + '/project/assignable', { userId: this.laneClosureRequest.requesterId })
			.then(resp => {
				this.requesterProjectIdOptions = [
				{
					id:null,
					name:"No Project Assigned",
					displayName:"No Project Assigned",
					isActive:1
				}
				];
				if (resp.data.length == 0) {
					this.laneClosureRequest.requesterProjectId.value = null;
				} else {
					for (var x = 0; x < resp.data.length; x++) {
						let projectX = Object.assign({}, resp.data[x]);
						if (resp.data[x].isActive == 0) {
							projectX.displayName = projectX.name + " (Archived)";
							this.requesterProjectIdOptions.push(projectX);
						} else {
							projectX.displayName = projectX.name;
							this.requesterProjectIdOptions.push(projectX);
						}
							// this.requesterProjectIdOptions.push(resp.data[x]);
						}
					}
				})
			.catch(error => {})
		},

		showNewProjectModalOkClick() {
			this.SaveNewProject();
		},
		SaveNewProject() {
			// TODO: Do we clear the first cross street and last cross street?
			// fill the first cross and last cross street names...
			let data = {
				organizationId: this.laneClosureRequest.requester.organizationId,
				name: this.newProject.name.value,
				isActive: this.newProject.isActive.value ? 1 : 0,
				comments: this.newProject.comments.value
			}
			Vue.prototype.$http.post(this.$store.state.apiUrl + '/project', data)
			.then(resp => {
				this.laneClosureRequest.requesterProjectId.value = resp.data.id;
				this.requesterProjectInfo = resp.data;
				this.showNewProjectModal = false;
				this.newProject.name.value = null;
				this.newProject.comments.value = null;
				this.getRequesterProjects();
			})
			.catch(error => {})

		},

		projectSelectChanged() {
			this.laneClosureRequest.requesterProjectId.resetStatus();
		},
		closeEditProjectModal() {
			this.showEditProjectModal = false;
		},
		openEditProjectModal() {
			if (this.laneClosureRequest.requesterProjectId.value > 0) {
				let curProject = this.requesterProjectIdOptions.find(x => x.id == this.laneClosureRequest.requesterProjectId.value);
				this.editProject.name.value = curProject.name;
				this.editProject.isActive.value = curProject.isActive;
				this.editProject.comments.value = curProject.comments;
				this.editProject.id = curProject.id;
				this.showEditProjectModal = true;
			}
		},
		showEditProjectModalOkClick() {
			this.SaveEditProject();
		},
		SaveEditProject() {
			let data = {
				id: this.editProject.id,
				organizationId: this.laneClosureRequest.requester.organizationId,
				name: this.editProject.name.value,
				isActive: this.editProject.isActive.value ? 1 : 0,
				comments: this.editProject.comments.value
			}
			Vue.prototype.$http.put(this.$store.state.apiUrl + '/project/' + this.editProject.id, data)
			.then(resp => {
				this.laneClosureRequest.requesterProjectId.value = resp.data.id;
				this.requesterProjectInfo = resp.data;
				this.showEditProjectModal = false;
				this.editProject.id = null;
				this.editProject.name.value = null;
				this.editProject.comments.value = null;
				this.editProject.isActive.value = null;
				this.getRequesterProjects();
			})
			.catch(error => {})
		},
		ArchiveProject() {
			let data = {
				id: this.editProject.id,
				organizationId: this.laneClosureRequest.requester.organizationId,
				name: this.editProject.name.value,
				isActive: 0,
				comments: this.editProject.comments.value
			}
			Vue.prototype.$http.put(this.$store.state.apiUrl + '/project/' + this.editProject.id + "/archive", data)
			.then(resp => {
				this.laneClosureRequest.requesterProjectId.value = resp.data.id;
				this.requesterProjectInfo = resp.data;
				this.showEditProjectModal = false;
				this.editProject.id = null;
				this.editProject.name.value = null;
				this.editProject.comments.value = null;
				this.editProject.isActive.value = null;
				this.getRequesterProjects();
			})
			.catch(error => {})
		},
		RestoreProject() {
			let data = {
				id: this.editProject.id,
				organizationId: this.laneClosureRequest.requester.organizationId,
				name: this.editProject.name.value,
				isActive: 1,
				comments: this.editProject.comments.value
			}
			Vue.prototype.$http.put(this.$store.state.apiUrl + '/project/' + this.editProject.id + "/restore", data)
			.then(resp => {
				this.laneClosureRequest.requesterProjectId.value = resp.data.id;
				this.requesterProjectInfo = resp.data;
				this.showEditProjectModal = false;
				this.editProject.id = null;
				this.editProject.name.value = null;
				this.editProject.comments.value = null;
				this.editProject.isActive.value = null;
				this.getRequesterProjects();
			})
			.catch(error => {})
		},

		updateRequesterProjectLabel() {
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.requester) {
					this.projectLabel = this.laneClosureRequest.requester.organizationName + " Project";
				} else {
					this.projectLabel = "Project";
				}
			} else {
				this.projectLabel = "Project";
			}
		},


		// Updates the most recent text entered into the autocomplete input.
		SearchAffectedStreet(input) {
			return new Promise((resolve, reject) => {
				if (input.length < 3) {
					return resolve([])
				}
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/block/affected-street?q=' + encodeURI(input))
				.then(resp => {
					resolve(resp.data)
					if (resp.data.length == 0) {
						this.firstCrossStreetOptions = this.noFirstCrossStreetOptions;
							// this.lastCrossStreetOptions = this.noLastCrossStreetOptions;
							// this.laneClosureRequest.firstCrossStreet.value = null;
							// this.laneClosureRequest.lastCrossStreet.value = null;
						}
					})
				.catch(error => {
					reject(error)
				})
			})
		},
		SearchAffectedStreetValue(result) {
			return result.streetName
		},

		handleAutocompleteAffectedStreet(obj) {
			if (obj.target.value != "") {
				this.HandleSelectAffectedStreet({ streetName: obj.target.value });
			}
		},

		HandleSelectAffectedStreet(selected) {
			this.laneClosureRequest.affectedStreet.value = selected.streetName;
			this.laneClosureRequest.affectedStreet.setDirty();
			let that = this;
			// TODO: Do we clear the first cross street and last cross street?
			// fill the first cross and last cross street names...
			Vue.prototype.$http.post(this.$store.state.apiUrl + '/block/cross-street', { affectedStreetName: selected.streetName })
			.then(resp => {
				if (resp.data.length == 0) {
					that.firstCrossStreetOptions = that.noFirstCrossStreetOptions;
					that.lastCrossStreetOptions = that.noLastCrossStreetOptions;
					that.laneClosureRequest.firstCrossStreet.value = null;
					that.laneClosureRequest.lastCrossStreet.value = null;
				} else {
					that.firstCrossStreetOptions = resp.data;
					that.lastCrossStreetOptions = resp.data;
				}

				if (that.firstCrossStreetOptions.filter(x => x.value == that.laneClosureRequest.firstCrossStreet.value).length == 0) {
					that.laneClosureRequest.firstCrossStreet.value = null;
					this.$store.commit('map/clearMap', null);
				}
				if (that.lastCrossStreetOptions.filter(x => x.value == that.laneClosureRequest.lastCrossStreet.value).length == 0) {
					that.laneClosureRequest.lastCrossStreet.value = null;
					this.$store.commit('map/clearMap', null);
				}

				this.loadBlocks();

					// that.setFirstCrossStreetMapMarker();
					// that.setLastCrossStreetMapMarker();
				})
			.catch(error => {})
		},

		onRequesterSearch(input) {
			return new Promise((resolve, reject) => {
				if (input.length < 1) {
					return resolve([])
				}
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/users/level-assignable?q=' + encodeURI(input))
				.then(resp => {
					resolve(resp.data)
				})
				.catch(error => {
					reject(error)
				})
			})
		},
		// Addeds a transaction line with contact attached.
		onRequesterSelect(selected) {
			this.laneClosureRequest.setDirty();

			this.laneClosureRequest.requesterId = parseInt(selected.userId);
			this.laneClosureRequest.requester = selected;
			this.$refs.searchRequester.value = null;
		},

		// Alternate Requesters
		onAltRequesterSearch(input) {
			return new Promise((resolve, reject) => {
				if (input.length < 1) {
					return resolve([])
				}
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/users/level-assignable-alt?q=' + encodeURI(input))
				.then(resp => {
					resolve(resp.data)
				})
				.catch(error => {
					reject(error)
				})
			})
		},
		onAltRequesterSelect(selected) {
			// add the selected contact to the alternate listing, with a delete button as well.
			let found = false;
			if (this.laneClosureRequest.requester != null) {
				if (this.laneClosureRequest.requester.userId == selected.userId) {
					found = true;
				}
			}
			for (var entry in this.laneClosureRequest.altRequester) {
				if (this.laneClosureRequest.altRequester[entry].userId == selected.userId) {
					// already in the list.
					found = true;
				}
			}
			if (!found) {
				this.laneClosureRequest.altRequester.push(selected);
				this.laneClosureRequest.setDirty();
			}
			this.$refs.searchAltRequester.value = null;
			// this.$refs.searchAltRequesterLimited.value = null;
		},
		onRemoveAltRequester(index) {
			this.laneClosureRequest.altRequester.splice(index, 1);
			this.laneClosureRequest.setDirty();
		},





		onClosureReporterSearch(input) {
			return new Promise((resolve, reject) => {
				if (input.length < 1) {
					return resolve([])
				}
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/users/level-assignable?q=' + encodeURI(input))
				.then(resp => {
					resolve(resp.data)
				})
				.catch(error => {
					reject(error)
				})
			})
		},
		// Addeds a transaction line with contact attached.
		onClosureReporterSelect(selected) {
			this.laneClosureRequest.closureReporter = selected;
			this.laneClosureRequest.closureReporterId = parseInt(selected.userId);
			this.$refs.searchClosureReporter.value = null;
			// this.$refs.searchClosureReporterLimited.value = null;
			this.laneClosureRequest.setDirty();
		},


		// Alternate ClosureReporters
		onAltClosureReporterSearch(input) {
			return new Promise((resolve, reject) => {
				if (input.length < 1) {
					return resolve([])
				}
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/users/level-assignable-alt?q=' + encodeURI(input))
				.then(resp => {
					resolve(resp.data)
				})
				.catch(error => {
					reject(error)
				})
			})
		},
		onAltClosureReporterSelect(selected) {
			// add the selected contact to the alternate listing, with a delete button as well.
			let found = false;
			if (this.laneClosureRequest.closureReporter != null) {
				if (this.laneClosureRequest.closureReporter.userId == selected.userId) {
					found = true;
				}
			}

			for (var entry in this.laneClosureRequest.altClosureReporter) {
				if (this.laneClosureRequest.altClosureReporter[entry].userId == selected.userId) {
					// already in the list.
					found = true;
				}
			}
			if (!found) {
				this.laneClosureRequest.altClosureReporter.push(selected);
				this.laneClosureRequest.setDirty();
			}
			this.$refs.searchAltClosureReporter.value = "";
			// this.$refs.searchAltClosureReporterLimited.value = "";
		},
		onRemoveAltClosureReporter(index) {
			this.laneClosureRequest.altClosureReporter.splice(index, 1);
		},



		// Restriction Reporter
		onRestrictionReporterSearch(input) {
			return new Promise((resolve, reject) => {
				if (input.length < 1) {
					return resolve([])
				}
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/users/level-assignable?q=' + encodeURI(input))
				.then(resp => {
					resolve(resp.data)
				})
				.catch(error => {
					reject(error)
				})
			})
		},
		// Addeds a transaction line with contact attached.
		onRestrictionReporterSelect(selected) {
			this.laneClosureRequest.restrictionReporter = selected;
			this.laneClosureRequest.restrictionReporterId = parseInt(selected.userId);
			this.$refs.searchRestrictionReporter.value = "";
			// this.$refs.searchRestrictionReporterLimited.value = "";
			this.laneClosureRequest.setDirty();
		},


		// Alternate RestrictionReporters
		onAltRestrictionReporterSearch(input) {
			return new Promise((resolve, reject) => {
				if (input.length < 1) {
					return resolve([])
				}
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/users/level-assignable-alt?q=' + encodeURI(input))
				.then(resp => {
					resolve(resp.data)
				})
				.catch(error => {
					reject(error)
				})
			})
		},
		onAltRestrictionReporterSelect(selected) {
			// add the selected contact to the alternate listing, with a delete button as well.
			let found = false;
			if (this.laneClosureRequest.restrictionReporter != null) {
				if (this.laneClosureRequest.restrictionReporter.userId == selected.userId) {
					found = true;
				}
			}
			for (var entry in this.laneClosureRequest.altRestrictionReporter) {
				if (this.laneClosureRequest.altRestrictionReporter[entry].userId == selected.userId) {
					// already in the list.
					found = true;
				}
			}
			if (!found) {
				this.laneClosureRequest.altRestrictionReporter.push(selected);
				this.laneClosureRequest.setDirty();
			}
			this.$refs.searchAltRestrictionReporter.value = "";
		},
		onRemoveAltRestrictionReporter(index) {
			this.laneClosureRequest.altRestrictionReporter.splice(index, 1);
		},


		// Updates the most recent text entered into the autocomplete input.
		SearchFirstCrossStreet(input) {
			return new Promise((resolve, reject) => {
				if (input.length < 2) {
					return resolve([])
				}
				Vue.prototype.$http.post(this.$store.state.apiUrl + '/block/first-cross-street', { affectedStreetName: this.laneClosureRequest.affectedStreet, directionId: this.laneClosureRequest.directionId })
				.then(resp => {
					resolve(resp.data)
				})
				.catch(error => {
					reject(error)
				})
			})
		},
		SearchFirstCrossStreetValue(result) {
			return result.streetName
		},

		onToggleExpandAffectedStreet: function() {
			this.expandAffectedStreet = !this.expandAffectedStreet;
		},

		onBlockListRemoveLane: function(data) {
			for (var bx = 0; bx < data.blockId.length; bx++) {
				for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
					if (this.laneClosureRequest.block[x].blockId == data.blockId[bx]) {
						for (var xx = 0; xx < this.laneClosureRequest.block[x].lane.length; xx++) {
							if (this.laneClosureRequest.block[x].lane[xx].laneId.value == data.laneId &&
							this.laneClosureRequest.block[x].lane[xx].peakId.value == data.peakId
							) {
								this.laneClosureRequest.block[x].lane.splice(xx, 1);
						}
					}

				}
			}
		}
		this.forceRerender();
	},

	onBlockListRemoveSidewalk: function(data) {
		if (data.blockId == null) {
			for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				for (var y = 0; y < this.laneClosureRequest.block[x].sidewalk.length; y++) {
					if (this.laneClosureRequest.block[x].sidewalk[y].sidewalkId.value == data.sidewalkId) {
						this.laneClosureRequest.block[x].sidewalk.splice(y, 1);
						this.laneClosureRequest.setDirty();
						y = 0;
					}
				}
			}
		} else {
			for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				if (this.laneClosureRequest.block[x].blockId == data.blockId) {
					for (var y = 0; y < this.laneClosureRequest.block[x].sidewalk.length; y++) {
						if (this.laneClosureRequest.block[x].sidewalk[y].sidewalkId.value == data.sidewalkId) {
							this.laneClosureRequest.block[x].sidewalk.splice(y, 1);
							this.laneClosureRequest.setDirty();
							y = 0;
							x = 0;
						}
					}
				}
			}
		}
		this.forceRerender();
	},

	onBlockListRemoveBicycle: function(data) {
		if (data.blockId == null) {
			for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				for (var y = 0; y < this.laneClosureRequest.block[x].bicycle.length; y++) {
					if (this.laneClosureRequest.block[x].bicycle[y].bicycleLaneId.value == data.bicycleLaneId) {
						this.laneClosureRequest.block[x].bicycle.splice(y, 1);
						this.laneClosureRequest.setDirty();
						y = 0;
					}
				}
			}
		} else {
			for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				if (this.laneClosureRequest.block[x].blockId == data.blockId || data.blockId == null) {
					for (var y = 0; y < this.laneClosureRequest.block[x].bicycle.length; y++) {
						if (this.laneClosureRequest.block[x].bicycle[y].bicycleLaneId.value == data.bicycleLaneId) {
							this.laneClosureRequest.block[x].bicycle.splice(y, 1);
							this.laneClosureRequest.setDirty();
							y = 0;
							x = 0;
						}
					}
				}
			}
		}
		this.forceRerender();
	},

	onBlockListRemoveRestrictionStreetName: function(data) {
			// remove the streetName
			if (data) {
				this.onBlockListRemoveRestriction({items:data});
				if (typeof this.laneClosureRequest.presetBlock[0].restriction[data.presetIndex].turningStreetName["b"+data.blockId] == "undefined") {
				}
				var foundStreet = -1;
				for (var x = 0; x < this.laneClosureRequest.presetBlock[0].restriction[data.presetIndex].turningStreetName["b"+data.blockId].length; x++) {
					if (this.laneClosureRequest.presetBlock[0].restriction[data.presetIndex].turningStreetName["b"+data.blockId][x] == data.crossStreet) {
						foundStreet = x;
					}
				}
				if (foundStreet != -1) {
					this.laneClosureRequest.presetBlock[0].restriction[data.presetIndex].turningStreetName["b"+data.blockId].splice(foundStreet,1);
				}

			}
		},

		onBlockListRemoveRestriction: function(arrayData) {
			var data = {};
			for (var z = 0; z < arrayData.items.length; z++) {
				data = arrayData.items[z];

				for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
					if (this.laneClosureRequest.block[x].blockId == data.blockId) {
						for (var xx = 0; xx < this.laneClosureRequest.block[x].restriction.length; xx++) {
							if (
							this.laneClosureRequest.block[x].restriction[xx].restrictionTypeId.value == data.restrictionTypeId &&
							this.laneClosureRequest.block[x].restriction[xx].directionId.value == data.directionId &&
							this.laneClosureRequest.block[x].restriction[xx].crossStreet.value == data.crossStreet &&
							this.laneClosureRequest.block[x].restriction[xx].peakId.value == data.peakId
							) {
								this.laneClosureRequest.block[x].restriction.splice(xx, 1);
							this.laneClosureRequest.setDirty();
						}
					}
				}
			}
		}
		this.forceRerender();
	},

	onBlockListRemoveTrafficSignalsAltered(data) {
		for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
			if (this.laneClosureRequest.block[x].blockId == data.blockId) {
				this.laneClosureRequest.block[x].trafficSignalsAltered.value = data.trafficSignalsAltered;
			}
		}
		var anyAltered = false;
		for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
			if (this.laneClosureRequest.block[x].trafficSignalsAltered.value == 1) {
				anyAltered = true;
			}
		}
		if (anyAltered == true) {
			this.laneClosureRequest.trafficSignalsAltered.value = 1;
		} else {
			this.laneClosureRequest.trafficSignalsAltered.value = 0;
		}


		this.forceRerender();
	},

	onSubmit(evt) {
		let that = this;
		this.isButtonDisabled = true;
		this.errorMsg = null;
		if (evt) {
			evt.preventDefault();
		}
		if (!this.validateFields()) {
			this.showUnsavedChangesModal = false;
			if (this.errorMsg == null) {
				this.errorMsg = "There are problems with your submission in these sections.";
			}
			this.showWizardErrorModal = true;
			this.isButtonDisabled = false;
			return;
				/*
				return new Promise(function(resolve, reject) {
					that.onSubmitPromiseDeferred.resolve = resolve;
					that.onSubmitPromiseDeferred.reject = reject;
					reject();
				});
				*/
			}

			// Don't need to check for conflicts for contravention requests.
			return new Promise(function(resolve, reject) {
				that.onSubmitPromiseDeferred.resolve = resolve;
				that.onSubmitPromiseDeferred.reject = reject;
				that.Save(that.laneClosureRequest);
			});

		},



		onReset(evt) {
			evt.preventDefault()
			// Trick to reset/clear native browser form validation state
			this.show = false
			this.$nextTick(() => {
				this.show = true
			})
		},
		Save(t) {
			this.saving = true;
			this.isButtonDisabled = true;
			if (t instanceof LaneClosureRequest) {
				// if (this.laneClosureRequest) {
				// 	this.onToDateTimeChanged(this.toTime.value);
				// 	this.onFromDateTimeChanged(this.fromTime.value);
				// }
				let go = true;
				if (go) {
					Vue.prototype.$http({
						method: 'post',
						url: `${this.$store.state.apiUrl}/lane-closure-request/with-contravention/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
						data: {
							request: t.getRawValue(),
							contravention: this.contravention.getRawValue()
						}
					}).then(resp => {

						// Handle Success
						this.contravention.id = resp.data.contravention.id;
						this.laneClosureRequest.id = resp.data.request.id;
						this.laneClosureRequest.approvalStatusId.value = resp.data.request.approvalStatusId;
						this.laneClosureRequest.recordStatusId.value = resp.data.request.recordStatusId;
						this.submitted = 1;
						this.saveState = 'success';
						this.submissionStatus = 'submission-success';
						this.SaveSuccess();
						this.onSubmitPromiseDeferred.resolve();
					}).catch(error => {
						this.saveState = 'fail';
						if (error) {
							if (error.response) {
								if (!ErrorHandler.HasLoginErrorCode(error)) {
									// this.laneClosureRequest.SetErrors(error.response.data);
									this.showErrors(error.response.data.fields);
								} else {
									ErrorHandler.RedirectToLogin();
								}
							} else {
								if (ErrorHandler.HasConnectionError(error)) {
									Vue.prototype.$bus.$emit("error:network", {error:error,submitted:null});
								}
							}
						}
						this.onSubmitPromiseDeferred.reject();
					}).finally(() => {
						this.isButtonDisabled = false;
						this.saving = false;
					});
				}
			}
		},
		SaveSuccess() {
			this.laneClosureRequest.saveChanges();
			this.contravention.saveChanges();
			this.submitted = 1;
			this.saveSuccess = 2;
		},

		onStartNewLaneClosureRequest() {
			this.$router.push("/new-lane-closure-request?r=" + Math.round(Math.random() * Math.pow(10, 6)));
		},

		validateFields() {
			this.validateSubmitterStep();
			this.validatePresetClosures();
			this.validateClosuresStep();
			this.validateDCZStep();
			this.validatePermitsStep();
			let lcrValid = this.laneClosureRequest.validate();
			this.workDoneForOrgType.validate();
			let workDoneForTypeValid = this.workDoneForOrgType.valid;

			if (this.hasErrorSubmitter ||
			this.hasErrorClosures ||
			this.hasErrorDCZ ||
			this.hasPresetBlockError ||
			this.hasErrorPermit)
			{
				return false;
			}


			if (lcrValid && workDoneForTypeValid) { //  && restrictValid
				if (this.laneClosureRequest.presetBlock[0]) {
					if (
					this.laneClosureRequest.presetBlock[0].lane.length > 0 ||
					this.laneClosureRequest.presetBlock[0].bicycle.length > 0 ||
					this.laneClosureRequest.presetBlock[0].sidewalk.length > 0 ||
					this.laneClosureRequest.presetBlock[0].restriction.length > 0
					) {
						return true;
				} else {
					return false;
				}

			} else {
				return false;
			}
		}
		return false;
	},


	checkLessThanTwoHours() {
			/*
		if (this.projectTimeDuration != null) {
			if (this.projectTimeDuration <= 0) {
				this.laneClosureRequest.toTime.invalidMessage = 'Estimated completion time cannot be earlier than requested start time';
				this.laneClosureRequest.toTime.status = false;
			} else if (this.projectTimeDuration < 2) {
				if (this.laneClosureRequest.isUnderTwoHours.value === false || this.laneClosureRequest.isUnderTwoHours.value === null) {
					this.lessThanTwoHourModalp1 = 'Estimated completion time is set to within two hours of requested start time.';
					this.lessThanTwoHourModalp2 = 'Do you want to set "Closure take less than 2 hours of total time" to "yes"?';
					this.showLessThanTwoHourModal = true;
				}
			} else {
				if (this.laneClosureRequest.isUnderTwoHours.value === true || this.laneClosureRequest.isUnderTwoHours.value === null) {
					this.lessThanTwoHourModalp1 = 'Estimated completion time is set to beyond two hours of requested start time.';
					this.lessThanTwoHourModalp2 = 'Do you want to set "Closure take less than 2 hours of total time" to "no"?';
					this.showLessThanTwoHourModal = true;
				}
			}
		}
			*/
	},


	presetErrorModalOkClick() {
		this.showPresetErrorModal = false;
	},
	nonRegionalStreetModalOkClick() {
		this.showNonRegionalStreetModal = false;
	},
	timeConflictModalOkClick() {
		this.ignoreTimeConflict = false;
			// TODO: check for conflicting requests again.
			this.laneClosureRequest.fromDate.value = this.conflictingLaneClosureRequest.newFromDate.value;
			this.laneClosureRequest.fromTime.value = this.conflictingLaneClosureRequest.newFromTime.value;
			this.laneClosureRequest.toDate.value = this.conflictingLaneClosureRequest.newToDate.value;
			this.laneClosureRequest.toTime.value = this.conflictingLaneClosureRequest.newToTime.value;

			this.fromDatePickerKey++;
			this.toDatePickerKey++;


			let x = 0;
			let objForm = {
				lcrId: this.laneClosureRequest.id,
				requesterId: this.laneClosureRequest.requesterId,
				isEmergency: this.laneClosureRequest.isEmergency.value,
				fromDate: this.laneClosureRequest.fromDate.getRawValue(),
				toDate: this.laneClosureRequest.toDate.getRawValue(),
				blockId: []
			}
			for (x = 0; x < this.laneClosureRequest.block.length; x++) {
				objForm.blockId.push(this.laneClosureRequest.block[x].blockId);
			}
			this.checkingConflicts = true;
			Vue.prototype.$http.post(this.$store.state.apiUrl + '/lane-closure-request/check-conflicts', objForm)
			.then(resp => {
				this.checkingConflicts = false;
				if(this.laneClosureRequest.requesterId === resp.data.conflicts.requesterId) {
					//When an LCR conflicts with another LCR from the same primary requester, hide the warnings 
					this.showTimeConflictModal = false;
					if (this.saveAfterConflictResolved == true) {
						this.onSubmit();
					}
					return true;
				}
				if (resp.data.conflicts.conflictType == null) {
					this.showTimeConflictModal = false;
					if (this.saveAfterConflictResolved == true) {
						this.onSubmit();
					}
				} else {
					if (this.newFromTime.getRawValue() != this.conflictingLaneClosureRequest.newFromDate.getRawValue() ||
					this.newToTime.getRawValue() != this.conflictingLaneClosureRequest.newToDate.getRawValue() ||
					resp.data.conflicts.conflictType != this.lastConflictType ||
					resp.data.conflicts.conflictType == "duration"
					) {
						this.conflictingLaneClosureRequest = new ConflictingLaneClosureRequest(resp.data.conflicts);
					this.newToTime.value = this.conflictingLaneClosureRequest.newToDate.value;
					this.newFromTime.value = this.conflictingLaneClosureRequest.newFromDate.value;
					this.showTimeConflictModal = true;
					this.lastConflictType = resp.data.conflicts.conflictType;
				}
			}
		})
			.catch(error => {
				this.checkingConflicts = false;

				if (ErrorHandler.HasConnectionError(error)) {
					Vue.prototype.$bus.$emit("error:network", {error:error,submitted:null});
				}
			})

		},


		timeConflictModalIgnoreClick() {
			this.ignoreTimeConflict = true;
			this.showTimeConflictModal = false;
			let x = 0;
			let objForm = {
				lcrId: this.laneClosureRequest.id,
				requesterId: this.laneClosureRequest.requesterId,
				isEmergency: this.laneClosureRequest.isEmergency.value,
				fromDate: this.laneClosureRequest.fromDate.getRawValue(),
				toDate: this.laneClosureRequest.toDate.getRawValue(),
				blockId: []
			}
			for (x = 0; x < this.laneClosureRequest.block.length; x++) {
				objForm.blockId.push(this.laneClosureRequest.block[x].blockId);
			}
			this.checkingConflicts = true;

			Vue.prototype.$http.post(this.$store.state.apiUrl + '/lane-closure-request/check-conflicts', objForm)
			.then(resp => {
				this.checkingConflicts = false;
				if(this.laneClosureRequest.requesterId === resp.data.conflicts.requesterId) {
					//When an LCR conflicts with another LCR from the same primary requester, hide the warnings 
					this.showTimeConflictModal = false;
					let that = this;
					return new Promise(function(resolve, reject) {
						that.onSubmitPromiseDeferred.resolve = resolve;
						that.onSubmitPromiseDeferred.reject = reject;
						if (this.saveAfterConflictResolved == true) {
							that.Save(that.laneClosureRequest);
						}
					});
				}
				if (resp.data.conflicts.conflictType == null) {
					this.showTimeConflictModal = false;
					let that = this;
					return new Promise(function(resolve, reject) {
						that.onSubmitPromiseDeferred.resolve = resolve;
						that.onSubmitPromiseDeferred.reject = reject;
						if (this.saveAfterConflictResolved == true) {
							that.Save(that.laneClosureRequest);
						}
					});
				} else {
					if (resp.data.conflicts.conflictType == "duration") {
						let that = this;
						return new Promise(function(resolve, reject) {
							that.onSubmitPromiseDeferred.resolve = resolve;
							that.onSubmitPromiseDeferred.reject = reject;
							if (this.saveAfterConflictResolved == true) {
								if (that.laneClosureRequest.id) {
									that.Save(that.laneClosureRequest);
								}
							}

						});
					}
				}
			})
			.catch(error => {
				this.checkingConflicts = false;
				if (ErrorHandler.HasConnectionError(error)) {
					Vue.prototype.$bus.$emit("error:network", {error:error,submitted:null});
				}
			})

		},




		lessThanTwoHoursModalOkClick() {
			this.showLessThanTwoHourModal = false;
			/*
			if (this.projectTimeDuration != null) {
				if (this.projectTimeDuration < 2) {
					this.laneClosureRequest.isUnderTwoHours.value = true;
				} else if (this.projectTimeDuration > 2) {
					this.laneClosureRequest.isUnderTwoHours.value = false;
				}
			}
			*/
		},


		startDateInPastModalOkClick() {
			this.hasShownStartDateInPastModal = true;
		},
		deleteAllMarkers() {
			//Loop through all the markers and remove
			for (var i = 0; i < this.markers.length; i++) {
				this.markers[i].setMap(null);
			}
			this.markers = [];
		},
		LoadLaneClosureRequest(id = this.id) {
			this.loaded = false;
			// Remove any messages being displayed.
			this.submissionStatus = null;

			if (id && Format.TryParseInt(id) > 0) {
				this.GetLaneClosureRequest(id);
			} else {
				this.laneClosureRequest = new LaneClosureRequest();
				this.laneClosureRequest.requester = this.$store.getters.userInfo();
				this.laneClosureRequest.requesterId = this.$store.getters.userId();
				this.laneClosureRequest.closureReporter = null;
				this.laneClosureRequest.closureReporterId = null;
				this.laneClosureRequest.restrictionReporter = null;
				this.laneClosureRequest.restrictionReporterId = null;

				// Default values so the officer doesn't have to type them in..
				this.laneClosureRequest.paidParkingAffected.value = 0;
				this.laneClosureRequest.parkingAffected.value = 0;
				this.laneClosureRequest.transitAffected.value = 0;
				this.laneClosureRequest.dczRequired.value = 0;
				this.laneClosureRequest.workZoneKph.value = 60;
				this.laneClosureRequest.parkingRemovalId.value = 2;
				this.laneClosureRequest.workDoneForId.value = 1;
				this.laneClosureRequest.permitRequired.value = 0;
				this.workDoneForOrgId = 1;
				this.laneClosureRequest.projectBidNumber.value = "N/A";


				// TODO: have fields to manually the owner of a new LCR?
				if (this.$route.query.isEmergency) {
					this.laneClosureRequest.isEmergency.value = this.$route.query.isEmergency;
				}


				let theTime = moment.tz(Format.TIMEZONE);
				theTime.seconds(0);
				this.laneClosureRequest.fromDate.value = theTime.format();
				this.laneClosureRequest.fromTime.value = theTime.format();
				this.laneClosureRequest.toDate.value = theTime.format();
				this.fromTime.value = theTime.format();
				this.toTime.value = theTime.add(2, "hours").format();
				this.laneClosureRequest.toDate.value = theTime.format();
				this.laneClosureRequest.toTime.value = theTime.format();

				this.contravention = new Contravention();
				this.contravention.officer = this.$store.getters.userInfo();
				this.contravention.officerId = this.$store.getters.userId();
				this.contravention.typeId.value = 1;

				this.GetOrganizationsForTreeSelect()
				.then(() => {
					this.workDoneForOrgId = this.laneClosureRequest.workDoneForId.value;
					this.setWorkForId(this.laneClosureRequest.workDoneForId.value);
					this.laneClosureRequest.saveChanges();
					this.contravention.saveChanges();
					this.loaded = true;
					let that = this;
					setTimeout(function() {
						that.$store.commit('map/clearNearbyPolylinesAndMarkers', {});
						that.zoomAllBlocks();
					}, 3000);
					this.setupRequiredFields();
				});
			}
		},
		GetOrganizations() {
			this.$store.dispatch('organizationList/loadWorkFor', this.$store.getters['organizationList/getParams'])
			.then(() => {
				this.organizations = [];
				let records = this.$store.getters['organizationList/getRecords'];
				if (records) {
					let found_first_agency = false;
					let found_first_entry = false;
					records.forEach(item => {
						if (found_first_entry == false) {
							found_first_entry = true;
							item.groupName = "City of Winnipeg / Major Utilities";
						}
						if (found_first_agency == false) {
							if (item.organizationTypeId == "agency") {
								found_first_agency = true;
								item.groupName = "Third-Party";
							}
						}
						this.organizations.push(item);
						if (item.id == this.laneClosureRequest.workDoneForId.value) {
							this.laneClosureRequest.workDoneForId.value = item;
						}
					})
				}
			})
			.catch(error => console.log('error', error)); // eslint-disable-line
		},
		GetOrganizationsForTreeSelect() {
			return this.$store.dispatch('organizationList/loadWorkFor', {})
			.then(() => {
				this.organizations = [];
				let result = this.$store.getters['organizationList/getRecords'];


				let refSet = [];
				let cityOrgs = [];
				let thirdPartyOrgs = [];
				let currentLevel = 1;
				let continueLoop = true;

				while (continueLoop) {
					if (currentLevel == 1) {
						let found_first_agency = false;

						result.forEach(x => {
							if (x.level == 1) {
								let o = {
									id: x.id,
									label: x.name,
									organizationTypeId: x.organizationTypeId
								}
								refSet.push(o);

								if (found_first_agency == false) {
									if (x.organizationTypeId == "agency") {
										found_first_agency = true;
										thirdPartyOrgs.push(o);
									} else {
										cityOrgs.push(o);
									}
								} else {
									thirdPartyOrgs.push(o);
								}
							}
						});
					} else {
						let newRef = [];
						result.forEach(x => {
							if (x.level == currentLevel) {
								let org = {
									id: x.id,
									label: x.name,
									parentId: x.parentId,
									organizationTypeId: x.organizationTypeId
								};

								newRef.push(org);
							}
						});

						newRef.forEach(x => {
							refSet.forEach(y => {
								if (x.parentId == y.id) {
									if (y.children == undefined) y.children = [];
									y.children.push(x);
								}
							});
						});

						refSet = newRef;
					}
					currentLevel++;
					if (refSet.length == 0) {
						continueLoop = false;
					}
				}
					// this.organizations = resultSet;
					this.cityOrgs = cityOrgs;
					this.thirdPartyOrgs = thirdPartyOrgs;
					if (this.laneClosureRequest.workDoneForId.value) {
						let o = result.filter(x => x.id == this.laneClosureRequest.workDoneForId.value);
						if (o) {
							if (o.length > 0) {
								if (o && o[0].organizationTypeId == "agency") {
									this.workDoneForOrgType.value = 2;
									this.organizations = thirdPartyOrgs;
								} else if (o) {
									this.workDoneForOrgType.value = 1;
									this.organizations = cityOrgs;
								}
							} else {
								this.workDoneForOrgType.value = 1;
								this.organizations = cityOrgs;
							}
						}
					}
				});
		},

		workDoneForOrgTypeChange(val) {
			this.workDoneForOrgType.resetStatus();
			this.laneClosureRequest.workDoneForId.value = null;
			this.workDoneForOrgId = null;
			if (val == 1) {
				this.organizations = this.cityOrgs;
			} else if (val == 2) {
				this.organizations = this.thirdPartyOrgs;
			}
		},

		// Loads lane closure request into the component based on provided id.
		GetLaneClosureRequest(id) {
			let that = this;
			if (Format.TryParseInt(id)) {
				this.loaded = false;
				this.loadedAll = false;
				Vue.prototype.$http.get(this.$store.state.apiUrl + "/lane-closure-request/" + id + "/edit?r=" + Math.round(Math.random() * Math.pow(10, 6))).then(response => {
					this.laneClosureRequest = new LaneClosureRequest(response.data.request);
					this.downloadToken = response.data.downloadToken;
					this.downloadTokenExpires = response.data.downloadTokenExpires;

					this.laneClosureRequest.id = null;
					this.laneClosureRequest.attachment = [];
					this.laneClosureRequest.message = [];
					this.firstCrossStreetOptions = response.data.crossStreets;

					// this.presetBlockBackup = this.laneClosureRequest.presetBlock[0].getRawValue();

					this.affectedStreetText = { id: this.laneClosureRequest.affectedStreet.value, label: this.laneClosureRequest.affectedStreet.value };
					this.affectedStreetOptions.push({ id: this.laneClosureRequest.affectedStreet.value, label: this.laneClosureRequest.affectedStreet.value });

					if (this.laneClosureRequest.workZoneKph.value == null) {
						this.laneClosureRequest.workZoneKph.value = 60;
					}

					this.$nextTick(() => {
						Vue.prototype.$bus.$emit("map:clear", 1);
						// Vue.prototype.$bus.$emit("map:showMapWhenDesktop");
						if (this.laneClosureRequest.block) {
							let x = 0;
							for (x = 0; x < this.laneClosureRequest.block.length; x++) {
								this.setBlockPolyline(this.laneClosureRequest.block[x]);
							}
							this.zoomAllBlocks();
						}
						this.GetOrganizationsForTreeSelect()
						.then(() => {
							this.workDoneForOrgId = this.laneClosureRequest.workDoneForId.value;
							this.setWorkForId(this.laneClosureRequest.workDoneForId.value);
							that.loaded = true;
							this.setupRequiredFields();
							this.laneClosureRequest.saveChanges();
							this.contravention.saveChanges();
							setTimeout(function() {
								if (that.$refs.lcrWizard) {
									that.$refs.lcrWizard.activateAll();
									if (that.laneClosureRequest.permitRequired.value == 1) {
										that.$refs.lcrWizard.changeTab(3, 0);
										that.$refs.lcrWizard.changeTab(0, 0);
									}
								}
							}, 1000);

							setTimeout(function() {
								that.$store.commit('map/clearNearbyPolylinesAndMarkers', {});
								that.loadedAll = true;
							}, 3000);
						});


					})

				}).catch(error => {
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						if (error.response && error.response.data) {
							if (error.response.data.error.code == "error.laneClosureRequest.notFound") {
								this.loaded = true;
								this.transactionStatus = 'not-found';
								this.errorDetails = error.response.data;
								this.laneClosureRequest = new LaneClosureRequest();
								this.contravention = new Contravention();
								this.laneClosureRequest.saveChanges();
								this.contravention.saveChanges();
							} else {
								this.loaded = false;
								this.transactionStatus = 'load-error';
								this.errorDetails = error.response.data;
							}
						} else {
							this.loaded = false;
							this.transactionStatus = 'load-error';
							this.errorDetails = "Loading Error";
						}
					} else {
						ErrorHandler.RedirectToLogin();
					}
				});
			}

		},


		onCancelBlock: function() {
			this.isEditing = false;
			this.editingIndex = null;
			this.scrollTop();
			// TODO: undo the edits to the block
		},

		showOnMap() {
			Vue.prototype.$bus.$emit("map:toggle");
			this.$nextTick(() => {
				// this.$store.dispatch("map/zoomToLaneClosureRequestId", this.laneClosureRequest.id);
				this.zoomAllBlocks();
			});
		},

		showBusMap() {
			Vue.prototype.$bus.$emit("map:toggle");
			this.$nextTick(() => {
				// this.$store.dispatch("map/zoomToLaneClosureRequestId", this.laneClosureRequest.id);
				//  https://www.google.com/maps/d/viewer?mid=1wlJylCiyaI0os59pmIMmA15xPlgaDRTJ&ll=49.7772903%2C-97.23214519999999&z=18

				this.zoomAllBlocks();
			});
		},

		onOfficerSearch(input) {
			return new Promise((resolve, reject) => {
				if (input.length < 1) {
					return resolve([])
				}
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/officers?q=' + encodeURI(input))
				.then(resp => {
					resolve(resp.data)
				})
				.catch(error => {
					reject(error)
				})
			})
		},
		// Addeds a transaction line with contact attached.
		onOfficerSelect(selected) {
			this.contravention.officerId = parseInt(selected.userId);
			this.contravention.officer = selected;
			this.$refs.searchOfficer.value = "";
		},

		isActiveTab(index) {
			if (this.$refs.lcrWizard.activeTabIndex == index) {
				return true;
			}
			return false;
		},

		changeTab(index) {
			this.$refs.lcrWizard.changeTab(this.$refs.lcrWizard.activeTabIndex, index, false);
			this.scrollTopOfWizard();
		},
		changeToShowMap() {
			this.currentBlockOnMap = null;
			this.hideMap = false;
		},
		changeToHideMap() {
			this.hideMap = true;
		},
		showBlockOnMap(data) {
			let id;
			if (data instanceof Object) {
				id = data.id;
			} else {
				id = data;
			}

			if (this.currentBlockOnMap && this.currentBlockOnMap instanceof Object) {
				if (this.currentBlockOnMap.id == data.id && this.currentBlockOnMap.type == data.type && this.currentBlockOnMap.laneId == data.laneId) {
					Vue.prototype.$bus.$emit("map:toggle", 0);
					this.currentBlockOnMap = null;
					return;
				}
			}
			this.currentBlockOnMap = data;
			Vue.prototype.$bus.$emit("map:toggle", 1);
			this.$nextTick(() => {
				this.$store.dispatch("map/zoomToBlockId", id);
				for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
					if (this.laneClosureRequest.block[x].blockId == id) {
						// this.zoomToBlock(x);
						// this.setPolylineColours(x);
						this.$store.dispatch("map/zoomToBlockIdPopup", id);

						break;
					}
				}
			});
		},

		getCanEdit(id) {
			Vue.prototype.$http.get(this.$store.state.apiUrl + "/lane-closure-request/" + id + "/canedit?r=" + Math.round(Math.random() * Math.pow(10, 6)))
			.then(res => {
				this.canEdit = res.data.canEdit;
			});
		},

		getOrganizationTreeList(user) {
			if (user.organizationTree) {
				let treeString = user.organizationTree;
				let treeList = treeString.split("|");
				treeList.pop();
				treeList.shift();
				treeList.reverse();
				return treeList;
			} else {
				return new Array(user.organizationName);
			}
		},

		onAltRestrictionReporterKeydown(event) {
			const { key } = event;
			if (key == "Tab") {
				if (this.$refs.searchAltRestrictionReporter.value)
				this.onAltRestrictionReporterSelect(this.$refs.searchAltRestrictionReporter.value);
		}
	},
	onRestrictionReporterKeydown(event) {
		const { key } = event;
		if (key == "Tab") {
			if (this.$refs.searchRestrictionReporter.value)
			this.onRestrictionReporterSelect(this.$refs.searchRestrictionReporter.value);
	}
},
onAltClosureReporterKeydown(event) {
	const { key } = event;
	if (key == "Tab") {
		if (this.$refs.searchAltClosureReporter.value)
		this.onAltClosureReporterSelect(this.$refs.searchAltClosureReporter.value);
}
},
onClosureReporterKeydown(event) {
	const { key } = event;
	if (key == "Tab") {
		if (this.$refs.searchClosureReporter.value)
		this.onClosureReporterSelect(this.$refs.searchClosureReporter.value);
}
},
onAltRequesterKeydown(event) {
	const { key } = event;
	if (key == "Tab") {
		if (this.$refs.searchAltRequester.value)
		this.onAltRequesterSelect(this.$refs.searchAltRequester.value);
}
},
onRequesterKeydown(event) {
	const { key } = event;
	if (key == "Tab") {
		if (this.$refs.searchRequester.value)
		this.onRequesterSelect(this.$refs.searchRequester.value);
}
},

		// For LCR Review
		onToggleExpandCustomizeTrafficSingalsAltered(value) {
			this.expandTrafficSignalsAltered = !!value.expand;
			this.forceRerender();
		},
		onToggleExpandDCZ() {
			this.expandDCZ = !this.expandDCZ;
			this.forceRerender();
		},
		onToggleExpandTransit() {
			this.expandTransit = !this.expandTransit;
			this.forceRerender();
		},
		onToggleExpandParking() {
			this.expandParking = !this.expandParking;
			this.forceRerender();
		},
		onToggleExpandPermit() {
			this.expandPermit = !this.expandPermit;
			this.forceRerender();
		},

		getYesNoText(val) {
			if (val !== null) {
				return Format.searchById(val, LaneClosureRequest.getYesNoOptions).name;
			}
			return null;
		},
		getDczRequiredText(dcz) {
			if (dcz) {
				return Format.searchById(dcz, LaneClosureRequest.getYesNoOptions).name;
			}
			return "N/A";
		},
		getWorkDoneForText(path) {
			if (path) {
				return Format.pipesToFlatTree(path.toUpperCase());
			}
			return null;
		},
		getBidAdmin() {
			if (this.laneClosureRequest.bidAdmin.value != null && this.laneClosureRequest.bidAdmin.value != "") {
				return this.laneClosureRequest.bidAdmin.value;
			} else {
				return "N/A";
			}
		},
		getParkingRemovalText(parkingRemovalId) {
			if (parkingRemovalId !== null) {
				return Format.searchById(parkingRemovalId, LaneClosureRequest.getViewParkingRemoveOptions).name;
			}
			return null;
		},
		getParkingLaneRemovedText(laneId) {
			if (laneId) {
				return Format.searchById(laneId, LaneClosureRequest.getParkingLaneOptions).name;
			}
			return null;
		},
		getParkingLaneRemovalOptions() {
			return [
				{
					value: 1,
					text: 'Eastbound curb lane (or right side curb for a one-way)'
				},
				{
					value: 4,
					text: 'Westbound curb lane (or right side curb for a one-way)'
				},
				{
					value: 7,
					text: 'Northbound curb lane (or right side curb for a one-way)'
				},
				{
					value: 10,
					text: 'Southbound curb lane (or right side curb for a one-way)'
				},
				{
					value: 3,
					text: 'Eastbound median lane (or left side curb for a one-way)'
				},
				{
					value: 6,
					text: 'Westbound median lane (or left side curb for a one-way)'
				},
				{
					value: 9,
					text: 'Northbound median lane (or left side curb for a one-way)'
				},
				{
					value: 12,
					text: 'Southbound median lane (or left side curb for a one-way)'
				}
			];
		},
		onSubmitNewParkingRemoval(newLaneData) {
			this.hasParkingRemovalError = false;
			this.laneClosureRequest.parkingRemoval.push(new LaneClosureRequestParkingRemoval({ ...newLaneData })); // Push a copy of newLaneData
		},
		onShowModalForParkingRemoval() {
			// Show the modal for adding parking removal lane
			this.laneInfoToEditParkingRemoval = new LaneClosureRequestParkingRemoval();
			this.isEditingParkingRemoval = false;
			this.laneIndexToEditParkingRemoval = 0;
			this.$refs.lcrParkingRemovalModalRef.openModal();
		}, 
		onRemoveLaneFromParkingRemoval(index) {
			this.laneClosureRequest.parkingRemoval.splice(index, 1);
		},
		onEditLaneFromParkingRemoval(laneIndexToEdit, laneInfoToEdit){
			// Show the modal for editing parking removal lane
			let laneDataToEdit = { 
				parkingLaneId: laneInfoToEdit.parkingLaneId.value,
				parkingRemovalMetres: parseFloat(laneInfoToEdit.parkingRemovalMetres.value),
				parkingStartAddress: laneInfoToEdit.parkingStartAddress.value,
				parkingEndAddress: laneInfoToEdit.parkingEndAddress.value,
			};
			this.laneInfoToEditParkingRemoval = new LaneClosureRequestParkingRemoval({ ...laneDataToEdit });
			this.isEditingParkingRemoval = true;
			this.laneIndexToEditParkingRemoval = laneIndexToEdit;
			this.$refs.lcrParkingRemovalModalRef.openModal();
		},
		onUpdateParkingRemoval(laneIndexToEditParkingRemoval, updatedLaneData) {
			this.hasParkingRemovalError = false;
			if (laneIndexToEditParkingRemoval >= 0 && laneIndexToEditParkingRemoval < this.laneClosureRequest.parkingRemoval.length) {
				// Update the array item at the specified index
				this.$set(
					this.laneClosureRequest.parkingRemoval,
					laneIndexToEditParkingRemoval,
					new LaneClosureRequestParkingRemoval({ ...updatedLaneData })
				);
			}
		},

		emailHref(value) {
			return "mailto:" + value;
		},
	},
	beforeRouteEnter(to, from, next) {
		if (store.getters.userHasRole('internal_admin_requests') || store.getters.userHasRole('system_admin') || store.getters.userHasRole('internal_admin_reports') ||
		store.getters.userHasRole('officer_requests') || store.getters.userHasRole('officer_reports')
		) {
			next(vm => {
				Vue.prototype.$bus.$emit("map:clear", 1);
				// Vue.prototype.$bus.$emit("map:showMapWhenDesktop");
			});
	} else {
		next('/contraventions');
	}
},
beforeRouteLeave(to, from, next) {
	if (this.loaded && (this.laneClosureRequest.hasChanges() ||  this.contravention.hasChanges())) {
		if (this.overrideUnsavedChanges) {
			Vue.prototype.$bus.$emit("map:clear", 1);
			this.setEventBusOff();
			next(true);
		} else {
			this.showUnsavedChangesModal = true;
			this.modalOnSave = (function() {
				this.onSubmit().then(() => {
					this.showUnsavedChangesModal = false;
					Vue.prototype.$bus.$emit("map:clear", 1);
					this.setEventBusOff();
					next(true);
				}).catch(() => {
					next(false);
				});
			}).bind(this);

			this.modalOnLeave = (function() {
				this.showUnsavedChangesModal = false;
				Vue.prototype.$bus.$emit("map:clear", 1);
				this.setEventBusOff();
				next(true);
			}).bind(this);

			next(false);
		}
	} else {
		Vue.prototype.$bus.$emit("map:clear", 1);
		this.setEventBusOff();
		next(true);
	}
},
}
</script>